webpackJsonp([1],{

/***/ "/626":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/IWP":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateGeofence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shapeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shape"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateGeofenceInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateGeofence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shapeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"geofence"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shape"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"geometry"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vehicles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plate"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":204}};
    doc.loc.source = {"body":"mutation UpdateGeofence ($shapeId: ID!, $shape: UpdateGeofenceInput!) {\n  updateGeofence (_id: $shapeId, geofence: $shape) {\n    _id\n    geometry\n    name\n    vehicles {\n      _id\n      plate\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["UpdateGeofence"] = oneQuery(doc, "UpdateGeofence");
        


/***/ }),

/***/ "00uD":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PaginatedEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vehicleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"finishDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rowsPerPage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchPaginatedEventsByVehicleAndDate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"vehicleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vehicleId"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"finishDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"finishDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"rowsPerPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rowsPerPage"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gps"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"latitude"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"speed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"azimuth"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardinalDirection"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"altitude"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reverseGeocoding"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"engineState"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":498}};
    doc.loc.source = {"body":"query PaginatedEvents ($vehicleId: ID!, $startDate: Date!, $finishDate: Date!, $page: Int!, $rowsPerPage: Int!) {\n  fetchPaginatedEventsByVehicleAndDate (vehicleId: $vehicleId, startDate: $startDate, finishDate: $finishDate, page: $page, rowsPerPage: $rowsPerPage) {\n    _id\n    name\n    data {\n      gps {\n        latitude\n        latitude\n        speed\n        azimuth {\n          cardinalDirection\n        }\n        altitude\n        date\n      }\n    }\n    reverseGeocoding\n    engineState\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["PaginatedEvents"] = oneQuery(doc, "PaginatedEvents");
        


/***/ }),

/***/ "0S1D":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Routes"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchRoutes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"geometry"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vehicles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plate"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":110}};
    doc.loc.source = {"body":"query Routes {\n  fetchRoutes {\n    _id\n    geometry\n    name\n    vehicles {\n      _id\n      plate\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["Routes"] = oneQuery(doc, "Routes");
        


/***/ }),

/***/ "0T0o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2WXF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3R/k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3TcT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4AK/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4IYN":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchVehicles"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchVehicles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plate"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":64}};
    doc.loc.source = {"body":"query FetchVehicles {\n  fetchVehicles {\n    _id\n    plate\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["FetchVehicles"] = oneQuery(doc, "FetchVehicles");
        


/***/ }),

/***/ "4Wrh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5PLJ":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateGuest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"guest"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateGuestInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateGuest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"guest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"guest"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vehicles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plate"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"username"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":200}};
    doc.loc.source = {"body":"mutation UpdateGuest ($_id: ID!, $guest: UpdateGuestInput!) {\n  updateGuest (_id: $_id, guest: $guest) {\n    _id\n    vehicles {\n      _id\n      plate\n    }\n    name\n    username\n    permissions\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["UpdateGuest"] = oneQuery(doc, "UpdateGuest");
        


/***/ }),

/***/ "5t8j":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Client"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchClient"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"active"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":100}};
    doc.loc.source = {"body":"query Client {\n  fetchClient {\n    _id\n    name\n    emails {\n      address\n      active\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["Client"] = oneQuery(doc, "Client");
        


/***/ }),

/***/ "6DHi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6STh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6SVg":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveGuest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeGuest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vehicles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plate"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"username"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":158}};
    doc.loc.source = {"body":"mutation RemoveGuest ($_id: ID!) {\n  removeGuest (_id: $_id) {\n    _id\n    vehicles {\n      _id\n      plate\n    }\n    name\n    username\n    permissions\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["RemoveGuest"] = oneQuery(doc, "RemoveGuest");
        


/***/ }),

/***/ "6a2R":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Vehicles"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchVehicles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastEvent"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gps"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"longitude"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":165}};
    doc.loc.source = {"body":"query Vehicles {\n  fetchVehicles {\n    _id\n    plate\n    lastEvent {\n      data {\n        gps {\n          latitude\n          longitude\n        }\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["Vehicles"] = oneQuery(doc, "Vehicles");
        


/***/ }),

/***/ "6gsQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6nfk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8eH3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "90VL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "93EI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9DHQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9v9n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A+FS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ATJn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Abih":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BCfr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BZUx":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateGuest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"guest"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateGuestInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createGuest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"guest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"guest"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vehicles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plate"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"username"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":178}};
    doc.loc.source = {"body":"mutation CreateGuest ($guest: CreateGuestInput!) {\n  createGuest (guest: $guest) {\n    _id\n    vehicles {\n      _id\n      plate\n    }\n    name\n    username\n    permissions\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["CreateGuest"] = oneQuery(doc, "CreateGuest");
        


/***/ }),

/***/ "BzrI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cq6c":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateClientPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"client"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateClientPasswordInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateClientPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"client"},"value":{"kind":"Variable","name":{"kind":"Name","value":"client"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":127}};
    doc.loc.source = {"body":"mutation UpdateClientPassword ($client: UpdateClientPasswordInput!) {\n  updateClientPassword (client: $client) {\n    _id\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["UpdateClientPassword"] = oneQuery(doc, "UpdateClientPassword");
        


/***/ }),

/***/ "Dilr":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchPermissions"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchPermissions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"displayName"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":77}};
    doc.loc.source = {"body":"query FetchPermissions {\n  fetchPermissions {\n    name\n    displayName\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["FetchPermissions"] = oneQuery(doc, "FetchPermissions");
        


/***/ }),

/***/ "DkdU":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Vehicles"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchVehicles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastEvent"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gps"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"longitude"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":165}};
    doc.loc.source = {"body":"query Vehicles {\n  fetchVehicles {\n    _id\n    plate\n    lastEvent {\n      data {\n        gps {\n          latitude\n          longitude\n        }\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["Vehicles"] = oneQuery(doc, "Vehicles");
        


/***/ }),

/***/ "ESOj":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateRoute"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shape"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateRouteInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRoute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"route"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shape"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"geometry"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vehicles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plate"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":162}};
    doc.loc.source = {"body":"mutation CreateRoute ($shape: CreateRouteInput!) {\n  createRoute (route: $shape) {\n    _id\n    geometry\n    name\n    vehicles {\n      _id\n      plate\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["CreateRoute"] = oneQuery(doc, "CreateRoute");
        


/***/ }),

/***/ "EimW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FHHX":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchVehicleLastEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vehicleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchVehicleById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vehicleId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastEvent"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gps"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"highPriority"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":215}};
    doc.loc.source = {"body":"query FetchVehicleLastEvent ($vehicleId: ID!) {\n  fetchVehicleById (_id: $vehicleId) {\n    lastEvent {\n      _id\n      data {\n        gps {\n          date\n        }\n      }\n      name\n      highPriority\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["FetchVehicleLastEvent"] = oneQuery(doc, "FetchVehicleLastEvent");
        


/***/ }),

/***/ "FbEL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fl5w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Gply":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchEventById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reverseGeocoding"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"engineState"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vehicle"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plate"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gps"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fixed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"satellites"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"latitude"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"longitude"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"speed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"azimuth"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grades"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cardinalDirection"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"altitude"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hdop"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vdop"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"gsm"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registration"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"signal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"codeCountry"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"codeNetwork"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"baseStationCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"baseStationIdentifier"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"strengthSignal"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"adc"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voltagePowerExternal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"voltageBateryBackup"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"dtt"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"IOStatus"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outputOne"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"io"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"outputTwo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"io"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"outputThree"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"io"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"inputOne"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"io"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"inputTwo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"io"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":1196}};
    doc.loc.source = {"body":"query FetchEvent ($eventId: ID!) {\n  fetchEventById (_id: $eventId) {\n    _id\n    name\n    reverseGeocoding\n    engineState\n    vehicle {\n      plate\n    }\n    data {\n      gps {\n        fixed\n        satellites\n        latitude\n        longitude\n        speed\n        azimuth {\n          grades\n          cardinalDirection\n        }\n        altitude\n        hdop\n        vdop\n        date\n      }\n      gsm {\n        registration {\n          code\n          status\n          message\n        }\n        signal\n        codeCountry\n        codeNetwork\n        baseStationCode\n        baseStationIdentifier\n        strengthSignal\n      }\n      adc {\n        voltagePowerExternal\n        voltageBateryBackup\n      }\n      dtt {\n        IOStatus {\n          outputOne {\n            name\n            status\n            io\n          }\n          outputTwo {\n            name\n            status\n            io\n          }\n          outputThree {\n            name\n            status\n            io\n          }\n          inputOne {\n            name\n            status\n            io\n          }\n          inputTwo {\n            name\n            status\n            io\n          }\n        }\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["FetchEvent"] = oneQuery(doc, "FetchEvent");
        


/***/ }),

/***/ "HB6Q":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateClientEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createClientEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"active"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":154}};
    doc.loc.source = {"body":"mutation CreateClientEmail ($email: String!) {\n  createClientEmail (email: $email) {\n    _id\n    name\n    emails {\n      address\n      active\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["CreateClientEmail"] = oneQuery(doc, "CreateClientEmail");
        


/***/ }),

/***/ "HNa/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcKj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IkIV":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ActivateEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activateEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":92}};
    doc.loc.source = {"body":"mutation ActivateEmail ($token: String!) {\n  activateEmail (token: $token) {\n    name\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["ActivateEmail"] = oneQuery(doc, "ActivateEmail");
        


/***/ }),

/***/ "J3Zt":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRoute"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shapeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shape"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateRouteInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRoute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shapeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"route"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shape"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"geometry"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vehicles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plate"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":192}};
    doc.loc.source = {"body":"mutation UpdateRoute ($shapeId: ID!, $shape: UpdateRouteInput!) {\n  updateRoute (_id: $shapeId, route: $shape) {\n    _id\n    geometry\n    name\n    vehicles {\n      _id\n      plate\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["UpdateRoute"] = oneQuery(doc, "UpdateRoute");
        


/***/ }),

/***/ "JLzs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JN0E":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveClientEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeClientEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"active"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":154}};
    doc.loc.source = {"body":"mutation RemoveClientEmail ($email: String!) {\n  removeClientEmail (email: $email) {\n    _id\n    name\n    emails {\n      address\n      active\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["RemoveClientEmail"] = oneQuery(doc, "RemoveClientEmail");
        


/***/ }),

/***/ "JicR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tuple", function() { return tuple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lookup", function() { return lookup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lookupArray", function() { return lookupArray; });
// Although `Symbol` is widely supported these days, we can safely fall
// back to using a non-enumerable string property without violating any
// assumptions elsewhere in the implementation.
var useSymbol =
  typeof Symbol === "function" &&
  typeof Symbol.for === "function";

// Used to mark `tuple.prototype` so that all objects that inherit from
// any `tuple.prototype` object (there could be more than one) will test
// positive according to `tuple.isTuple`.
var brand = useSymbol
  ? Symbol.for("immutable-tuple")
  : "@@__IMMUTABLE_TUPLE__@@";

// Used to save a reference to the globally shared `UniversalWeakMap` that
// stores all known `tuple` objects.
var globalKey = useSymbol
  ? Symbol.for("immutable-tuple-root")
  : "@@__IMMUTABLE_TUPLE_ROOT__@@";

// Convenient helper for defining hidden immutable properties.
function def(obj, name, value, enumerable) {
  Object.defineProperty(obj, name, {
    value: value,
    enumerable: !! enumerable,
    writable: false,
    configurable: false
  });
  return value;
}

var freeze = Object.freeze || function (obj) {
  return obj;
};

function isObjRef(value) {
  switch (typeof value) {
  case "object":
    if (value === null) {
      return false;
    }
  case "function":
    return true;
  default:
    return false;
  }
}

// The `mustConvertThisToArray` value is true when the corresponding
// `Array` method does not attempt to modify `this`, which means we can
// pass a `tuple` object as `this` without first converting it to an
// `Array`.
function forEachArrayMethod(fn) {
  function call(name, mustConvertThisToArray) {
    var desc = Object.getOwnPropertyDescriptor(Array.prototype, name);
    fn(name, desc, !! mustConvertThisToArray);
  }

  call("every");
  call("filter");
  call("find");
  call("findIndex");
  call("forEach");
  call("includes");
  call("indexOf");
  call("join");
  call("lastIndexOf");
  call("map");
  call("reduce");
  call("reduceRight");
  call("slice");
  call("some");
  call("toLocaleString");
  call("toString");

  // The `reverse` and `sort` methods are usually destructive, but for
  // `tuple` objects they return a new `tuple` object that has been
  // appropriately reversed/sorted.
  call("reverse", true);
  call("sort", true);

  // Make `[...someTuple]` work.
  call(useSymbol && Symbol.iterator || "@@iterator");
}

// A map data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var UniversalWeakMap = function UniversalWeakMap() {
  // Since a `WeakMap` cannot hold primitive values as keys, we need a
  // backup `Map` instance to hold primitive keys. Both `this._weakMap`
  // and `this._strongMap` are lazily initialized.
  this._weakMap = null;
  this._strongMap = null;
  this.data = null;
};

// Since `get` and `set` are the only methods used, that's all I've
// implemented here.

UniversalWeakMap.prototype.get = function get (key) {
  var map = this._getMap(key, false);
  if (map) {
    return map.get(key);
  }
};

UniversalWeakMap.prototype.set = function set (key, value) {
  this._getMap(key, true).set(key, value);
  // An actual `Map` or `WeakMap` would return `this` here, but
  // returning the `value` is more convenient for the `tuple`
  // implementation.
  return value;
};

UniversalWeakMap.prototype._getMap = function _getMap (key, canCreate) {
  if (! canCreate) {
    return isObjRef(key) ? this._weakMap : this._strongMap;
  }
  if (isObjRef(key)) {
    return this._weakMap || (this._weakMap = new WeakMap);
  }
  return this._strongMap || (this._strongMap = new Map);
};

// See [`universal-weak-map.js`](universal-weak-map.html).
// See [`util.js`](util.html).
// If this package is installed multiple times, there could be mutiple
// implementations of the `tuple` function with distinct `tuple.prototype`
// objects, but the shared pool of `tuple` objects must be the same across
// all implementations. While it would be ideal to use the `global`
// object, there's no reliable way to get the global object across all JS
// environments without using the `Function` constructor, so instead we
// use the global `Array` constructor as a shared namespace.
var root = Array[globalKey] || def(Array, globalKey, new UniversalWeakMap, false);

function lookup() {
  return lookupArray(arguments);
}

function lookupArray(array) {
  var node = root;

  // Because we are building a tree of *weak* maps, the tree will not
  // prevent objects in tuples from being garbage collected, since the
  // tree itself will be pruned over time when the corresponding `tuple`
  // objects become unreachable. In addition to internalization, this
  // property is a key advantage of the `immutable-tuple` package.
  var len = array.length;
  for (var i = 0; i < len; ++i) {
    var item = array[i];
    node = node.get(item) || node.set(item, new UniversalWeakMap);
  }

  // Return node.data rather than node itself to prevent tampering with
  // the UniversalWeakMap tree.
  return node.data || (node.data = Object.create(null));
}

// See [`lookup.js`](lookup.html).
// See [`util.js`](util.html).
// When called with any number of arguments, this function returns an
// object that inherits from `tuple.prototype` and is guaranteed to be
// `===` any other `tuple` object that has exactly the same items. In
// computer science jargon, `tuple` instances are "internalized" or just
// "interned," which allows for constant-time equality checking, and makes
// it possible for tuple objects to be used as `Map` or `WeakMap` keys, or
// stored in a `Set`.
function tuple() {
  var arguments$1 = arguments;

  var node = lookup.apply(null, arguments);

  if (node.tuple) {
    return node.tuple;
  }

  var t = Object.create(tuple.prototype);

  // Define immutable items with numeric indexes, and permanently fix the
  // `.length` property.
  var argc = arguments.length;
  for (var i = 0; i < argc; ++i) {
    t[i] = arguments$1[i];
  }

  def(t, "length", argc, false);

  // Remember this new `tuple` object so that we can return the same object
  // earlier next time.
  return freeze(node.tuple = t);
}

// Since the `immutable-tuple` package could be installed multiple times
// in an application, there is no guarantee that the `tuple` constructor
// or `tuple.prototype` will be unique, so `value instanceof tuple` is
// unreliable. Instead, to test if a value is a tuple, you should use
// `tuple.isTuple(value)`.
def(tuple.prototype, brand, true, false);
function isTuple(that) {
  return !! (that && that[brand] === true);
}

tuple.isTuple = isTuple;

function toArray(tuple) {
  var array = [];
  var i = tuple.length;
  while (i--) { array[i] = tuple[i]; }
  return array;
}

// Copy all generic non-destructive Array methods to `tuple.prototype`.
// This works because (for example) `Array.prototype.slice` can be invoked
// against any `Array`-like object.
forEachArrayMethod(function (name, desc, mustConvertThisToArray) {
  var method = desc && desc.value;
  if (typeof method === "function") {
    desc.value = function () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var result = method.apply(
        mustConvertThisToArray ? toArray(this) : this,
        args
      );
      // Of course, `tuple.prototype.slice` should return a `tuple` object,
      // not a new `Array`.
      return Array.isArray(result) ? tuple.apply(void 0, result) : result;
    };
    Object.defineProperty(tuple.prototype, name, desc);
  }
});

// Like `Array.prototype.concat`, except for the extra effort required to
// convert any tuple arguments to arrays, so that
// ```
// tuple(1).concat(tuple(2), 3) === tuple(1, 2, 3)
// ```
var ref = Array.prototype;
var concat = ref.concat;
tuple.prototype.concat = function () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return tuple.apply(void 0, concat.apply(toArray(this), args.map(
    function (item) { return isTuple(item) ? toArray(item) : item; }
  )));
};

/* harmony default export */ __webpack_exports__["default"] = (tuple);



/***/ }),

/***/ "MtuX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N+IJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/Vuetify/index.js
var Vuetify = __webpack_require__("M+UZ");
var Vuetify_default = /*#__PURE__*/__webpack_require__.n(Vuetify);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/VApp/index.js
var VApp = __webpack_require__("IcMm");
var VApp_default = /*#__PURE__*/__webpack_require__.n(VApp);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/VResponsive/index.js
var VResponsive = __webpack_require__("6zvj");
var VResponsive_default = /*#__PURE__*/__webpack_require__.n(VResponsive);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/VNavigationDrawer/index.js
var VNavigationDrawer = __webpack_require__("rPQa");
var VNavigationDrawer_default = /*#__PURE__*/__webpack_require__.n(VNavigationDrawer);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/VGrid/index.js
var VGrid = __webpack_require__("JUsQ");
var VGrid_default = /*#__PURE__*/__webpack_require__.n(VGrid);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/VToolbar/index.js
var VToolbar = __webpack_require__("+9ps");
var VToolbar_default = /*#__PURE__*/__webpack_require__.n(VToolbar);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/VCard/index.js
var VCard = __webpack_require__("f/u0");
var VCard_default = /*#__PURE__*/__webpack_require__.n(VCard);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/VMenu/index.js
var VMenu = __webpack_require__("DBae");
var VMenu_default = /*#__PURE__*/__webpack_require__.n(VMenu);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/VFooter/index.js
var VFooter = __webpack_require__("TWha");
var VFooter_default = /*#__PURE__*/__webpack_require__.n(VFooter);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/VList/index.js
var VList = __webpack_require__("fYhH");
var VList_default = /*#__PURE__*/__webpack_require__.n(VList);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/VBtn/index.js
var VBtn = __webpack_require__("7Q1V");
var VBtn_default = /*#__PURE__*/__webpack_require__.n(VBtn);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/VIcon/index.js
var VIcon = __webpack_require__("7M7f");
var VIcon_default = /*#__PURE__*/__webpack_require__.n(VIcon);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/VDivider/index.js
var VDivider = __webpack_require__("XRgG");
var VDivider_default = /*#__PURE__*/__webpack_require__.n(VDivider);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/VAutocomplete/index.js
var VAutocomplete = __webpack_require__("ZZrt");
var VAutocomplete_default = /*#__PURE__*/__webpack_require__.n(VAutocomplete);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/VDialog/index.js
var VDialog = __webpack_require__("MPXs");
var VDialog_default = /*#__PURE__*/__webpack_require__.n(VDialog);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/VSnackbar/index.js
var VSnackbar = __webpack_require__("UxJg");
var VSnackbar_default = /*#__PURE__*/__webpack_require__.n(VSnackbar);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/VSubheader/index.js
var VSubheader = __webpack_require__("7gKz");
var VSubheader_default = /*#__PURE__*/__webpack_require__.n(VSubheader);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/VAvatar/index.js
var VAvatar = __webpack_require__("RWpw");
var VAvatar_default = /*#__PURE__*/__webpack_require__.n(VAvatar);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/VProgressCircular/index.js
var VProgressCircular = __webpack_require__("QLUw");
var VProgressCircular_default = /*#__PURE__*/__webpack_require__.n(VProgressCircular);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/VProgressLinear/index.js
var VProgressLinear = __webpack_require__("pqui");
var VProgressLinear_default = /*#__PURE__*/__webpack_require__.n(VProgressLinear);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/VForm/index.js
var VForm = __webpack_require__("DDBM");
var VForm_default = /*#__PURE__*/__webpack_require__.n(VForm);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/VTextField/index.js
var VTextField = __webpack_require__("/yi5");
var VTextField_default = /*#__PURE__*/__webpack_require__.n(VTextField);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/VChip/index.js
var VChip = __webpack_require__("t9Tm");
var VChip_default = /*#__PURE__*/__webpack_require__.n(VChip);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/VPagination/index.js
var VPagination = __webpack_require__("8Vjh");
var VPagination_default = /*#__PURE__*/__webpack_require__.n(VPagination);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/VSwitch/index.js
var VSwitch = __webpack_require__("8QWG");
var VSwitch_default = /*#__PURE__*/__webpack_require__.n(VSwitch);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/VAlert/index.js
var VAlert = __webpack_require__("BOXn");
var VAlert_default = /*#__PURE__*/__webpack_require__.n(VAlert);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/VBadge/index.js
var VBadge = __webpack_require__("VdfK");
var VBadge_default = /*#__PURE__*/__webpack_require__.n(VBadge);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/VDataTable/index.js
var VDataTable = __webpack_require__("LmeB");
var VDataTable_default = /*#__PURE__*/__webpack_require__.n(VDataTable);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/VDatePicker/index.js
var VDatePicker = __webpack_require__("IzLz");
var VDatePicker_default = /*#__PURE__*/__webpack_require__.n(VDatePicker);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/VTimePicker/index.js
var VTimePicker = __webpack_require__("Wj7w");
var VTimePicker_default = /*#__PURE__*/__webpack_require__.n(VTimePicker);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/VTooltip/index.js
var VTooltip = __webpack_require__("CYy8");
var VTooltip_default = /*#__PURE__*/__webpack_require__.n(VTooltip);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/VExpansionPanel/index.js
var VExpansionPanel = __webpack_require__("tCug");
var VExpansionPanel_default = /*#__PURE__*/__webpack_require__.n(VExpansionPanel);

// EXTERNAL MODULE: ./node_modules/vuetify/es5/components/transitions/index.js
var transitions = __webpack_require__("6VHA");
var transitions_default = /*#__PURE__*/__webpack_require__.n(transitions);

// EXTERNAL MODULE: ./node_modules/vuetify/src/stylus/app.styl
var app = __webpack_require__("s6ZO");
var app_default = /*#__PURE__*/__webpack_require__.n(app);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de15c76a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"light":""}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/api/auth.js



var auth__this = this;


var AUTH_URL = "http://api.web.rastreosigloxxi.io:3005/auth";
var auth_client = axios_default.a.create({
  baseURL: AUTH_URL
});

var auth_signIn = function () {
  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref2) {
    var username = _ref2.username,
        password = _ref2.password;
    var path, authenticatedClient, response, message;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            path = '/sign-in';
            authenticatedClient = void 0;
            _context.prev = 2;
            _context.next = 5;
            return auth_client.post(path, {
              username: username,
              password: password
            });

          case 5:
            response = _context.sent;

            authenticatedClient = response.data;
            _context.next = 13;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context['catch'](2);
            message = _context.t0.response ? _context.t0.response.data : 'Ooops, ha ocurrido un error :c';
            throw new Error(message);

          case 13:
            return _context.abrupt('return', authenticatedClient);

          case 14:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, auth__this, [[2, 9]]);
  }));

  return function signIn(_x) {
    return _ref.apply(this, arguments);
  };
}();

var validateToken = function () {
  var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(token) {
    var path, isValid, response;
    return regenerator_default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            path = '/validate-token/' + token;
            isValid = void 0;
            _context2.prev = 2;
            _context2.next = 5;
            return auth_client.get(path);

          case 5:
            response = _context2.sent;

            isValid = response.data.isValid;
            _context2.next = 13;
            break;

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2['catch'](2);

            console.error(_context2.t0);
            isValid = false;

          case 13:
            return _context2.abrupt('return', isValid);

          case 14:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, auth__this, [[2, 9]]);
  }));

  return function validateToken(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

var forgotPassword = function () {
  var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(_ref5) {
    var email = _ref5.email;
    var path, message;
    return regenerator_default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            path = '/forgot-password';
            _context3.prev = 1;
            _context3.next = 4;
            return auth_client.post(path, { email: email });

          case 4:
            _context3.next = 10;
            break;

          case 6:
            _context3.prev = 6;
            _context3.t0 = _context3['catch'](1);
            message = _context3.t0.response ? _context3.t0.response.data : 'Ooops, ha ocurrido un error :c';
            throw new Error(message);

          case 10:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, auth__this, [[1, 6]]);
  }));

  return function forgotPassword(_x3) {
    return _ref4.apply(this, arguments);
  };
}();

var resetPassword = function () {
  var _ref6 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(_ref7) {
    var password = _ref7.password,
        token = _ref7.token;
    var path, message;
    return regenerator_default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            path = '/reset-password';
            _context4.prev = 1;
            _context4.next = 4;
            return auth_client.post(path, { password: password, token: token });

          case 4:
            _context4.next = 10;
            break;

          case 6:
            _context4.prev = 6;
            _context4.t0 = _context4['catch'](1);
            message = _context4.t0.response ? _context4.t0.response.data : 'Ooops, ha ocurrido un error :c';
            throw new Error(message);

          case 10:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, auth__this, [[1, 6]]);
  }));

  return function resetPassword(_x4) {
    return _ref6.apply(this, arguments);
  };
}();


// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Layout.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Layout = ({
  name: 'layout',
  data: function data() {
    return {
      sessionIsGuest: false,
      sessionName: '',
      drawer: true
    };
  },
  created: function created() {
    // Fix boolean string
    this.sessionIsGuest = JSON.parse(localStorage.getItem('heimdall-session-is-guest'));
    this.sessionName = localStorage.getItem('heimdall-session-name');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25f1f8e5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout.vue
var Layout_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-layout"},[_c('v-navigation-drawer',{attrs:{"app":"","clipped":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',[_c('v-list-tile',{attrs:{"to":{ name: 'tracking' }}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("directions_car")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Seguimiento")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"to":{ name: 'geofences' }}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("layers")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Geocercas")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"to":{ name: 'routes' }}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("navigation")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Rutas")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"to":{ name: 'places' }}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("place")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Lugares")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"to":{ name: 'reports' }}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("track_changes")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Reportes")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"to":{ name: 'travels' }}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("directions")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Recorridos")])],1)],1),_vm._v(" "),(!_vm.sessionIsGuest)?_c('v-list-tile',{attrs:{"to":{ name: 'guests' }}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("person")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Invitados")])],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-toolbar',{attrs:{"app":"","clipped-left":""}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Rastreo Siglo XXI")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{attrs:{"offset-y":"","bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("notifications")])],1),_vm._v(" "),_c('v-toolbar',[_c('v-toolbar-title',[_vm._v("Notificaciones")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("settings")])],1)],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Coming soon...")])],1)],1)],1)],1),_vm._v(" "),_c('v-menu',{attrs:{"offset-y":"","bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("account_circle")])],1),_vm._v(" "),_c('v-card',[_c('v-list',[_c('v-list-tile',{attrs:{"to":{ name: 'profile' }}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"large":""}},[_vm._v("account_circle")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.sessionName))])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',[_c('v-list-tile',{attrs:{"to":{ name: 'profile' }}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("account_box")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Mi cuenta")])],1),_vm._v(" "),_c('v-list-tile',{attrs:{"to":{ name: 'help' }}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("help")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Ayuda")])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',[_vm._v("feedback")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Enviar feedback")])],1),_vm._v(" "),_c('v-list-tile',{attrs:{"to":{ name: 'login' }}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("exit_to_app")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Cerrar sesión")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-content',[_c('router-view')],1)],1)}
var Layout_staticRenderFns = []
var Layout_esExports = { render: Layout_render, staticRenderFns: Layout_staticRenderFns }
/* harmony default export */ var components_Layout = (Layout_esExports);
// CONCATENATED MODULE: ./src/components/Layout.vue
function injectStyle (ssrContext) {
  __webpack_require__("dM5o")
}
var Layout_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Layout___vue_template_functional__ = false
/* styles */
var Layout___vue_styles__ = injectStyle
/* scopeId */
var Layout___vue_scopeId__ = "data-v-25f1f8e5"
/* moduleIdentifier (server only) */
var Layout___vue_module_identifier__ = null
var Layout_Component = Layout_normalizeComponent(
  Layout,
  components_Layout,
  Layout___vue_template_functional__,
  Layout___vue_styles__,
  Layout___vue_scopeId__,
  Layout___vue_module_identifier__
)

/* harmony default export */ var src_components_Layout = (Layout_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Snackbar.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Snackbar = ({
  name: 'snackbar',
  data: function data() {
    return {
      snackbar: false,
      snackbarColor: '',
      snackbarText: ''
    };
  },
  methods: {
    open: function open(color, text) {
      this.snackbarColor = color;
      this.snackbarText = text;
      this.snackbar = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43d3925e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Snackbar.vue
var Snackbar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"timeout":6000,"color":_vm.snackbarColor},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n  "+_vm._s(_vm.snackbarText)+"\n  "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_vm._v("Close")])],1)}
var Snackbar_staticRenderFns = []
var Snackbar_esExports = { render: Snackbar_render, staticRenderFns: Snackbar_staticRenderFns }
/* harmony default export */ var components_Snackbar = (Snackbar_esExports);
// CONCATENATED MODULE: ./src/components/Snackbar.vue
var Snackbar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Snackbar___vue_template_functional__ = false
/* styles */
var Snackbar___vue_styles__ = null
/* scopeId */
var Snackbar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Snackbar___vue_module_identifier__ = null
var Snackbar_Component = Snackbar_normalizeComponent(
  Snackbar,
  components_Snackbar,
  Snackbar___vue_template_functional__,
  Snackbar___vue_styles__,
  Snackbar___vue_scopeId__,
  Snackbar___vue_module_identifier__
)

/* harmony default export */ var src_components_Snackbar = (Snackbar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Login.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Login = ({
  name: 'login',
  data: function data() {
    return {
      loading: false,
      username: '',
      password: ''
    };
  },
  components: {
    'snackbar': src_components_Snackbar
  },
  methods: {
    signIn: function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var client, error;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.loading) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return', false);

              case 2:
                client = void 0;

                this.loading = true;
                _context.prev = 4;
                _context.next = 7;
                return auth_signIn({
                  username: this.username,
                  password: this.password
                });

              case 7:
                client = _context.sent;
                _context.next = 18;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                this.loading = false;
                this.username = '';
                this.password = '';
                error = _context.t0.message;

                this.$refs.snackbar.open('error', error);
                return _context.abrupt('return', console.error(_context.t0));

              case 18:
                this.loading = false;
                this.username = '';
                this.password = '';
                localStorage.setItem('heimdall-session-is-guest', client.isGuest);
                localStorage.setItem('heimdall-session-username', client.username);
                localStorage.setItem('heimdall-session-name', client.name);
                localStorage.setItem('heimdall-session-token', client.token);
                window.location.replace('/');

              case 26:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function signIn() {
        return _ref.apply(this, arguments);
      }

      return signIn;
    }()
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67d31aa4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
var Login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"background"},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{staticClass:"hidden-xs-only",attrs:{"sm4":"","md3":"","lg2":"","xl2":""}},[_c('v-card',{staticClass:"form-card left-card",attrs:{"flat":"","height":"400px","tile":""}},[_c('v-responsive',{staticClass:"card-background",attrs:{"height":"400px"}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"display-1 text-xs-center white--text mt-5"},[_vm._v("Bienvenido")]),_vm._v(" "),_c('div',{staticClass:"title text-xs-center grey--text text--lighten-2"},[_vm._v("¡Entra!")])])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm5":"","md4":"","lg3":"","xl3":""}},[_c('v-card',{staticClass:"form-card right-card",attrs:{"flat":"","height":"400px","tile":""}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"title login-title"},[_vm._v("Iniciar Sesión")])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","justify-center":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Usuario","append-icon":"perm_identity"},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Contraseña","type":"password","append-icon":"lock_outline"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.signIn($event)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"mt-5 ml-2"},[_c('v-btn',{staticClass:"login-button",attrs:{"outline":"","loading":_vm.loading},on:{"click":_vm.signIn}},[_vm._v("Iniciar Sesión")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"body-2 text-xs-center mt-3"},[_c('a',{staticClass:"forgot-password-link white--text",attrs:{"href":"#/forgot-password"}},[_vm._v("¿Olvidaste tu contraseña?")])])])],1),_vm._v(" "),_c('v-footer',{staticClass:"footer pa-3",attrs:{"absolute":""}},[_c('div',{staticClass:"body-2 white--text mr-1 hidden-xs-only"},[_vm._v("Made with")]),_vm._v(" "),_c('v-icon',{staticClass:"hidden-xs-only",attrs:{"dark":""}},[_vm._v("favorite")]),_vm._v(" "),_c('div',{staticClass:"body-2 white--text ml-1 hidden-xs-only"},[_vm._v("by")]),_vm._v(" "),_c('div',{staticClass:"body-2 white--text ml-1"},[_vm._v("Rastreo Siglo XXI")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{staticClass:"mr-1",attrs:{"dark":""}},[_vm._v("copyright")]),_vm._v(" "),_c('div',{staticClass:"body-2 white--text"},[_vm._v(_vm._s(new Date().getFullYear()))])],1)],1),_vm._v(" "),_c('snackbar',{ref:"snackbar"})],1)}
var Login_staticRenderFns = []
var Login_esExports = { render: Login_render, staticRenderFns: Login_staticRenderFns }
/* harmony default export */ var views_Login = (Login_esExports);
// CONCATENATED MODULE: ./src/views/Login.vue
function Login_injectStyle (ssrContext) {
  __webpack_require__("zSdZ")
}
var Login_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Login___vue_template_functional__ = false
/* styles */
var Login___vue_styles__ = Login_injectStyle
/* scopeId */
var Login___vue_scopeId__ = "data-v-67d31aa4"
/* moduleIdentifier (server only) */
var Login___vue_module_identifier__ = null
var Login_Component = Login_normalizeComponent(
  Login,
  views_Login,
  Login___vue_template_functional__,
  Login___vue_styles__,
  Login___vue_scopeId__,
  Login___vue_module_identifier__
)

/* harmony default export */ var src_views_Login = (Login_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Tracking/VehicleDialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var VehicleDialog = ({
  name: 'vehicle-dialog',
  props: {
    vehicles: Array,
    selectedVehicle: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      dialog: false,
      vehicleSelect: null
    };
  },
  watch: {
    vehicleSelect: function vehicleSelect(_vehicleSelect) {
      this.$emit('update:selectedVehicle', _vehicleSelect);
    }
  },
  methods: {
    open: function open() {
      this.dialog = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0281c3bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracking/VehicleDialog.vue
var VehicleDialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":"","transition":"dialog-bottom-transition","overlay":false},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",attrs:{"dark":""}},[_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Selecciona un vehículo")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{staticClass:"mt-5",attrs:{"items":_vm.vehicles,"item-text":"plate","return-object":"","prepend-icon":"directions_car","label":"Vehículos"},model:{value:(_vm.vehicleSelect),callback:function ($$v) {_vm.vehicleSelect=$$v},expression:"vehicleSelect"}})],1)],1)],1)],1)],1)],1)}
var VehicleDialog_staticRenderFns = []
var VehicleDialog_esExports = { render: VehicleDialog_render, staticRenderFns: VehicleDialog_staticRenderFns }
/* harmony default export */ var Tracking_VehicleDialog = (VehicleDialog_esExports);
// CONCATENATED MODULE: ./src/components/Tracking/VehicleDialog.vue
var VehicleDialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var VehicleDialog___vue_template_functional__ = false
/* styles */
var VehicleDialog___vue_styles__ = null
/* scopeId */
var VehicleDialog___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VehicleDialog___vue_module_identifier__ = null
var VehicleDialog_Component = VehicleDialog_normalizeComponent(
  VehicleDialog,
  Tracking_VehicleDialog,
  VehicleDialog___vue_template_functional__,
  VehicleDialog___vue_styles__,
  VehicleDialog___vue_scopeId__,
  VehicleDialog___vue_module_identifier__
)

/* harmony default export */ var components_Tracking_VehicleDialog = (VehicleDialog_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Tracking/ActionsToolbar.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ActionsToolbar = ({
  name: 'actions-toolbar',
  props: {
    focus: String,
    vehicles: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    events: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      selectedVehicle: null,
      unreadEvents: 0
    };
  },
  computed: {
    unreadEventsBadge: function unreadEventsBadge() {
      return {
        value: this.unreadEvents,
        visible: this.unreadEvents > 0
      };
    }
  },
  watch: {
    events: function events(_events) {
      if (_events.length === 0 || _events.length === 1) this.unreadEvents = _events.length;else if (this.unreadEvents >= 99) this.unreadEvents = 99;else this.unreadEvents++;
    },
    selectedVehicle: function selectedVehicle(_selectedVehicle) {
      if (!_selectedVehicle) {
        this.$emit('update:focus', null);
      } else {
        this.$emit('update:focus', this.selectedVehicle._id);
      }
    }
  },
  components: {
    'vehicle-dialog': components_Tracking_VehicleDialog
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a291b5c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracking/ActionsToolbar.vue
var ActionsToolbar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"actions-toolbar"},[(_vm.$vuetify.breakpoint.smAndUp)?_c('v-toolbar',{staticClass:"mt-3",attrs:{"floating":"","dense":""}},[_c('v-autocomplete',{attrs:{"items":_vm.vehicles,"item-text":"plate","return-object":"","prepend-icon":"directions_car","label":"Vehículos","single-line":"","loading":_vm.loading},model:{value:(_vm.selectedVehicle),callback:function ($$v) {_vm.selectedVehicle=$$v},expression:"selectedVehicle"}}),_vm._v(" "),(_vm.selectedVehicle)?_c('v-menu',{attrs:{"offset-y":"","bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},on:{"click":function($event){_vm.unreadEvents = 0}},slot:"activator"},[_c('v-badge',{attrs:{"right":""},model:{value:(_vm.unreadEventsBadge.visible),callback:function ($$v) {_vm.$set(_vm.unreadEventsBadge, "visible", $$v)},expression:"unreadEventsBadge.visible"}},[_c('span',{attrs:{"slot":"badge","color":"primary"},slot:"badge"},[_vm._v(_vm._s(_vm.unreadEventsBadge.value))]),_vm._v(" "),_c('v-icon',[_vm._v("track_changes")])],1)],1),_vm._v(" "),_c('v-toolbar',[_c('v-toolbar-title',[_vm._v("Eventos")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("settings")])],1)],1),_vm._v(" "),_c('div',{staticClass:"events-menu-body"},[_c('v-list',{attrs:{"two-line":""}},_vm._l((_vm.events),function(event){return _c('v-list-tile',{key:event._id,attrs:{"avatar":""},on:{"click":function($event){return _vm.$emit('open-event-dialog', event._id)}}},[_c('v-list-tile-avatar',[(event.highPriority)?_c('v-icon',{staticClass:"primary white--text"},[_vm._v("priority_high")]):_c('v-icon',{staticClass:"primary white--text"},[_vm._v("notifications")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n              "+_vm._s(event.name)+"\n            ")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("\n              "+_vm._s(event.date)+"\n            ")])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"icon":"","ripple":""}},[_c('v-icon',{staticClass:"red--text text--darken-1 text--lighten-1"},[_vm._v("info")])],1)],1)],1)}),1)],1)],1):_c('v-menu',{attrs:{"disabled":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","disabled":""},slot:"activator"},[_c('v-icon',[_vm._v("track_changes")])],1)],1),_vm._v(" "),(_vm.selectedVehicle)?_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.$emit('open-commands-dialog', { vehicleId: _vm.selectedVehicle._id })}}},[_c('v-icon',[_vm._v("cloud_upload")])],1):_c('v-btn',{attrs:{"icon":"","disabled":""}},[_c('v-icon',[_vm._v("cloud_upload")])],1)],1):_vm._e(),_vm._v(" "),(_vm.$vuetify.breakpoint.xsOnly)?_c('v-toolbar',[_c('v-btn',{attrs:{"icon":"","loading":_vm.loading,"color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.$refs.vehicleDialog.open()}}},[_c('v-icon',[_vm._v("directions_car")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("\n      "+_vm._s(_vm.selectedVehicle ? _vm.selectedVehicle.plate : 'Selecciona un vehículo')+"\n    ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.selectedVehicle)?_c('v-menu',{attrs:{"offset-y":"","top":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},on:{"click":function($event){_vm.unreadEvents = 0}},slot:"activator"},[_c('v-badge',{attrs:{"right":""},model:{value:(_vm.unreadEventsBadge.visible),callback:function ($$v) {_vm.$set(_vm.unreadEventsBadge, "visible", $$v)},expression:"unreadEventsBadge.visible"}},[_c('span',{attrs:{"slot":"badge","color":"primary"},slot:"badge"},[_vm._v(_vm._s(_vm.unreadEventsBadge.value))]),_vm._v(" "),_c('v-icon',[_vm._v("track_changes")])],1)],1),_vm._v(" "),_c('v-toolbar',[_c('v-toolbar-title',[_vm._v("Eventos")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("settings")])],1)],1),_vm._v(" "),_c('div',{staticClass:"events-menu-body"},[_c('v-list',{attrs:{"two-line":""}},_vm._l((_vm.events),function(event){return _c('v-list-tile',{key:event._id,attrs:{"avatar":""},on:{"click":function($event){return _vm.$emit('open-event-dialog', event._id)}}},[_c('v-list-tile-avatar',[(event.highPriority)?_c('v-icon',{staticClass:"primary white--text"},[_vm._v("priority_high")]):_c('v-icon',{staticClass:"primary white--text"},[_vm._v("notifications")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n              "+_vm._s(event.name)+"\n            ")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("\n              "+_vm._s(event.date)+"\n            ")])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"icon":"","ripple":""}},[_c('v-icon',{staticClass:"red--text text--darken-1 text--lighten-1"},[_vm._v("info")])],1)],1)],1)}),1)],1)],1):_c('v-menu',{attrs:{"disabled":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","disabled":""},slot:"activator"},[_c('v-icon',[_vm._v("track_changes")])],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","disabled":""}},[_c('v-icon',[_vm._v("settings")])],1)],1):_vm._e(),_vm._v(" "),_c('vehicle-dialog',{ref:"vehicleDialog",attrs:{"vehicles":_vm.vehicles,"selected-vehicle":_vm.selectedVehicle},on:{"update:selectedVehicle":function($event){_vm.selectedVehicle=$event},"update:selected-vehicle":function($event){_vm.selectedVehicle=$event}}})],1)}
var ActionsToolbar_staticRenderFns = []
var ActionsToolbar_esExports = { render: ActionsToolbar_render, staticRenderFns: ActionsToolbar_staticRenderFns }
/* harmony default export */ var Tracking_ActionsToolbar = (ActionsToolbar_esExports);
// CONCATENATED MODULE: ./src/components/Tracking/ActionsToolbar.vue
function ActionsToolbar_injectStyle (ssrContext) {
  __webpack_require__("SWxp")
}
var ActionsToolbar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ActionsToolbar___vue_template_functional__ = false
/* styles */
var ActionsToolbar___vue_styles__ = ActionsToolbar_injectStyle
/* scopeId */
var ActionsToolbar___vue_scopeId__ = "data-v-6a291b5c"
/* moduleIdentifier (server only) */
var ActionsToolbar___vue_module_identifier__ = null
var ActionsToolbar_Component = ActionsToolbar_normalizeComponent(
  ActionsToolbar,
  Tracking_ActionsToolbar,
  ActionsToolbar___vue_template_functional__,
  ActionsToolbar___vue_styles__,
  ActionsToolbar___vue_scopeId__,
  ActionsToolbar___vue_module_identifier__
)

/* harmony default export */ var components_Tracking_ActionsToolbar = (ActionsToolbar_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./node_modules/lodash/find.js
var find = __webpack_require__("kbi+");
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// EXTERNAL MODULE: ./node_modules/lodash/without.js
var without = __webpack_require__("yI9a");
var without_default = /*#__PURE__*/__webpack_require__.n(without);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/get-prototype-of.js
var get_prototype_of = __webpack_require__("Zx67");
var get_prototype_of_default = /*#__PURE__*/__webpack_require__.n(get_prototype_of);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("zwoO");
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__("Pf15");
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: ./node_modules/events/events.js
var events_events = __webpack_require__("vzCy");
var events_default = /*#__PURE__*/__webpack_require__.n(events_events);

// CONCATENATED MODULE: ./src/utils/google-maps-library.js






var GOOGLE_MAPS_KEY = "AIzaSyBNA6CyQ029gfQmyQ7Q4tdhfQKr8TStrA8";

var google_maps_library_GoogleMaps = function (_EventEmitter) {
  inherits_default()(GoogleMaps, _EventEmitter);

  function GoogleMaps() {
    classCallCheck_default()(this, GoogleMaps);

    var _this = possibleConstructorReturn_default()(this, (GoogleMaps.__proto__ || get_prototype_of_default()(GoogleMaps)).call(this));

    _this._url = 'https://maps.googleapis.com';
    _this._path = '/maps/api/js';
    _this._key = GOOGLE_MAPS_KEY;
    _this._libraries = 'drawing';
    _this._callback = 'googleMapInit';
    return _this;
  }

  createClass_default()(GoogleMaps, [{
    key: 'mountCallback',
    value: function mountCallback() {
      var _this2 = this;

      window.googleMapInit = function () {
        _this2.emit('ready');
      };
    }
  }, {
    key: 'load',
    value: function load() {
      if (document.getElementById('google-maps-library')) {
        this.emit('ready');
        return false;
      }
      this.mountCallback();
      var script = document.createElement('script');
      script.id = 'google-maps-library';
      script.setAttribute('async', '');
      script.setAttribute('defer', '');
      script.type = 'text/javascript';
      script.src = '' + this._url + this._path + '?key=' + this._key + '&libraries=' + this._libraries + '&callback=' + this._callback;
      document.body.appendChild(script);
    }
  }]);

  return GoogleMaps;
}(events_default.a);

/* harmony default export */ var google_maps_library = (new google_maps_library_GoogleMaps());
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Maps/Google.vue

 //
//
//
//

/* global google */



/* harmony default export */ var Google = ({
  name: 'google-map',
  data: function data() {
    return {
      map: {},
      drawingManager: {},
      polygons: [],
      markers: [],
      polylines: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    google_maps_library.once('ready', function () {
      _this.createMap();
      _this.$emit('ready');
    });
    google_maps_library.load();
  },
  methods: {
    createMap: function createMap() {
      this.map = new google.maps.Map(document.getElementById('google-map'), {
        center: {
          lat: 6.265666,
          lng: -75.574995
        },
        zoom: 14,
        mapTypeControlOptions: {
          position: google.maps.ControlPosition.LEFT_BOTTOM
        }
      });
      this.drawingManager = this.turnOnDrawingManager();
    },
    turnOnDrawingManager: function turnOnDrawingManager() {
      var _this2 = this;

      var drawingManager = new google.maps.drawing.DrawingManager({
        drawingControl: false
      });
      google.maps.event.addListener(drawingManager, 'polygoncomplete', function (overlay) {
        var overlayPath = overlay.getPath().getArray();
        _this2.$emit('polygon-overlay-created', overlayPath);
        overlay.setMap(null);
        _this2.drawingManager.setDrawingMode(null);
      });
      google.maps.event.addListener(drawingManager, 'markercomplete', function (marker) {
        var position = marker.getPosition();
        _this2.$emit('marker-created', position);
        marker.setMap(null);
        _this2.drawingManager.setDrawingMode(null);
      });
      google.maps.event.addListener(drawingManager, 'polylinecomplete', function (overlay) {
        var overlayPath = overlay.getPath().getArray();
        _this2.$emit('polyline-overlay-created', overlayPath);
        overlay.setMap(null);
        _this2.drawingManager.setDrawingMode(null);
      });
      drawingManager.setMap(this.map);
      return drawingManager;
    },
    drawPolygon: function drawPolygon() {
      this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
    },
    drawPolyline: function drawPolyline() {
      this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYLINE);
    },
    drawMarker: function drawMarker() {
      this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.MARKER);
    },
    panTo: function panTo(position) {
      this.map.panTo(position);
    },
    setGeometryToMap: function setGeometryToMap(geometry) {
      var _this3 = this;

      if (geometry instanceof google.maps.Polyline) {
        geometry.type = 'Polyline';
        this.polylines.push(geometry);
      } else if (geometry instanceof google.maps.Marker) {
        geometry.type = 'Marker';
        this.markers.push(geometry);
      } else if (geometry instanceof google.maps.Polygon) {
        geometry.type = 'Polygon';
        this.polygons.push(geometry);
      } else {
        throw new Error('Unknown geometry type');
      }
      var emitClickEvent = function emitClickEvent(geometry) {
        _this3.$emit('geometry-clicked', geometry);
      };
      geometry.addListener('click', function () {
        emitClickEvent(this);
        event.stopPropagation();
      });
      geometry.setMap(this.map);
    },
    removeMarkers: function removeMarkers() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(this.markers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var marker = _step.value;

          marker.setMap(null);
          this.markers = without_default()(this.markers, marker);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    removePolygons: function removePolygons() {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = get_iterator_default()(this.polygons), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var polygon = _step2.value;

          polygon.setMap(null);
          this.polygons = without_default()(this.polygons, polygon);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    removePolylines: function removePolylines() {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = get_iterator_default()(this.polylines), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var polyline = _step3.value;

          polyline.setMap(null);
          this.polylines = without_default()(this.polylines, polyline);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    },
    animateMarker: function animateMarker(markerId) {
      this.markers.some(function (marker) {
        if (markerId === marker.id) {
          marker.setAnimation(google.maps.Animation.BOUNCE);
        } else {
          marker.setAnimation(null);
        }
        return markerId === marker.id;
      });
    },
    createPolygon: function createPolygon(_ref) {
      var polygonOptions = _ref.polygonOptions;

      return new google.maps.Polygon(polygonOptions);
    },
    createPolyline: function createPolyline(_ref2) {
      var polylineOptions = _ref2.polylineOptions;

      return new google.maps.Polyline(polylineOptions);
    },
    createMarker: function createMarker(_ref3) {
      var markerOptions = _ref3.markerOptions;

      return new google.maps.Marker(markerOptions);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71001b64","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Maps/Google.vue
var Google_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"google-map"}})}
var Google_staticRenderFns = []
var Google_esExports = { render: Google_render, staticRenderFns: Google_staticRenderFns }
/* harmony default export */ var Maps_Google = (Google_esExports);
// CONCATENATED MODULE: ./src/components/Maps/Google.vue
function Google_injectStyle (ssrContext) {
  __webpack_require__("93EI")
}
var Google_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Google___vue_template_functional__ = false
/* styles */
var Google___vue_styles__ = Google_injectStyle
/* scopeId */
var Google___vue_scopeId__ = "data-v-71001b64"
/* moduleIdentifier (server only) */
var Google___vue_module_identifier__ = null
var Google_Component = Google_normalizeComponent(
  Google,
  Maps_Google,
  Google___vue_template_functional__,
  Google___vue_styles__,
  Google___vue_scopeId__,
  Google___vue_module_identifier__
)

/* harmony default export */ var components_Maps_Google = (Google_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Maps/Tracking.vue

 //
//
//
//
//
//
//
//
//



/* harmony default export */ var Tracking = ({
  name: 'tracking-map',
  props: {
    vehicles: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    focus: String
  },
  data: function data() {
    return {
      mapIsReady: false
    };
  },
  watch: {
    vehicles: function vehicles() {
      this.updateMapVehicles();
    },
    focus: function focus(_focus) {
      var vehicle = find_default()(this.vehicles, { _id: _focus });
      if (vehicle && vehicle.position) {
        this.$refs.googleMap.animateMarker(vehicle._id);
        this.$refs.googleMap.panTo(vehicle.position);
      }
    }
  },
  components: {
    'google-map': components_Maps_Google
  },
  methods: {
    googleMapReady: function googleMapReady() {
      this.mapIsReady = true;
      this.updateMapVehicles();
    },
    updateMapVehicles: function updateMapVehicles() {
      if (!this.mapIsReady) {
        return false;
      }
      var googleMap = this.$refs.googleMap;
      googleMap.removeMarkers();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(this.vehicles), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var vehicle = _step.value;

          if (!vehicle.position) continue;
          var marker = googleMap.createMarker({
            markerOptions: {
              position: vehicle.position,
              title: vehicle.plate,
              id: vehicle._id
            }
          });
          googleMap.setGeometryToMap(marker);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (this.focus) googleMap.animateMarker(this.focus);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-829fd690","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Maps/Tracking.vue
var Tracking_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tracking-map"},[_c('google-map',{ref:"googleMap",on:{"ready":_vm.googleMapReady}})],1)}
var Tracking_staticRenderFns = []
var Tracking_esExports = { render: Tracking_render, staticRenderFns: Tracking_staticRenderFns }
/* harmony default export */ var Maps_Tracking = (Tracking_esExports);
// CONCATENATED MODULE: ./src/components/Maps/Tracking.vue
function Tracking_injectStyle (ssrContext) {
  __webpack_require__("qlEt")
}
var Tracking_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Tracking___vue_template_functional__ = false
/* styles */
var Tracking___vue_styles__ = Tracking_injectStyle
/* scopeId */
var Tracking___vue_scopeId__ = "data-v-829fd690"
/* moduleIdentifier (server only) */
var Tracking___vue_module_identifier__ = null
var Tracking_Component = Tracking_normalizeComponent(
  Tracking,
  Maps_Tracking,
  Tracking___vue_template_functional__,
  Tracking___vue_styles__,
  Tracking___vue_scopeId__,
  Tracking___vue_module_identifier__
)

/* harmony default export */ var components_Maps_Tracking = (Tracking_Component.exports);

// EXTERNAL MODULE: ./node_modules/canvas-gauges/gauge.min.js
var gauge_min = __webpack_require__("EDEO");
var gauge_min_default = /*#__PURE__*/__webpack_require__.n(gauge_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Gauges/Compass.vue
//
//
//
//



/* harmony default export */ var Compass = ({
  name: 'compass-gauge',
  props: {
    value: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      chart: {},
      options: {
        width: 250,
        height: 250,
        title: 'Acimut',
        minValue: 0,
        maxValue: 360,
        majorTicks: ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW', 'N'],
        minorTicks: 22,
        ticksAngle: 360,
        startAngle: 180,
        strokeTicks: false,
        highlights: false,
        colorPlate: '#222',
        colorMajorTicks: '#f5f5f5',
        colorMinorTicks: '#ddd',
        colorTitle: '#fff',
        colorNumbers: '#eee',
        colorNeedle: 'rgba(240, 128, 128, 1)',
        colorNeedleEnd: 'rgba(255, 160, 122, .9)',
        valueBox: false,
        valueTextShadow: false,
        colorCircleInner: '#fff',
        colorNeedleCircleOuter: '#ccc',
        needleCircleSize: 15,
        needleCircleOuter: false,
        animationRule: 'linear',
        needleType: 'line',
        needleStart: 75,
        needleEnd: 99,
        needleWidth: 3,
        borders: true,
        borderInnerWidth: 0,
        borderMiddleWidth: 0,
        borderOuterWidth: 10,
        colorBorderOuter: '#ccc',
        colorBorderOuterEnd: '#ccc',
        colorNeedleShadowDown: '#222',
        borderShadowWidth: 0,
        animationDuration: 1500
      }
    };
  },
  watch: {
    value: function value(curse) {
      this.chart.value = curse;
    }
  },
  mounted: function mounted() {
    this.options.value = this.value;
    this.options.renderTo = this.$el;
    this.chart = new gauge_min["RadialGauge"](this.options).draw();
  },
  beforeDestroy: function beforeDestroy() {
    this.chart.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7092db80","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gauges/Compass.vue
var Compass_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{staticClass:"compass-gauge"})}
var Compass_staticRenderFns = []
var Compass_esExports = { render: Compass_render, staticRenderFns: Compass_staticRenderFns }
/* harmony default export */ var Gauges_Compass = (Compass_esExports);
// CONCATENATED MODULE: ./src/components/Gauges/Compass.vue
var Compass_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Compass___vue_template_functional__ = false
/* styles */
var Compass___vue_styles__ = null
/* scopeId */
var Compass___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Compass___vue_module_identifier__ = null
var Compass_Component = Compass_normalizeComponent(
  Compass,
  Gauges_Compass,
  Compass___vue_template_functional__,
  Compass___vue_styles__,
  Compass___vue_scopeId__,
  Compass___vue_module_identifier__
)

/* harmony default export */ var components_Gauges_Compass = (Compass_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Gauges/Speed.vue
//
//
//
//



/* harmony default export */ var Speed = ({
  name: 'speed-gauge',
  props: {
    value: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      chart: {},
      options: {
        width: 250,
        height: 250,
        units: 'Km/h',
        title: 'Velocidad',
        minValue: 0,
        maxValue: 300,
        majorTicks: ['0', '20', '40', '60', '80', '100', '120', '140', '160', '180', '200', '220', '240', '260', '280', '300'],
        minorTicks: 2,
        strokeTicks: true,
        highlights: [{ from: 120, to: 300, color: 'rgba(200,50,50,.75)' }],
        colorPlate: '#222',
        colorMajorTicks: '#f5f5f5',
        colorMinorTicks: '#ddd',
        colorTitle: '#fff',
        colorUnits: '#ccc',
        colorNumbers: '#eee',
        colorBorderOuter: '#333',
        colorBorderOuterEnd: '#111',
        colorBorderMiddle: '#222',
        colorBorderMiddleEnd: '#111',
        colorBorderInner: '#111',
        colorBorderInnerEnd: '#333',
        needleCircleSize: '7',
        colorNeedle: '#ff0000',
        colorNeedleEnd: '#ff0000',
        valueBox: true,
        valueBoxBorderRadius: 0,
        colorValueBoxRect: '#222',
        colorValueBoxRectEnd: '#333'
      }
    };
  },
  watch: {
    value: function value(speed) {
      this.chart.value = speed;
    }
  },
  mounted: function mounted() {
    this.options.value = this.value;
    this.options.renderTo = this.$el;
    this.chart = new gauge_min["RadialGauge"](this.options).draw();
  },
  beforeDestroy: function beforeDestroy() {
    this.chart.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64ee22f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gauges/Speed.vue
var Speed_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{staticClass:"speed-gauge"})}
var Speed_staticRenderFns = []
var Speed_esExports = { render: Speed_render, staticRenderFns: Speed_staticRenderFns }
/* harmony default export */ var Gauges_Speed = (Speed_esExports);
// CONCATENATED MODULE: ./src/components/Gauges/Speed.vue
var Speed_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Speed___vue_template_functional__ = false
/* styles */
var Speed___vue_styles__ = null
/* scopeId */
var Speed___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Speed___vue_module_identifier__ = null
var Speed_Component = Speed_normalizeComponent(
  Speed,
  Gauges_Speed,
  Speed___vue_template_functional__,
  Speed___vue_styles__,
  Speed___vue_scopeId__,
  Speed___vue_module_identifier__
)

/* harmony default export */ var components_Gauges_Speed = (Speed_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Gauges/Signal.vue
//
//
//
//

/* harmony default export */ var Signal = ({
  name: 'signal-gauge',
  props: {
    level: Number
  },
  data: function data() {
    return {
      signalLevels: 5,
      width: 200,
      height: 150,
      radius: 10,
      x: 0,
      y: 0
    };
  },
  watch: {
    level: function level(signalStrenght) {
      var canvas = this.$el;
      var ctx = canvas.getContext('2d');
      var level = this.level;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      this.drawBase(ctx, level);
      this.drawSignalStrength(ctx, level);
      this.drawEmptySignalLevels(ctx, this.signalLevels, level);
    }
  },
  mounted: function mounted() {
    var canvas = this.$el;
    var canvasWidth = this.width;
    var canvasHeight = this.height;
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;
    this.x = canvasWidth / 2;
    this.y = canvasHeight - this.radius;
    var ctx = canvas.getContext('2d');
    var level = this.level;
    this.drawBase(ctx, level);
    this.drawSignalStrength(ctx, level);
    this.drawEmptySignalLevels(ctx, this.signalLevels, level);
  },
  methods: {
    drawBase: function drawBase(ctx, signalStrenght) {
      ctx.beginPath();
      ctx.arc(this.x, this.y, this.radius, 0, 2 * Math.PI);
      if (signalStrenght > 0) {
        ctx.fillStyle = '#00ccff';
      } else {
        ctx.fillStyle = '#808080';
      }
      ctx.fill();
    },
    drawSignalStrength: function drawSignalStrength(ctx, signalStrenght) {
      for (var i = 0; i < signalStrenght; i++) {
        ctx.beginPath();
        ctx.arc(this.x, this.y, 30 * i, this.degreesToRadians(225), this.degreesToRadians(315));
        ctx.lineWidth = 2 * this.radius;
        ctx.strokeStyle = '#00ccff';
        ctx.stroke();
      }
    },
    drawEmptySignalLevels: function drawEmptySignalLevels(ctx, signalLevels, signalStrenght) {
      for (var i = signalStrenght; i < signalLevels; i++) {
        ctx.beginPath();
        ctx.arc(this.x, this.y, 30 * i, this.degreesToRadians(225), this.degreesToRadians(315));
        ctx.lineWidth = 2 * this.radius;
        ctx.strokeStyle = '#808080';
        ctx.stroke();
      }
    },
    degreesToRadians: function degreesToRadians(degrees) {
      return degrees * Math.PI / 180;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-647f793c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gauges/Signal.vue
var Signal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{staticClass:"signal-gauge"})}
var Signal_staticRenderFns = []
var Signal_esExports = { render: Signal_render, staticRenderFns: Signal_staticRenderFns }
/* harmony default export */ var Gauges_Signal = (Signal_esExports);
// CONCATENATED MODULE: ./src/components/Gauges/Signal.vue
var Signal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Signal___vue_template_functional__ = false
/* styles */
var Signal___vue_styles__ = null
/* scopeId */
var Signal___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Signal___vue_module_identifier__ = null
var Signal_Component = Signal_normalizeComponent(
  Signal,
  Gauges_Signal,
  Signal___vue_template_functional__,
  Signal___vue_styles__,
  Signal___vue_scopeId__,
  Signal___vue_module_identifier__
)

/* harmony default export */ var components_Gauges_Signal = (Signal_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Gauges/Voltage.vue
//
//
//
//



/* harmony default export */ var Voltage = ({
  name: 'voltage-gauge',
  props: {
    value: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      chart: {},
      options: {
        width: 250,
        height: 250,
        units: 'V',
        minValue: 10,
        maxValue: 16,
        startAngle: 90,
        ticksAngle: 180,
        majorTicks: ['10', '13', '16'],
        minorTicks: 3,
        strokeTicks: true,
        highlights: false,
        valueBox: false,
        colorPlate: '#fff',
        borderShadowWidth: 0,
        borders: false,
        needleType: 'arrow',
        needleWidth: 2,
        needleCircleSize: 7,
        needleCircleOuter: true,
        needleCircleInner: false
      }
    };
  },
  watch: {
    value: function value(speed) {
      this.chart.value = speed;
    }
  },
  mounted: function mounted() {
    this.options.value = this.value;
    this.options.title = this.title;
    this.options.renderTo = this.$el;
    this.chart = new gauge_min["RadialGauge"](this.options).draw();
  },
  beforeDestroy: function beforeDestroy() {
    this.chart.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3eeb7b40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gauges/Voltage.vue
var Voltage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{staticClass:"voltage-gauge"})}
var Voltage_staticRenderFns = []
var Voltage_esExports = { render: Voltage_render, staticRenderFns: Voltage_staticRenderFns }
/* harmony default export */ var Gauges_Voltage = (Voltage_esExports);
// CONCATENATED MODULE: ./src/components/Gauges/Voltage.vue
var Voltage_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Voltage___vue_template_functional__ = false
/* styles */
var Voltage___vue_styles__ = null
/* scopeId */
var Voltage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Voltage___vue_module_identifier__ = null
var Voltage_Component = Voltage_normalizeComponent(
  Voltage,
  Gauges_Voltage,
  Voltage___vue_template_functional__,
  Voltage___vue_styles__,
  Voltage___vue_scopeId__,
  Voltage___vue_module_identifier__
)

/* harmony default export */ var components_Gauges_Voltage = (Voltage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EventDialog.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var EventDialog = ({
  name: 'event-dialog',
  data: function data() {
    return {
      dialog: false,
      loading: false,
      now: new Date()
    };
  },
  computed: {
    event: function event() {
      return this.$store.getters['EventDialog/event'](this.now);
    }
  },
  mounted: function mounted() {
    var _this = this;

    setInterval(function () {
      _this.now = new Date();
    }, 60000);
  },
  components: {
    'compass-gauge': components_Gauges_Compass,
    'speed-gauge': components_Gauges_Speed,
    'signal-gauge': components_Gauges_Signal,
    'voltage-gauge': components_Gauges_Voltage
  },
  methods: {
    open: function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref2) {
        var eventId = _ref2.eventId;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.loading = true;
                this.dialog = true;
                _context.next = 4;
                return this.$store.dispatch('EventDialog/fetchEvent', { eventId: eventId });

              case 4:
                this.loading = false;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function open(_x) {
        return _ref.apply(this, arguments);
      }

      return open;
    }()
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4779dea2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EventDialog.vue
var EventDialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-dialog"},[_c('v-dialog',{attrs:{"fullscreen":"","transition":"dialog-bottom-transition","overlay":false},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Evento")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("cerrar")])],1)],1),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading mt-5"},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":100,"color":"primary"}})],1)],1):_c('div',{staticClass:"event"},[_c('v-container',{attrs:{"fluid":""}},[(_vm.event)?_c('v-layout',{staticClass:"header",attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","lg4":"","xl3":""}},[_c('v-card',{staticClass:"ma-3"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Detalles del Evento")])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[(_vm.event)?_c('div',{staticClass:"mb-3"},[_c('div',{staticClass:"title text-xs-center"},[_vm._v(_vm._s(_vm.event.vehiclePlate))]),_vm._v(" "),_c('div',{staticClass:"title text-xs-center"},[_vm._v(_vm._s(_vm.event.name))]),_vm._v(" "),_c('div',{staticClass:"title text-xs-center green--text"},[_vm._v(_vm._s(_vm.event.date))]),_vm._v(" "),(_vm.event.engineState)?_c('div',{staticClass:"title text-xs-center green--text"},[_vm._v("Motor encendido")]):_c('div',{staticClass:"title text-xs-center red--text"},[_vm._v("Motor apagado")])]):_vm._e()])],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.event)?_c('v-layout',{staticClass:"event-details",attrs:{"row":"","wrap":""}},[(_vm.event && _vm.event.gps)?_c('v-flex',{staticClass:"speed-card",attrs:{"xs12":"","sm6":"","lg4":"","xl3":""}},[_c('v-card',{staticClass:"ma-3"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Velocidad")])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[(_vm.event)?_c('div',{staticClass:"mb-3"},[_c('speed-gauge',{attrs:{"value":_vm.event.gps.speed}})],1):_vm._e()])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.event && _vm.event.gps)?_c('v-flex',{staticClass:"azimuth-card",attrs:{"xs12":"","sm6":"","lg4":"","xl3":""}},[_c('v-card',{staticClass:"ma-3"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Acimut")])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('div',{staticClass:"mb-3"},[_c('compass-gauge',{attrs:{"value":_vm.event.gps.azimuth}})],1)])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.event && _vm.event.gps)?_c('v-flex',{staticClass:"gps-card",attrs:{"xs12":"","sm6":"","lg4":"","xl3":""}},[_c('v-card',{staticClass:"ma-3"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("GPS")])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('div',{staticClass:"mb-3"},[_c('v-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"title text-xs-center mb-4"},[_vm._v("\n                          "+_vm._s(_vm.event.reverseGeocoding)+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("\n                          Satélites a la vista:\n                          "),(_vm.event.gps.satellites)?_c('span',{staticClass:"green--text"},[_vm._v("\n                            "+_vm._s(_vm.event.gps.satellites)+"\n                          ")]):_c('span',{staticClass:"red--text"},[_vm._v("NO APLICA")])]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("\n                          Dispersión de la precisión horizontal:\n                          "),(_vm.event.gps.hdop)?_c('span',{staticClass:"green--text"},[_vm._v("\n                            "+_vm._s(_vm.event.gps.hdop)+"\n                          ")]):_c('span',{staticClass:"red--text"},[_vm._v("NO APLICA")])]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("\n                          Dispersión de la precisión vertical:\n                          "),(_vm.event.gps.vdop)?_c('span',{staticClass:"green--text"},[_vm._v("\n                            "+_vm._s(_vm.event.gps.vdop)+"\n                          ")]):_c('span',{staticClass:"red--text"},[_vm._v("NO APLICA")])]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("\n                          Latitud:\n                          "),_c('span',{staticClass:"green--text"},[_vm._v("\n                            "+_vm._s(_vm.event.gps.latitude)+"\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("\n                          Longitud:\n                          "),_c('span',{staticClass:"green--text"},[_vm._v("\n                            "+_vm._s(_vm.event.gps.longitude)+"\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("\n                          Altitud:\n                          "),(_vm.event.gps.altitude)?_c('span',{staticClass:"green--text"},[_vm._v("\n                            "+_vm._s(_vm.event.gps.altitude)+" msnm\n                          ")]):_c('span',{staticClass:"red--text"},[_vm._v("NO APLICA")])])])],1)])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.event && _vm.event.gsm && _vm.event.gsm.signal <= 5)?_c('v-flex',{staticClass:"gsm-card",attrs:{"xs12":"","sm6":"","lg4":"","xl3":""}},[_c('v-card',{staticClass:"ma-3"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("GSM")])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('div',{staticClass:"mb-3"},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('signal-gauge',{staticClass:"mb-4",attrs:{"level":_vm.event.gsm.signal}})],1),_vm._v(" "),_c('v-container',{attrs:{"fluid":""}},[(_vm.event.gsm.registration)?_c('div',[(_vm.event.gsm.registration.status)?_c('div',{staticClass:"title green--text"},[_vm._v(_vm._s(_vm.event.gsm.registration.message))]):_c('div',{staticClass:"title green--text"},[_vm._v(_vm._s(_vm.event.gsm.registration.message))]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("\n                            Código del país:\n                            "),_c('span',{staticClass:"green--text"},[_vm._v("\n                              "+_vm._s(_vm.event.gsm.codeCountry)+"\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("\n                            Código de la green:\n                            "),_c('span',{staticClass:"green--text"},[_vm._v("\n                              "+_vm._s(_vm.event.gsm.codeNetwork)+"\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("\n                            Código de la estación base:\n                            "),_c('span',{staticClass:"green--text"},[_vm._v("\n                              "+_vm._s(_vm.event.gsm.baseStationCode)+"\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("\n                            Identificador de la estación base:\n                            "),_c('span',{staticClass:"green--text"},[_vm._v("\n                              "+_vm._s(_vm.event.gsm.baseStationIdentifier)+"\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("\n                            Fuerza de la señal:\n                            "),_c('span',{staticClass:"green--text"},[_vm._v("\n                              "+_vm._s(_vm.event.gsm.strengthSignal)+" dBm\n                            ")])])]):_vm._e()])],1)])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.event && _vm.event.batteryLevel)?_c('v-flex',{staticClass:"battery-card",attrs:{"xs12":"","sm6":"","lg4":"","xl3":""}},[_c('v-card',{staticClass:"ma-3"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Batería")])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('div',{staticClass:"mb-3"},[_c('voltage-gauge',{attrs:{"value":_vm.event.batteryLevel,"title":"Batería"}})],1)])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.event && _vm.event.backupBatteryLevel)?_c('v-flex',{attrs:{"xs12":"","sm6":"","lg4":"","xl3":""}},[_c('v-card',{staticClass:"ma-3"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Batería de Respaldo")])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('div',{staticClass:"mb-3"},[_c('voltage-gauge',{attrs:{"value":_vm.event.backupBatteryLevel,"title":"Respaldo"}})],1)])],1)],1)],1):_vm._e()],1):_vm._e()],1)],1)],1)],1)],1)}
var EventDialog_staticRenderFns = []
var EventDialog_esExports = { render: EventDialog_render, staticRenderFns: EventDialog_staticRenderFns }
/* harmony default export */ var components_EventDialog = (EventDialog_esExports);
// CONCATENATED MODULE: ./src/components/EventDialog.vue
var EventDialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var EventDialog___vue_template_functional__ = false
/* styles */
var EventDialog___vue_styles__ = null
/* scopeId */
var EventDialog___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EventDialog___vue_module_identifier__ = null
var EventDialog_Component = EventDialog_normalizeComponent(
  EventDialog,
  components_EventDialog,
  EventDialog___vue_template_functional__,
  EventDialog___vue_styles__,
  EventDialog___vue_scopeId__,
  EventDialog___vue_module_identifier__
)

/* harmony default export */ var src_components_EventDialog = (EventDialog_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CommandsDialog.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var CommandsDialog = ({
  name: 'commands-dialog',
  data: function data() {
    return {
      dialog: false,
      loading: false,
      vehicleId: null,
      warningText: 'Algunos comandos pueden generar comportamientos inesperados en los vehículos. Apagar un vehículo mientras se desplaza a altas velocidades puede generar una pérdida del control del mismo.',
      errorAlertText: 'El dispositivo no recibió el comando, vuelve a intentarlo.'
    };
  },
  computed: {
    commands: function commands() {
      return this.$store.getters['CommandsDialog/commands'];
    },
    commandTransferStatus: function commandTransferStatus() {
      return this.$store.state.CommandsDialog.commandTransferStatus;
    },
    sendingCommand: function sendingCommand() {
      var processes = ['SENDING', 'PENDING'];
      return processes.includes(this.commandTransferStatus);
    },
    errorAlert: function errorAlert() {
      return this.commandTransferStatus === 'ERROR';
    }
  },
  methods: {
    open: function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref2) {
        var vehicleId = _ref2.vehicleId;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (vehicleId) {
                  _context.next = 2;
                  break;
                }

                throw new Error('Vehicle id is missing.');

              case 2:
                this.vehicleId = vehicleId;
                this.dialog = true;
                this.loading = true;
                _context.next = 7;
                return this.$store.dispatch('CommandsDialog/fetchVehicle', { vehicleId: vehicleId });

              case 7:
                this.loading = false;

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function open(_x) {
        return _ref.apply(this, arguments);
      }

      return open;
    }(),
    sendCommand: function () {
      var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(_ref4) {
        var commandId = _ref4.commandId;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.$store.dispatch('CommandsDialog/connectToCommandsServer');

              case 2:
                this.$store.dispatch('CommandsDialog/sendCommand', {
                  commandId: commandId,
                  vehicleId: this.vehicleId
                });

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function sendCommand(_x2) {
        return _ref3.apply(this, arguments);
      }

      return sendCommand;
    }()
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df19bc96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommandsDialog.vue
var CommandsDialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":590},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Comandos")])]),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"type":"warning","value":true}},[_vm._v(_vm._s(_vm.warningText))])],1),_vm._v(" "),_c('v-card-text',[(_vm.loading)?_c('div',{staticClass:"loading mt-5"},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":100,"color":"primary"}})],1)],1):_c('div',{staticClass:"commands"},[_c('v-layout',{attrs:{"row":"","justify-center":""}},_vm._l((_vm.commands),function(command,index){return _c('v-btn',{key:index,attrs:{"color":"primary","loading":_vm.sendingCommand},on:{"click":function($event){return _vm.sendCommand({ commandId: command.id })}}},[_vm._v("\n            "+_vm._s(command.alias)+"\n            "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1)}),1)],1)]),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"color":"error","icon":"warning"},model:{value:(_vm.errorAlert),callback:function ($$v) {_vm.errorAlert=$$v},expression:"errorAlert"}},[_vm._v(_vm._s(_vm.errorAlertText))])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("cerrar")])],1)],1)],1)}
var CommandsDialog_staticRenderFns = []
var CommandsDialog_esExports = { render: CommandsDialog_render, staticRenderFns: CommandsDialog_staticRenderFns }
/* harmony default export */ var components_CommandsDialog = (CommandsDialog_esExports);
// CONCATENATED MODULE: ./src/components/CommandsDialog.vue
var CommandsDialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CommandsDialog___vue_template_functional__ = false
/* styles */
var CommandsDialog___vue_styles__ = null
/* scopeId */
var CommandsDialog___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CommandsDialog___vue_module_identifier__ = null
var CommandsDialog_Component = CommandsDialog_normalizeComponent(
  CommandsDialog,
  components_CommandsDialog,
  CommandsDialog___vue_template_functional__,
  CommandsDialog___vue_styles__,
  CommandsDialog___vue_scopeId__,
  CommandsDialog___vue_module_identifier__
)

/* harmony default export */ var src_components_CommandsDialog = (CommandsDialog_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Tracking.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var views_Tracking = ({
  name: 'tracking',
  data: function data() {
    return {
      focus: null,
      loading: false
    };
  },
  computed: {
    vehicles: function vehicles() {
      return this.$store.state.Tracking.vehicles;
    },
    events: function events() {
      return this.$store.getters['Tracking/events'];
    }
  },
  watch: {
    focus: function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(_focus) {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_focus) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return', false);

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return this.$store.dispatch('Tracking/watchVehicle', {
                  vehicleId: _focus
                });

              case 5:
                _context.next = 7;
                return this.$store.dispatch('Tracking/fetchVehicleLastEvent', {
                  vehicleId: _focus
                });

              case 7:
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](2);
                return _context.abrupt('return', this.$refs.snackbar.open('error', _context.t0.message));

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 9]]);
      }));

      function focus(_x) {
        return _ref.apply(this, arguments);
      }

      return focus;
    }()
  },
  components: {
    'actions-toolbar': components_Tracking_ActionsToolbar,
    'tracking-map': components_Maps_Tracking,
    'event-dialog': src_components_EventDialog,
    'commands-dialog': src_components_CommandsDialog,
    'snackbar': src_components_Snackbar
  },
  created: function () {
    var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              this.loading = true;
              _context2.prev = 1;
              _context2.next = 4;
              return this.$store.dispatch('Tracking/connectToEventsServer');

            case 4:
              _context2.next = 6;
              return this.$store.dispatch('Tracking/fetchVehicles');

            case 6:
              _context2.next = 8;
              return this.$store.dispatch('Tracking/subscribeToEvents');

            case 8:
              _context2.next = 15;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2['catch'](1);

              this.loading = false;
              console.error(_context2.t0);
              return _context2.abrupt('return', this.$refs.snackbar.open('error', 'No se logró establecer conexión con el servidor'));

            case 15:
              this.loading = false;
              this.loadSettings();

            case 17:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this, [[1, 10]]);
    }));

    function created() {
      return _ref2.apply(this, arguments);
    }

    return created;
  }(),
  destroyed: function destroyed() {
    this.$store.dispatch('Tracking/unsubscribeFromEvents');
    this.saveSettings();
  },
  methods: {
    openCommandsDialog: function openCommandsDialog(_ref3) {
      var vehicleId = _ref3.vehicleId;

      this.$refs.commandsDialog.open({ vehicleId: vehicleId });
    },
    openEventDialog: function openEventDialog(eventId) {
      this.$refs.eventDialog.open({ eventId: eventId });
    },
    loadSettings: function loadSettings() {
      var username = localStorage.getItem('heimdall-session-username');
      if (false) {
        console.log('Loading ' + username + ' settings...');
      }
      var settings = JSON.parse(localStorage.getItem('heimdall-' + username + '-settings'));
      if (!settings) {
        return false;
      }
      this.focus = settings.focus || null;
    },
    saveSettings: function saveSettings() {
      var username = localStorage.getItem('heimdall-session-username');
      if (false) {
        console.log('Saving ' + username + ' settings...');
      }
      var unsavedSettings = {
        focus: this.focus
      };
      localStorage.setItem('heimdall-' + username + '-settings', stringify_default()(unsavedSettings));
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf789204","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Tracking.vue
var views_Tracking_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tracking"},[_c('div',{staticClass:"map-wrapper"},[_c('div',{staticClass:"over-map-content"},[(_vm.$vuetify.breakpoint.smAndUp)?_c('actions-toolbar',{attrs:{"focus":_vm.focus,"vehicles":_vm.vehicles,"events":_vm.events,"loading":_vm.loading},on:{"update:focus":function($event){_vm.focus=$event},"open-event-dialog":_vm.openEventDialog,"open-commands-dialog":_vm.openCommandsDialog}}):_vm._e()],1),_vm._v(" "),_c('tracking-map',{attrs:{"vehicles":_vm.vehicles,"focus":_vm.focus}})],1),_vm._v(" "),_c('event-dialog',{ref:"eventDialog"}),_vm._v(" "),_c('commands-dialog',{ref:"commandsDialog"}),_vm._v(" "),(_vm.$vuetify.breakpoint.xsOnly)?_c('actions-toolbar',{attrs:{"focus":_vm.focus,"vehicles":_vm.vehicles,"events":_vm.events,"loading":_vm.loading},on:{"update:focus":function($event){_vm.focus=$event},"open-event-dialog":_vm.openEventDialog}}):_vm._e(),_vm._v(" "),_c('snackbar',{ref:"snackbar"})],1)}
var views_Tracking_staticRenderFns = []
var views_Tracking_esExports = { render: views_Tracking_render, staticRenderFns: views_Tracking_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_Tracking = (views_Tracking_esExports);
// CONCATENATED MODULE: ./src/views/Tracking.vue
function views_Tracking_injectStyle (ssrContext) {
  __webpack_require__("VSNX")
}
var views_Tracking_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var views_Tracking___vue_template_functional__ = false
/* styles */
var views_Tracking___vue_styles__ = views_Tracking_injectStyle
/* scopeId */
var views_Tracking___vue_scopeId__ = "data-v-bf789204"
/* moduleIdentifier (server only) */
var views_Tracking___vue_module_identifier__ = null
var views_Tracking_Component = views_Tracking_normalizeComponent(
  views_Tracking,
  selectortype_template_index_0_src_views_Tracking,
  views_Tracking___vue_template_functional__,
  views_Tracking___vue_styles__,
  views_Tracking___vue_scopeId__,
  views_Tracking___vue_module_identifier__
)

/* harmony default export */ var src_views_Tracking = (views_Tracking_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Maps/Geofences.vue

 //
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Geofences = ({
  name: 'geofences-map',
  props: {
    geofences: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    drawingGeofence: {
      type: Boolean,
      default: false
    },
    vehicles: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    focus: String
  },
  data: function data() {
    return {
      mapIsReady: false
    };
  },
  computed: {
    polygons: function polygons() {
      return this.geofences.map(function (geofence) {
        var polygon = {
          path: [],
          id: geofence._id
        };
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = get_iterator_default()(geofence.geometry.coordinates[0]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var coordinate = _step.value;

            polygon.path.push({
              lat: coordinate[1],
              lng: coordinate[0]
            });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return polygon;
      });
    }
  },
  watch: {
    polygons: function polygons() {
      this.updateMapGeofences();
    },
    drawingGeofence: function drawingGeofence() {
      this.updateMapDrawingState();
    },
    vehicles: function vehicles() {
      this.updateMapVehicles();
    },
    focus: function focus(_focus) {
      var vehicle = find_default()(this.vehicles, { _id: _focus });
      if (vehicle && vehicle.position) {
        this.$refs.googleMap.animateMarker(vehicle._id);
        this.$refs.googleMap.panTo(vehicle.position);
      }
    }
  },
  components: {
    'google-map': components_Maps_Google
  },
  methods: {
    googleMapReady: function googleMapReady() {
      this.mapIsReady = true;
      this.updateMapGeofences();
      this.updateMapDrawingState();
    },
    updateMapGeofences: function updateMapGeofences() {
      if (!this.mapIsReady) return false;
      this.$refs.googleMap.removePolygons();
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = get_iterator_default()(this.polygons), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var polygon = _step2.value;

          this.$refs.googleMap.setGeometryToMap(this.$refs.googleMap.createPolygon({
            polygonOptions: polygon
          }));
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    updateMapVehicles: function updateMapVehicles() {
      if (!this.mapIsReady) {
        return false;
      }
      var googleMap = this.$refs.googleMap;
      googleMap.removeMarkers();
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = get_iterator_default()(this.vehicles), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var vehicle = _step3.value;

          if (!vehicle.position) continue;
          var marker = googleMap.createMarker({
            markerOptions: {
              position: vehicle.position,
              title: vehicle.plate,
              id: vehicle._id
            }
          });
          googleMap.setGeometryToMap(marker);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      if (this.focus) googleMap.animateMarker(this.focus);
    },
    updateMapDrawingState: function updateMapDrawingState() {
      if (!this.mapIsReady || !this.drawingGeofence) return false;
      this.$refs.googleMap.drawPolygon();
    },
    createPolygon: function createPolygon(overlayPath) {
      var polygon = {
        type: 'Polygon',
        coordinates: [[]]
      };
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = get_iterator_default()(overlayPath), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var path = _step4.value;

          var coordinate = [path.lng(), path.lat()];
          polygon.coordinates[0].push(coordinate);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      var firstCoordinate = overlayPath[0];
      polygon.coordinates[0].push([firstCoordinate.lng(), firstCoordinate.lat()]);
      this.$emit('polygon-created', polygon);
    },
    polygonClicked: function polygonClicked(_ref) {
      var type = _ref.type,
          id = _ref.id;

      if (type !== 'Polygon') return false;
      this.$emit('polygon-clicked', id);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ed537e9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Maps/Geofences.vue
var Geofences_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"geofences-map"},[_c('google-map',{ref:"googleMap",on:{"ready":_vm.googleMapReady,"geometry-clicked":_vm.polygonClicked,"polygon-overlay-created":_vm.createPolygon}})],1)}
var Geofences_staticRenderFns = []
var Geofences_esExports = { render: Geofences_render, staticRenderFns: Geofences_staticRenderFns }
/* harmony default export */ var Maps_Geofences = (Geofences_esExports);
// CONCATENATED MODULE: ./src/components/Maps/Geofences.vue
function Geofences_injectStyle (ssrContext) {
  __webpack_require__("Abih")
}
var Geofences_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Geofences___vue_template_functional__ = false
/* styles */
var Geofences___vue_styles__ = Geofences_injectStyle
/* scopeId */
var Geofences___vue_scopeId__ = "data-v-4ed537e9"
/* moduleIdentifier (server only) */
var Geofences___vue_module_identifier__ = null
var Geofences_Component = Geofences_normalizeComponent(
  Geofences,
  Maps_Geofences,
  Geofences___vue_template_functional__,
  Geofences___vue_styles__,
  Geofences___vue_scopeId__,
  Geofences___vue_module_identifier__
)

/* harmony default export */ var components_Maps_Geofences = (Geofences_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Geofences.vue



 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_Geofences = ({
  name: 'geofences',
  data: function data() {
    return {
      focus: null,
      loading: false,
      updatingGeofence: false,
      drawingGeofence: false,
      selectedGeofenceId: false,
      selectedGeofenceName: 'Nombre de la Geocerca',
      selectedGeofenceVehicles: [],
      dialog: false
    };
  },
  computed: {
    vehicles: function vehicles() {
      return this.$store.state.Geofences.vehicles;
    },
    shapes: function shapes() {
      return this.$store.state.Geofences.shapes;
    },
    geofences: function geofences() {
      var geofences = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(this.shapes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var shape = _step.value;

          if (shape.geometry.type === 'Polygon') {
            geofences.push(shape);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return geofences;
    }
  },
  components: {
    'geofences-map': components_Maps_Geofences,
    'snackbar': src_components_Snackbar
  },
  created: function () {
    var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.loading = true;
              _context.prev = 1;
              _context.next = 4;
              return this.$store.dispatch('Geofences/fetchShapes');

            case 4:
              _context.next = 6;
              return this.$store.dispatch('Geofences/connectToEventsServer');

            case 6:
              _context.next = 8;
              return this.$store.dispatch('Geofences/fetchVehicles');

            case 8:
              _context.next = 10;
              return this.$store.dispatch('Geofences/subscribeToPositions');

            case 10:
              _context.next = 17;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context['catch'](1);

              this.loading = false;
              console.error(_context.t0);
              return _context.abrupt('return', this.$refs.snackbar.open('error', 'No se logró establecer conexión con el servidor'));

            case 17:
              this.loading = false;

            case 18:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[1, 12]]);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }(),
  destroyed: function destroyed() {
    this.$store.dispatch('Geofences/unsubscribeFromEvents');
  },
  methods: {
    openGeofenceDialog: function openGeofenceDialog(geofenceId) {
      var geofence = find_default()(this.geofences, { _id: geofenceId });
      this.selectedGeofenceId = geofence._id;
      this.selectedGeofenceName = geofence.name;
      this.selectedGeofenceVehicles = geofence.vehicles;
      this.dialog = true;
    },
    createGeofence: function () {
      var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(polygon) {
        var geofence;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.drawingGeofence = false;
                geofence = {
                  geometry: polygon,
                  name: 'Sin Título',
                  vehicles: []
                };
                _context2.prev = 2;
                _context2.next = 5;
                return this.$store.dispatch('Geofences/createShape', {
                  shape: geofence
                });

              case 5:
                _context2.next = 11;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](2);

                console.error(_context2.t0);
                return _context2.abrupt('return', this.$refs.snackbar.open('error', 'Ocurrió un error mientras se creaba la geocerca'));

              case 11:
                this.$refs.snackbar.open('success', 'Geocerca creada');

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 7]]);
      }));

      function createGeofence(_x) {
        return _ref2.apply(this, arguments);
      }

      return createGeofence;
    }(),
    updateGeofence: function () {
      var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.updatingGeofence = true;
                _context3.prev = 1;
                _context3.next = 4;
                return this.$store.dispatch('Geofences/updateShape', {
                  shapeId: this.selectedGeofenceId,
                  shape: {
                    name: this.selectedGeofenceName,
                    vehicles: this.selectedGeofenceVehicles
                  }
                });

              case 4:
                _context3.next = 11;
                break;

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3['catch'](1);

                this.updatingGeofence = false;
                console.error(_context3.t0);
                return _context3.abrupt('return', this.$refs.snackbar.open('error', 'Ocurrió un error mientras se actualizaba la geocerca'));

              case 11:
                this.updatingGeofence = false;
                this.dialog = false;
                this.selectedGeofenceId = false;
                this.selectedGeofenceName = '';
                this.selectedGeofenceVehicles = [];
                this.$refs.snackbar.open('success', 'Geocerca actualizada');

              case 17:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 6]]);
      }));

      function updateGeofence() {
        return _ref3.apply(this, arguments);
      }

      return updateGeofence;
    }(),
    removeGeofence: function () {
      var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var shapeId;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                shapeId = this.selectedGeofenceId;
                _context4.prev = 1;
                _context4.next = 4;
                return this.$store.dispatch('Geofences/removeShape', {
                  shapeId: shapeId
                });

              case 4:
                _context4.next = 10;
                break;

              case 6:
                _context4.prev = 6;
                _context4.t0 = _context4['catch'](1);

                console.error(_context4.t0);
                return _context4.abrupt('return', this.$refs.snackbar.open('error', 'Ocurrió un error mientras se eliminaba la geocerca'));

              case 10:
                this.dialog = false;
                this.selectedGeofenceId = false;
                this.selectedGeofenceName = false;
                this.selectedGeofenceVehicles = [];
                this.$refs.snackbar.open('success', 'Geocerca eliminada');

              case 15:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 6]]);
      }));

      function removeGeofence() {
        return _ref4.apply(this, arguments);
      }

      return removeGeofence;
    }()
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6244afdc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Geofences.vue
var components_Geofences_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"geofences"},[_c('div',{staticClass:"map-wrapper"},[_c('div',{staticClass:"over-map-content"},[_c('v-toolbar',{staticClass:"mt-3",attrs:{"floating":"","dense":""}},[_c('v-autocomplete',{attrs:{"items":_vm.vehicles,"item-text":"plate","item-value":"_id","prepend-icon":"directions_car","label":"Vehículos","single-line":"","loading":_vm.loading},model:{value:(_vm.focus),callback:function ($$v) {_vm.focus=$$v},expression:"focus"}})],1),_vm._v(" "),_c('v-btn',{staticClass:"mr-5 mb-4",attrs:{"color":"primary","dark":"","fab":"","fixed":"","bottom":"","right":""},nativeOn:{"click":function($event){_vm.drawingGeofence = true}}},[_c('v-icon',[_vm._v("add")])],1)],1),_vm._v(" "),_c('geofences-map',{attrs:{"vehicles":_vm.vehicles,"focus":_vm.focus,"geofences":_vm.geofences,"drawing-geofence":_vm.drawingGeofence},on:{"polygon-created":_vm.createGeofence,"polygon-clicked":_vm.openGeofenceDialog}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":620},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_c('v-icon',[_vm._v("layers")]),_vm._v("\n          Geocerca "+_vm._s(_vm.selectedGeofenceName)+"\n        ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{attrs:{"offset-y":"","bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":_vm.removeGeofence}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("delete")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                  Eliminar Geocerca\n                ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Nombre","prepend-icon":"layers"},model:{value:(_vm.selectedGeofenceName),callback:function ($$v) {_vm.selectedGeofenceName=$$v},expression:"selectedGeofenceName"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.vehicles,"multiple":"","item-text":"plate","item-value":"_id","label":"Vehículos","prepend-icon":"directions_car"},model:{value:(_vm.selectedGeofenceVehicles),callback:function ($$v) {_vm.selectedGeofenceVehicles=$$v},expression:"selectedGeofenceVehicles"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"success","flat":"","loading":_vm.updatingGeofence},on:{"click":_vm.updateGeofence}},[_vm._v("Guardar")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Cancelar")])],1)],1)],1),_vm._v(" "),_c('snackbar',{ref:"snackbar"})],1)}
var components_Geofences_staticRenderFns = []
var components_Geofences_esExports = { render: components_Geofences_render, staticRenderFns: components_Geofences_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Geofences = (components_Geofences_esExports);
// CONCATENATED MODULE: ./src/components/Geofences.vue
function components_Geofences_injectStyle (ssrContext) {
  __webpack_require__("0T0o")
}
var components_Geofences_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var components_Geofences___vue_template_functional__ = false
/* styles */
var components_Geofences___vue_styles__ = components_Geofences_injectStyle
/* scopeId */
var components_Geofences___vue_scopeId__ = "data-v-6244afdc"
/* moduleIdentifier (server only) */
var components_Geofences___vue_module_identifier__ = null
var components_Geofences_Component = components_Geofences_normalizeComponent(
  components_Geofences,
  selectortype_template_index_0_src_components_Geofences,
  components_Geofences___vue_template_functional__,
  components_Geofences___vue_styles__,
  components_Geofences___vue_scopeId__,
  components_Geofences___vue_module_identifier__
)

/* harmony default export */ var src_components_Geofences = (components_Geofences_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Maps/Routes.vue

//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Routes = ({
  name: 'routes-map',
  props: {
    routes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    drawingRoute: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      mapIsReady: false
    };
  },
  computed: {
    lineStrings: function lineStrings() {
      return this.routes.map(function (route) {
        var lineString = {
          path: [],
          id: route._id
        };
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = get_iterator_default()(route.geometry.coordinates), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var coordinate = _step.value;

            lineString.path.push({
              lat: coordinate[1],
              lng: coordinate[0]
            });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return lineString;
      });
    }
  },
  watch: {
    lineStrings: function lineStrings() {
      this.updateMapRoutes();
    },
    drawingRoute: function drawingRoute() {
      this.updateMapDrawingState();
    }
  },
  components: {
    'google-map': components_Maps_Google
  },
  methods: {
    googleMapReady: function googleMapReady() {
      this.mapIsReady = true;
      this.updateMapRoutes();
      this.updateMapDrawingState();
    },
    updateMapRoutes: function updateMapRoutes() {
      if (!this.mapIsReady) return false;
      this.$refs.googleMap.removePolylines();
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = get_iterator_default()(this.lineStrings), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var lineString = _step2.value;

          this.$refs.googleMap.setGeometryToMap(this.$refs.googleMap.createPolyline({
            polylineOptions: lineString
          }));
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    updateMapDrawingState: function updateMapDrawingState() {
      if (!this.mapIsReady || !this.drawingRoute) return false;
      this.$refs.googleMap.drawPolyline();
    },
    createLineString: function createLineString(overlayPath) {
      var lineString = {
        type: 'LineString',
        coordinates: []
      };
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = get_iterator_default()(overlayPath), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var path = _step3.value;

          var coordinate = [path.lng(), path.lat()];
          lineString.coordinates.push(coordinate);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      this.$emit('line-string-created', lineString);
    },
    lineStringClicked: function lineStringClicked(_ref) {
      var type = _ref.type,
          id = _ref.id;

      if (type !== 'Polyline') return false;
      this.$emit('line-string-clicked', id);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60f211c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Maps/Routes.vue
var Routes_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"routes-map"},[_c('google-map',{ref:"googleMap",on:{"ready":_vm.googleMapReady,"geometry-clicked":_vm.lineStringClicked,"polyline-overlay-created":_vm.createLineString}})],1)}
var Routes_staticRenderFns = []
var Routes_esExports = { render: Routes_render, staticRenderFns: Routes_staticRenderFns }
/* harmony default export */ var Maps_Routes = (Routes_esExports);
// CONCATENATED MODULE: ./src/components/Maps/Routes.vue
function Routes_injectStyle (ssrContext) {
  __webpack_require__("8eH3")
}
var Routes_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Routes___vue_template_functional__ = false
/* styles */
var Routes___vue_styles__ = Routes_injectStyle
/* scopeId */
var Routes___vue_scopeId__ = "data-v-60f211c0"
/* moduleIdentifier (server only) */
var Routes___vue_module_identifier__ = null
var Routes_Component = Routes_normalizeComponent(
  Routes,
  Maps_Routes,
  Routes___vue_template_functional__,
  Routes___vue_styles__,
  Routes___vue_scopeId__,
  Routes___vue_module_identifier__
)

/* harmony default export */ var components_Maps_Routes = (Routes_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Routes.vue



 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_Routes = ({
  name: 'routes',
  data: function data() {
    return {
      updatingRoute: false,
      drawingRoute: false,
      selectedRouteId: false,
      selectedRouteName: 'Nombre de la Ruta',
      selectedRouteVehicles: [],
      dialog: false
    };
  },
  computed: {
    vehicles: function vehicles() {
      return this.$store.state.Routes.vehicles;
    },
    shapes: function shapes() {
      return this.$store.state.Routes.shapes;
    },
    routes: function routes() {
      var routes = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(this.shapes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var shape = _step.value;

          if (shape.geometry.type === 'LineString') {
            routes.push(shape);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return routes;
    }
  },
  components: {
    'routes-map': components_Maps_Routes,
    'snackbar': src_components_Snackbar
  },
  created: function () {
    var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return this.$store.dispatch('Routes/fetchShapes');

            case 3:
              _context.next = 5;
              return this.$store.dispatch('Routes/fetchVehicles');

            case 5:
              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context['catch'](0);

              console.error(_context.t0);
              this.$refs.snackbar.open('error', 'No se logró establecer conexión con el servidor');

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 7]]);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    openRouteDialog: function openRouteDialog(routeId) {
      var route = find_default()(this.routes, { _id: routeId });
      this.selectedRouteId = route._id;
      this.selectedRouteName = route.name;
      this.selectedRouteVehicles = route.vehicles;
      this.dialog = true;
    },
    createRoute: function () {
      var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(lineString) {
        var route;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.drawingRoute = false;
                route = {
                  geometry: lineString,
                  name: 'Sin Título',
                  vehicles: []
                };
                _context2.prev = 2;
                _context2.next = 5;
                return this.$store.dispatch('Routes/createShape', {
                  shape: route
                });

              case 5:
                _context2.next = 11;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](2);

                console.error(_context2.t0);
                return _context2.abrupt('return', this.$refs.snackbar.open('error', 'Ocurrió un error mientras se creaba la ruta'));

              case 11:
                this.$refs.snackbar.open('success', 'Ruta creada');

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 7]]);
      }));

      function createRoute(_x) {
        return _ref2.apply(this, arguments);
      }

      return createRoute;
    }(),
    updateRoute: function () {
      var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.updatingRoute = true;
                _context3.prev = 1;
                _context3.next = 4;
                return this.$store.dispatch('Routes/updateShape', {
                  shapeId: this.selectedRouteId,
                  shape: {
                    name: this.selectedRouteName,
                    vehicles: this.selectedRouteVehicles
                  }
                });

              case 4:
                _context3.next = 11;
                break;

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3['catch'](1);

                this.updatingRoute = false;
                console.error(_context3.t0);
                return _context3.abrupt('return', this.$refs.snackbar.open('error', 'Ocurrió un error mientras se actualizaba la ruta'));

              case 11:
                this.updatingRoute = false;
                this.dialog = false;
                this.selectedRouteId = false;
                this.selectedRouteName = '';
                this.selectedRouteVehicles = [];
                this.$refs.snackbar.open('success', 'Ruta actualizada');

              case 17:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 6]]);
      }));

      function updateRoute() {
        return _ref3.apply(this, arguments);
      }

      return updateRoute;
    }(),
    removeRoute: function () {
      var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var shapeId;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                shapeId = this.selectedRouteId;
                _context4.prev = 1;
                _context4.next = 4;
                return this.$store.dispatch('Routes/removeShape', {
                  shapeId: shapeId
                });

              case 4:
                _context4.next = 10;
                break;

              case 6:
                _context4.prev = 6;
                _context4.t0 = _context4['catch'](1);

                console.error(_context4.t0);
                return _context4.abrupt('return', this.$refs.snackbar.open('error', 'Ocurrió un error mientras se eliminaba la ruta'));

              case 10:
                this.dialog = false;
                this.selectedRouteId = false;
                this.selectedRouteName = false;
                this.selectedRouteVehicles = [];
                this.$refs.snackbar.open('success', 'Ruta eliminada');

              case 15:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 6]]);
      }));

      function removeRoute() {
        return _ref4.apply(this, arguments);
      }

      return removeRoute;
    }()
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70ba1fd4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Routes.vue
var components_Routes_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"routes"},[_c('div',{staticClass:"map-wrapper"},[_c('div',{staticClass:"over-map-content"},[_c('v-btn',{staticClass:"mr-5 mb-4",attrs:{"color":"primary","dark":"","fab":"","fixed":"","bottom":"","right":""},nativeOn:{"click":function($event){_vm.drawingRoute = true}}},[_c('v-icon',[_vm._v("add")])],1)],1),_vm._v(" "),_c('routes-map',{attrs:{"routes":_vm.routes,"drawing-route":_vm.drawingRoute},on:{"line-string-created":_vm.createRoute,"line-string-clicked":_vm.openRouteDialog}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":620},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_c('v-icon',[_vm._v("navigation")]),_vm._v("\n          Ruta "+_vm._s(_vm.selectedRouteName)+"\n        ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{attrs:{"offset-y":"","bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":_vm.removeRoute}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("delete")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                  Eliminar Ruta\n                ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Nombre","prepend-icon":"navigation"},model:{value:(_vm.selectedRouteName),callback:function ($$v) {_vm.selectedRouteName=$$v},expression:"selectedRouteName"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.vehicles,"item-text":"plate","item-value":"_id","multiple":"","label":"Vehículos","prepend-icon":"directions_car"},model:{value:(_vm.selectedRouteVehicles),callback:function ($$v) {_vm.selectedRouteVehicles=$$v},expression:"selectedRouteVehicles"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"success","flat":"","loading":_vm.updatingRoute},on:{"click":_vm.updateRoute}},[_vm._v("Guardar")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Cancelar")])],1)],1)],1),_vm._v(" "),_c('snackbar',{ref:"snackbar"})],1)}
var components_Routes_staticRenderFns = []
var components_Routes_esExports = { render: components_Routes_render, staticRenderFns: components_Routes_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Routes = (components_Routes_esExports);
// CONCATENATED MODULE: ./src/components/Routes.vue
function components_Routes_injectStyle (ssrContext) {
  __webpack_require__("MtuX")
}
var components_Routes_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var components_Routes___vue_template_functional__ = false
/* styles */
var components_Routes___vue_styles__ = components_Routes_injectStyle
/* scopeId */
var components_Routes___vue_scopeId__ = "data-v-70ba1fd4"
/* moduleIdentifier (server only) */
var components_Routes___vue_module_identifier__ = null
var components_Routes_Component = components_Routes_normalizeComponent(
  components_Routes,
  selectortype_template_index_0_src_components_Routes,
  components_Routes___vue_template_functional__,
  components_Routes___vue_styles__,
  components_Routes___vue_scopeId__,
  components_Routes___vue_module_identifier__
)

/* harmony default export */ var src_components_Routes = (components_Routes_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Maps/Places.vue

//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Places = ({
  name: 'places-map',
  props: {
    places: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    drawingPlace: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      mapIsReady: false
    };
  },
  computed: {
    points: function points() {
      return this.places.map(function (place) {
        return {
          position: {
            lat: place.geometry.coordinates[1],
            lng: place.geometry.coordinates[0]
          },
          id: place._id
        };
      });
    }
  },
  watch: {
    points: function points(_points) {
      this.updateMapPlaces();
    },
    drawingPlace: function drawingPlace() {
      this.updateMapDrawingState();
    }
  },
  components: {
    'google-map': components_Maps_Google
  },
  methods: {
    googleMapReady: function googleMapReady() {
      this.mapIsReady = true;
      this.updateMapPlaces();
      this.updateMapDrawingState();
    },
    updateMapPlaces: function updateMapPlaces() {
      if (!this.mapIsReady) return false;
      this.$refs.googleMap.removeMarkers();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(this.points), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var point = _step.value;

          this.$refs.googleMap.setGeometryToMap(this.$refs.googleMap.createMarker({
            markerOptions: point
          }));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    updateMapDrawingState: function updateMapDrawingState() {
      if (!this.mapIsReady || !this.drawingPlace) return false;
      this.$refs.googleMap.drawMarker();
    },
    createPoint: function createPoint(position) {
      var point = {
        type: 'Point',
        coordinates: [position.lng(), position.lat()]
      };
      this.$emit('point-created', point);
    },
    pointClicked: function pointClicked(_ref) {
      var type = _ref.type,
          id = _ref.id;

      if (type !== 'Marker') return false;
      this.$emit('point-clicked', id);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ae8e9b14","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Maps/Places.vue
var Places_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"places-map"},[_c('google-map',{ref:"googleMap",on:{"ready":_vm.googleMapReady,"geometry-clicked":_vm.pointClicked,"marker-created":_vm.createPoint}})],1)}
var Places_staticRenderFns = []
var Places_esExports = { render: Places_render, staticRenderFns: Places_staticRenderFns }
/* harmony default export */ var Maps_Places = (Places_esExports);
// CONCATENATED MODULE: ./src/components/Maps/Places.vue
function Places_injectStyle (ssrContext) {
  __webpack_require__("EimW")
}
var Places_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Places___vue_template_functional__ = false
/* styles */
var Places___vue_styles__ = Places_injectStyle
/* scopeId */
var Places___vue_scopeId__ = "data-v-ae8e9b14"
/* moduleIdentifier (server only) */
var Places___vue_module_identifier__ = null
var Places_Component = Places_normalizeComponent(
  Places,
  Maps_Places,
  Places___vue_template_functional__,
  Places___vue_styles__,
  Places___vue_scopeId__,
  Places___vue_module_identifier__
)

/* harmony default export */ var components_Maps_Places = (Places_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Places.vue



 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_Places = ({
  name: 'places',
  data: function data() {
    return {
      updatingPlace: false,
      drawingPlace: false,
      selectedPlaceId: false,
      selectedPlaceName: 'Nombre del Lugar',
      dialog: false
    };
  },
  computed: {
    shapes: function shapes() {
      return this.$store.state.Places.shapes;
    },
    places: function places() {
      var places = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(this.shapes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var shape = _step.value;

          if (shape.geometry.type === 'Point') {
            places.push(shape);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return places;
    }
  },
  components: {
    'places-map': components_Maps_Places,
    'snackbar': src_components_Snackbar
  },
  created: function () {
    var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return this.$store.dispatch('Places/fetchShapes');

            case 3:
              _context.next = 9;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context['catch'](0);

              console.error(_context.t0);
              this.$refs.snackbar.open('error', 'No se logró establecer conexión con el servidor');

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 5]]);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    openPlaceDialog: function openPlaceDialog(placeId) {
      var place = find_default()(this.places, { _id: placeId });
      this.selectedPlaceId = place._id;
      this.selectedPlaceName = place.name;
      this.dialog = true;
    },
    createPlace: function () {
      var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(point) {
        var place;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.drawingPlace = false;
                place = {
                  geometry: point,
                  name: 'Sin Título'
                };
                _context2.prev = 2;
                _context2.next = 5;
                return this.$store.dispatch('Places/createShape', {
                  shape: place
                });

              case 5:
                _context2.next = 11;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](2);

                console.error(_context2.t0);
                return _context2.abrupt('return', this.$refs.snackbar.open('error', 'Ocurrió un error mientras se creaba el lugar'));

              case 11:
                this.$refs.snackbar.open('success', 'Lugar creado');

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 7]]);
      }));

      function createPlace(_x) {
        return _ref2.apply(this, arguments);
      }

      return createPlace;
    }(),
    updatePlace: function () {
      var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.updatingPlace = true;
                _context3.prev = 1;
                _context3.next = 4;
                return this.$store.dispatch('Places/updateShape', {
                  shapeId: this.selectedPlaceId,
                  shape: {
                    name: this.selectedPlaceName
                  }
                });

              case 4:
                _context3.next = 11;
                break;

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3['catch'](1);

                this.updatingPlace = false;
                console.error(_context3.t0);
                return _context3.abrupt('return', this.$refs.snackbar.open('error', 'Ocurrió un error mientras se actualizaba el lugar'));

              case 11:
                this.updatingPlace = false;
                this.dialog = false;
                this.selectedPlaceId = false;
                this.selectedPlaceName = '';
                this.$refs.snackbar.open('success', 'Lugar actualizado');

              case 16:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 6]]);
      }));

      function updatePlace() {
        return _ref3.apply(this, arguments);
      }

      return updatePlace;
    }(),
    removePlace: function () {
      var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var shapeId;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                shapeId = this.selectedPlaceId;
                _context4.prev = 1;
                _context4.next = 4;
                return this.$store.dispatch('Places/removeShape', {
                  shapeId: shapeId
                });

              case 4:
                _context4.next = 10;
                break;

              case 6:
                _context4.prev = 6;
                _context4.t0 = _context4['catch'](1);

                console.error(_context4.t0);
                return _context4.abrupt('return', this.$refs.snackbar.open('error', 'Ocurrió un error mientras se eliminaba el lugar'));

              case 10:
                this.dialog = false;
                this.selectedPlaceId = false;
                this.selectedPlaceName = false;
                this.$refs.snackbar.open('success', 'Lugar eliminado');

              case 14:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 6]]);
      }));

      function removePlace() {
        return _ref4.apply(this, arguments);
      }

      return removePlace;
    }()
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9aaef454","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Places.vue
var components_Places_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"places"},[_c('div',{staticClass:"map-wrapper"},[_c('div',{staticClass:"over-map-content"},[_c('v-btn',{staticClass:"mr-5 mb-4",attrs:{"color":"primary","dark":"","fab":"","fixed":"","bottom":"","right":""},nativeOn:{"click":function($event){_vm.drawingPlace = true}}},[_c('v-icon',[_vm._v("add")])],1)],1),_vm._v(" "),_c('places-map',{attrs:{"places":_vm.places,"drawing-place":_vm.drawingPlace},on:{"point-created":_vm.createPlace,"point-clicked":_vm.openPlaceDialog}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":620},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_c('v-icon',[_vm._v("place")]),_vm._v("\n          Lugar "+_vm._s(_vm.selectedPlaceName)+"\n        ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{attrs:{"offset-y":"","bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":_vm.removePlace}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("delete")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                  Eliminar Lugar\n                ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Nombre","prepend-icon":"place"},model:{value:(_vm.selectedPlaceName),callback:function ($$v) {_vm.selectedPlaceName=$$v},expression:"selectedPlaceName"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"success","flat":"","loading":_vm.updatingPlace},on:{"click":_vm.updatePlace}},[_vm._v("Guardar")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Cancelar")])],1)],1)],1),_vm._v(" "),_c('snackbar',{ref:"snackbar"})],1)}
var components_Places_staticRenderFns = []
var components_Places_esExports = { render: components_Places_render, staticRenderFns: components_Places_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Places = (components_Places_esExports);
// CONCATENATED MODULE: ./src/components/Places.vue
function components_Places_injectStyle (ssrContext) {
  __webpack_require__("6gsQ")
}
var components_Places_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var components_Places___vue_template_functional__ = false
/* styles */
var components_Places___vue_styles__ = components_Places_injectStyle
/* scopeId */
var components_Places___vue_scopeId__ = "data-v-9aaef454"
/* moduleIdentifier (server only) */
var components_Places___vue_module_identifier__ = null
var components_Places_Component = components_Places_normalizeComponent(
  components_Places,
  selectortype_template_index_0_src_components_Places,
  components_Places___vue_template_functional__,
  components_Places___vue_styles__,
  components_Places___vue_scopeId__,
  components_Places___vue_module_identifier__
)

/* harmony default export */ var src_components_Places = (components_Places_Component.exports);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Reports/Indicator.vue
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Indicator = ({
  name: 'indicator',
  props: {
    title: String,
    value: [String, Number]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74416348","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reports/Indicator.vue
var Indicator_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":"","sm6":"","lg4":"","xl3":""}},[_c('v-card',{staticClass:"ma-3"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('h5',{staticClass:"headline"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('v-card-text',[_c('h2',{staticClass:"display-3 text-xs-center"},[_vm._v(_vm._s(_vm.value))])])],1)],1)}
var Indicator_staticRenderFns = []
var Indicator_esExports = { render: Indicator_render, staticRenderFns: Indicator_staticRenderFns }
/* harmony default export */ var Reports_Indicator = (Indicator_esExports);
// CONCATENATED MODULE: ./src/components/Reports/Indicator.vue
var Indicator_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Indicator___vue_template_functional__ = false
/* styles */
var Indicator___vue_styles__ = null
/* scopeId */
var Indicator___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Indicator___vue_module_identifier__ = null
var Indicator_Component = Indicator_normalizeComponent(
  Indicator,
  Reports_Indicator,
  Indicator___vue_template_functional__,
  Indicator___vue_styles__,
  Indicator___vue_scopeId__,
  Indicator___vue_module_identifier__
)

/* harmony default export */ var components_Reports_Indicator = (Indicator_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Reports/Actions.vue

 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Actions = ({
  name: 'actions',
  props: {
    reportRange: String,
    vehicles: Array
  },
  data: function data() {
    return {
      selectedVehicle: null
    };
  },
  computed: {
    vehiclesPlates: function vehiclesPlates() {
      var vehiclesPlates = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(this.vehicles), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var vehicle = _step.value;

          vehiclesPlates.push(vehicle.plate);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return vehiclesPlates;
    }
  },
  watch: {
    selectedVehicle: function selectedVehicle(_selectedVehicle) {
      var vehicle = find_default()(this.vehicles, { plate: _selectedVehicle });
      if (!vehicle) {
        return false;
      }
      this.$emit('update-selected-vehicle', vehicle);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b38a3e9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reports/Actions.vue
var Actions_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm9":"","offset-sm3":"","md6":"","offset-md6":"","xl4":"","offset-xl8":""}},[_c('v-card',{staticClass:"ma-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":"","justify-space-around":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-autocomplete',{attrs:{"items":_vm.vehiclesPlates,"prepend-icon":"directions_car","label":"Vehículos","single-line":""},model:{value:(_vm.selectedVehicle),callback:function ($$v) {_vm.selectedVehicle=$$v},expression:"selectedVehicle"}})],1),_vm._v(" "),_c('v-btn',{attrs:{"dark":_vm.reportRange === 'today',"outline":_vm.reportRange !== 'today',"color":"primary","fab":"","small":""},on:{"click":function($event){return _vm.$emit('today-report-range')}}},[_c('v-icon',[_vm._v("today")])],1),_vm._v(" "),_c('v-btn',{attrs:{"dark":_vm.reportRange === 'custom',"outline":_vm.reportRange !== 'custom',"color":"primary","fab":"","small":""},on:{"click":function($event){return _vm.$emit('custom-report-range')}}},[_c('v-icon',[_vm._v("build")])],1),_vm._v(" "),_c('v-menu',{attrs:{"offset-y":"","bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.$emit('download-spreadsheet')}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                Descargar Hoja de Cálculo\n              ")])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.$emit('download-csv')}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                Descargar CSV\n              ")])],1)],1)],1)],1)],1)],1)],1)],1)],1)}
var Actions_staticRenderFns = []
var Actions_esExports = { render: Actions_render, staticRenderFns: Actions_staticRenderFns }
/* harmony default export */ var Reports_Actions = (Actions_esExports);
// CONCATENATED MODULE: ./src/components/Reports/Actions.vue
var Actions_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Actions___vue_template_functional__ = false
/* styles */
var Actions___vue_styles__ = null
/* scopeId */
var Actions___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Actions___vue_module_identifier__ = null
var Actions_Component = Actions_normalizeComponent(
  Actions,
  Reports_Actions,
  Actions___vue_template_functional__,
  Actions___vue_styles__,
  Actions___vue_scopeId__,
  Actions___vue_module_identifier__
)

/* harmony default export */ var components_Reports_Actions = (Actions_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Reports/CustomRange.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var CustomRange = ({
  name: 'custom-range',
  data: function data() {
    return {
      startDate: null,
      startTime: null,
      startDateDialog: false,
      startTimeDialog: false,
      finishDate: null,
      finishTime: null,
      finishDateDialog: false,
      finishTimeDialog: false
    };
  },
  computed: {
    allowedStartDates: function allowedStartDates() {
      var min = moment_default()().subtract(6, 'months').toDate().toISOString().substr(0, 10);
      var max = moment_default()().toDate().toISOString().substr(0, 10);
      return { min: min, max: max };
    },
    allowedFinishDates: function allowedFinishDates() {
      var startDateAndTime = this.startDateAndTime;
      if (!this.startDateAndTime) {
        return { min: null, max: null };
      }
      var thisMonth = moment_default()().month();
      var min = startDateAndTime.toDate().toISOString().substr(0, 10);
      var max = void 0;
      if (startDateAndTime.month() === thisMonth) {
        max = moment_default()().toDate().toISOString().substr(0, 10);
      } else {
        max = startDateAndTime.endOf('month').toDate().toISOString().substr(0, 10);
      }
      return { min: min, max: max };
    },
    startDateAndTime: function startDateAndTime() {
      if (!this.startDate || !this.startTime) {
        return null;
      }
      return moment_default()(this.startDate + ' ' + this.startTime, 'YYYY-MM-DD h:mmA');
    },
    finishDateAndTime: function finishDateAndTime() {
      if (!this.finishDate || !this.finishTime) {
        return null;
      }
      return moment_default()(this.finishDate + ' ' + this.finishTime, 'YYYY-MM-DD h:mmA');
    }
  },
  watch: {
    startDate: function startDate() {
      this.finishDate = null;
      this.$emit('update-finish-date', null);
      this.getStartDateAndTime();
    },
    startTime: function startTime() {
      this.getStartDateAndTime();
    },
    finishDate: function finishDate() {
      this.getFinishDateAndTime();
    },
    finishTime: function finishTime() {
      this.getFinishDateAndTime();
    }
  },
  methods: {
    getStartDateAndTime: function getStartDateAndTime() {
      var startDateAndTime = this.startDateAndTime;
      if (!startDateAndTime) {
        this.$emit('update-start-date', null);
      } else {
        this.$emit('update-start-date', startDateAndTime.valueOf());
      }
    },
    getFinishDateAndTime: function getFinishDateAndTime() {
      var finishDateAndTime = this.finishDateAndTime;
      if (!finishDateAndTime) {
        this.$emit('update-finish-date', null);
      } else {
        this.$emit('update-finish-date', finishDateAndTime.valueOf());
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bc60017","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reports/CustomRange.vue
var CustomRange_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"ma-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":"","justify-space-around":""}},[_c('v-flex',{attrs:{"xs12":"","sm2":"","xl1":""}},[_c('v-subheader',{staticClass:"mt-2"},[_vm._v("Desde")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs10":"","sm4":""}},[_c('v-dialog',{attrs:{"lazy":"","full-width":"","width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Fecha","prepend-icon":"event","readonly":""},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}},on))]}}]),model:{value:(_vm.startDateDialog),callback:function ($$v) {_vm.startDateDialog=$$v},expression:"startDateDialog"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"es-co","min":_vm.allowedStartDates.min,"max":_vm.allowedStartDates.max,"scrollable":"","autosave":""},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs10":"","sm5":"","offset-sm1":""}},[_c('v-dialog',{attrs:{"lazy":"","full-width":"","width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"slot":"activator","label":"Hora","prepend-icon":"access_time","readonly":""},slot:"activator",model:{value:(_vm.startTime),callback:function ($$v) {_vm.startTime=$$v},expression:"startTime"}},on))]}}]),model:{value:(_vm.startTimeDialog),callback:function ($$v) {_vm.startTimeDialog=$$v},expression:"startTimeDialog"}},[_vm._v(" "),_c('v-time-picker',{attrs:{"autosave":""},model:{value:(_vm.startTime),callback:function ($$v) {_vm.startTime=$$v},expression:"startTime"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify-space-around":""}},[_c('v-flex',{attrs:{"xs12":"","sm2":"","xl1":""}},[_c('v-subheader',{staticClass:"mt-2"},[_vm._v("Hasta")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs10":"","sm4":""}},[_c('v-dialog',{attrs:{"lazy":"","full-width":"","width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Fecha","prepend-icon":"event","readonly":""},model:{value:(_vm.finishDate),callback:function ($$v) {_vm.finishDate=$$v},expression:"finishDate"}},on))]}}]),model:{value:(_vm.finishDateDialog),callback:function ($$v) {_vm.finishDateDialog=$$v},expression:"finishDateDialog"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"es-co","min":_vm.allowedFinishDates.min,"max":_vm.allowedFinishDates.max,"scrollable":"","autosave":""},model:{value:(_vm.finishDate),callback:function ($$v) {_vm.finishDate=$$v},expression:"finishDate"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs10":"","sm5":"","offset-sm1":""}},[_c('v-dialog',{attrs:{"lazy":"","full-width":"","width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Hora","prepend-icon":"access_time","readonly":""},model:{value:(_vm.finishTime),callback:function ($$v) {_vm.finishTime=$$v},expression:"finishTime"}},on))]}}]),model:{value:(_vm.finishTimeDialog),callback:function ($$v) {_vm.finishTimeDialog=$$v},expression:"finishTimeDialog"}},[_vm._v(" "),_c('v-time-picker',{attrs:{"autosave":""},model:{value:(_vm.finishTime),callback:function ($$v) {_vm.finishTime=$$v},expression:"finishTime"}})],1)],1)],1)],1)],1)],1)],1)}
var CustomRange_staticRenderFns = []
var CustomRange_esExports = { render: CustomRange_render, staticRenderFns: CustomRange_staticRenderFns }
/* harmony default export */ var Reports_CustomRange = (CustomRange_esExports);
// CONCATENATED MODULE: ./src/components/Reports/CustomRange.vue
var CustomRange_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CustomRange___vue_template_functional__ = false
/* styles */
var CustomRange___vue_styles__ = null
/* scopeId */
var CustomRange___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CustomRange___vue_module_identifier__ = null
var CustomRange_Component = CustomRange_normalizeComponent(
  CustomRange,
  Reports_CustomRange,
  CustomRange___vue_template_functional__,
  CustomRange___vue_styles__,
  CustomRange___vue_scopeId__,
  CustomRange___vue_module_identifier__
)

/* harmony default export */ var components_Reports_CustomRange = (CustomRange_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Reports/EventsTable.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EventsTable = ({
  name: 'events-table',
  props: {
    loading: Boolean,
    events: Array,
    totalEvents: Number
  },
  data: function data() {
    return {
      pagination: {},
      headers: [{ text: 'Fecha', align: 'left', sortable: false }, { text: 'Evento', sortable: false }],
      noDataText: 'No hay eventos para mostrar',
      noResultsText: 'No se han encontrado coincidencias',
      rowsPerPageText: 'Filas por página:',
      rowsPerPageItems: [5, 15, 25, 50, 75, 100]
    };
  },
  watch: {
    pagination: function pagination(_pagination) {
      var page = _pagination.page,
          rowsPerPage = _pagination.rowsPerPage;

      this.$emit('update-pagination', { page: page, rowsPerPage: rowsPerPage });
    }
  },
  mounted: function mounted() {
    var _pagination2 = this.pagination,
        page = _pagination2.page,
        rowsPerPage = _pagination2.rowsPerPage;

    this.$emit('update-pagination', { page: page, rowsPerPage: rowsPerPage });
  },
  components: {
    'event-dialog': src_components_EventDialog
  },
  methods: {
    openEventDialog: function openEventDialog(_ref) {
      var _id = _ref._id;

      console.log('event dialog...');
      console.log(_id);
      this.$refs.eventDialog.open({ eventId: _id });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c742717","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reports/EventsTable.vue
var EventsTable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-3"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('h5',{staticClass:"headline"},[_vm._v("Eventos")])]),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{attrs:{"headers":_vm.headers,"pagination":_vm.pagination,"items":_vm.events,"total-items":_vm.totalEvents,"loading":_vm.loading,"no-data-text":_vm.noDataText,"no-results-text":_vm.noResultsText,"rows-per-page-text":_vm.rowsPerPageText,"rows-per-page-items":_vm.rowsPerPageItems},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{on:{"click":function($event){return _vm.openEventDialog({ _id: props.item._id })}}},[_c('td',[_vm._v(_vm._s(new Date(props.item.data.gps.date).toLocaleString()))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.name))])])]}}])})],1),_vm._v(" "),_c('event-dialog',{ref:"eventDialog"})],1)}
var EventsTable_staticRenderFns = []
var EventsTable_esExports = { render: EventsTable_render, staticRenderFns: EventsTable_staticRenderFns }
/* harmony default export */ var Reports_EventsTable = (EventsTable_esExports);
// CONCATENATED MODULE: ./src/components/Reports/EventsTable.vue
var EventsTable_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var EventsTable___vue_template_functional__ = false
/* styles */
var EventsTable___vue_styles__ = null
/* scopeId */
var EventsTable___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EventsTable___vue_module_identifier__ = null
var EventsTable_Component = EventsTable_normalizeComponent(
  EventsTable,
  Reports_EventsTable,
  EventsTable___vue_template_functional__,
  EventsTable___vue_styles__,
  EventsTable___vue_scopeId__,
  EventsTable___vue_module_identifier__
)

/* harmony default export */ var components_Reports_EventsTable = (EventsTable_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Reports.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var Reports = ({
  name: 'reports',
  data: function data() {
    return {
      selectedVehicle: null,
      loading: false,
      reportRange: 'today',
      eventsTablePagination: {},
      startDate: moment_default()().startOf('date').valueOf(),
      finishDate: moment_default()().endOf('date').valueOf()
    };
  },
  computed: {
    vehicles: function vehicles() {
      return this.$store.state.Reports.vehicles;
    },
    events: function events() {
      return this.$store.state.Reports.events;
    },
    totalEvents: function totalEvents() {
      return this.$store.state.Reports.totalEvents;
    },
    indicators: function indicators() {
      return this.$store.state.Reports.indicators;
    }
  },
  watch: {
    reportRange: function reportRange(_reportRange) {
      if (_reportRange === 'today') {
        this.startDate = moment_default()().startOf('date').valueOf();
        this.finishDate = moment_default()().endOf('date').valueOf();
      }
    },
    selectedVehicle: function selectedVehicle() {
      this.fetchEvents();
      this.fetchIndicators();
    },
    eventsTablePagination: function eventsTablePagination() {
      this.fetchEvents();
      this.fetchIndicators();
    },
    startDate: function startDate() {
      this.fetchEvents();
      this.fetchIndicators();
    },
    finishDate: function finishDate() {
      this.fetchEvents();
      this.fetchIndicators();
    }
  },
  components: {
    'indicator': components_Reports_Indicator,
    'actions': components_Reports_Actions,
    'custom-range': components_Reports_CustomRange,
    'events-table': components_Reports_EventsTable
  },
  mounted: function mounted() {
    this.$store.dispatch('Reports/fetchVehicles');
  },
  methods: {
    downloadCsv: function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var response, data, mime, filename, blob, blobURL, tempLink;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$store.dispatch('Reports/downloadCsv', {
                  vehicleId: this.selectedVehicle._id,
                  startDate: this.startDate,
                  finishDate: this.finishDate
                });

              case 2:
                response = _context.sent;

                if (response) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return', false);

              case 5:
                data = response.data, mime = response.mime, filename = response.filename;
                blob = new Blob([data], { type: mime });
                blobURL = window.URL.createObjectURL(blob);
                tempLink = document.createElement('a');

                tempLink.style.display = 'none';
                tempLink.href = blobURL;
                tempLink.setAttribute('download', filename);
                document.body.appendChild(tempLink);
                tempLink.click();
                document.body.removeChild(tempLink);
                window.URL.revokeObjectURL(blobURL);

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function downloadCsv() {
        return _ref.apply(this, arguments);
      }

      return downloadCsv;
    }(),
    downloadSpreadsheet: function () {
      var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var response, data, mime, filename, blob, blobURL, tempLink;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.$store.dispatch('Reports/downloadSpreadsheet', {
                  vehicleId: this.selectedVehicle._id,
                  startDate: this.startDate,
                  finishDate: this.finishDate
                });

              case 2:
                response = _context2.sent;

                if (response) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt('return', false);

              case 5:
                data = response.data, mime = response.mime, filename = response.filename;
                blob = new Blob([data], { type: mime });
                blobURL = window.URL.createObjectURL(blob);
                tempLink = document.createElement('a');

                tempLink.style.display = 'none';
                tempLink.href = blobURL;
                tempLink.setAttribute('download', filename);
                document.body.appendChild(tempLink);
                tempLink.click();
                document.body.removeChild(tempLink);
                window.URL.revokeObjectURL(blobURL);

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function downloadSpreadsheet() {
        return _ref2.apply(this, arguments);
      }

      return downloadSpreadsheet;
    }(),
    updateSelectedVehicle: function updateSelectedVehicle(vehicle) {
      this.selectedVehicle = vehicle;
    },
    updateStartDate: function updateStartDate(date) {
      this.startDate = date;
    },
    updateFinishDate: function updateFinishDate(date) {
      this.finishDate = date;
    },
    updateEventsTablePagination: function updateEventsTablePagination(_ref3) {
      var page = _ref3.page,
          rowsPerPage = _ref3.rowsPerPage;

      this.eventsTablePagination = { page: page, rowsPerPage: rowsPerPage };
    },
    fetchIndicators: function fetchIndicators() {
      if (!this.selectedVehicle || !this.startDate || !this.finishDate) {
        return false;
      }
      var dispatchData = {
        vehicleId: this.selectedVehicle._id,
        mark: this.selectedVehicle.device.type.mark,
        reference: this.selectedVehicle.device.type.reference,
        startDate: this.startDate,
        finishDate: this.finishDate
      };
      this.$store.dispatch('Reports/fetchIndicators', dispatchData);
    },
    fetchEvents: function () {
      var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var _eventsTablePaginatio, page, rowsPerPage;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!this.selectedVehicle || !this.startDate || !this.finishDate)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return', false);

              case 2:
                _eventsTablePaginatio = this.eventsTablePagination, page = _eventsTablePaginatio.page, rowsPerPage = _eventsTablePaginatio.rowsPerPage;

                this.loading = true;
                _context3.next = 6;
                return this.$store.dispatch('Reports/countEvents', {
                  vehicleId: this.selectedVehicle._id,
                  startDate: this.startDate,
                  finishDate: this.finishDate
                });

              case 6:
                if (!(rowsPerPage !== -1)) {
                  _context3.next = 11;
                  break;
                }

                _context3.next = 9;
                return this.$store.dispatch('Reports/fetchPaginatedEvents', {
                  vehicleId: this.selectedVehicle._id,
                  startDate: this.startDate,
                  finishDate: this.finishDate,
                  page: page,
                  rowsPerPage: rowsPerPage
                });

              case 9:
                _context3.next = 13;
                break;

              case 11:
                _context3.next = 13;
                return this.$store.dispatch('Reports/fetchEvents', {
                  vehicleId: this.selectedVehicle._id,
                  startDate: this.startDate,
                  finishDate: this.finishDate
                });

              case 13:
                this.loading = false;

              case 14:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchEvents() {
        return _ref4.apply(this, arguments);
      }

      return fetchEvents;
    }()
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abb018e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Reports.vue
var Reports_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"navigation-drawer-view"}},[_c('v-container',{attrs:{"fluid":""}},[_c('actions',{attrs:{"reportRange":_vm.reportRange,"vehicles":_vm.vehicles},on:{"download-spreadsheet":_vm.downloadSpreadsheet,"download-csv":_vm.downloadCsv,"update-selected-vehicle":_vm.updateSelectedVehicle,"today-report-range":function($event){_vm.reportRange = 'today'},"custom-report-range":function($event){_vm.reportRange = 'custom'}}}),_vm._v(" "),(_vm.reportRange === 'custom')?_c('custom-range',{on:{"update-start-date":_vm.updateStartDate,"update-finish-date":_vm.updateFinishDate}}):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.indicators),function(indicator,index){return _c('indicator',{key:index,attrs:{"title":indicator.name,"value":indicator.value}})}),1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('events-table',{attrs:{"events":_vm.events,"totalEvents":_vm.totalEvents,"loading":_vm.loading},on:{"update-pagination":_vm.updateEventsTablePagination}})],1)],1)],1)],1)}
var Reports_staticRenderFns = []
var Reports_esExports = { render: Reports_render, staticRenderFns: Reports_staticRenderFns }
/* harmony default export */ var views_Reports = (Reports_esExports);
// CONCATENATED MODULE: ./src/views/Reports.vue
var Reports_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Reports___vue_template_functional__ = false
/* styles */
var Reports___vue_styles__ = null
/* scopeId */
var Reports___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Reports___vue_module_identifier__ = null
var Reports_Component = Reports_normalizeComponent(
  Reports,
  views_Reports,
  Reports___vue_template_functional__,
  Reports___vue_styles__,
  Reports___vue_scopeId__,
  Reports___vue_module_identifier__
)

/* harmony default export */ var src_views_Reports = (Reports_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Travels/Map.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Map = ({
  name: 'interactive-report-map',
  props: {
    travelSteps: Array
  },
  computed: {
    polylineOptions: function polylineOptions() {
      var polylineOptions = {
        path: []
      };
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(this.travelSteps), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var step = _step.value;

          polylineOptions.path.push(step.latLng);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return polylineOptions;
    },
    markersOptions: function markersOptions() {
      var markersOptions = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = get_iterator_default()(this.travelSteps), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var step = _step2.value;

          markersOptions.push({
            position: step.latLng,
            data: {
              eventId: step.eventId
            }
          });
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return markersOptions;
    }
  },
  watch: {
    travelSteps: function travelSteps() {
      this.setUpTravel();
    }
  },
  components: {
    'google-map': components_Maps_Google
  },
  methods: {
    googleMapReady: function googleMapReady() {
      if (this.travelSteps.length > 0) {
        this.setUpTravel();
      }
    },
    geometryClicked: function geometryClicked(geometry) {
      if (geometry.type !== 'Marker') {
        return false;
      }
      this.$emit('open-event-dialog', { eventId: geometry.data.eventId });
    },
    setUpTravel: function setUpTravel() {
      // Handle empty travel
      if (this.travelSteps.length === 0) {
        console.log('No hay eventos para mostrar');
        return false;
      }
      var googleMap = this.$refs.googleMap;
      googleMap.removeMarkers();
      googleMap.removePolylines();
      var polyline = googleMap.createPolyline({
        polylineOptions: this.polylineOptions
      });
      googleMap.setGeometryToMap(polyline);
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = get_iterator_default()(this.markersOptions), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var markerOptions = _step3.value;

          var marker = googleMap.createMarker({ markerOptions: markerOptions });
          googleMap.setGeometryToMap(marker);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var lastTravelStep = this.travelSteps[this.travelSteps.length - 1];
      googleMap.panTo(lastTravelStep.latLng);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86cfc33e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Travels/Map.vue
var Map_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interactive-report-map"},[_c('google-map',{ref:"googleMap",on:{"ready":_vm.googleMapReady,"geometry-clicked":_vm.geometryClicked}})],1)}
var Map_staticRenderFns = []
var Map_esExports = { render: Map_render, staticRenderFns: Map_staticRenderFns }
/* harmony default export */ var Travels_Map = (Map_esExports);
// CONCATENATED MODULE: ./src/components/Travels/Map.vue
function Map_injectStyle (ssrContext) {
  __webpack_require__("ZU8t")
}
var Map_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Map___vue_template_functional__ = false
/* styles */
var Map___vue_styles__ = Map_injectStyle
/* scopeId */
var Map___vue_scopeId__ = "data-v-86cfc33e"
/* moduleIdentifier (server only) */
var Map___vue_module_identifier__ = null
var Map_Component = Map_normalizeComponent(
  Map,
  Travels_Map,
  Map___vue_template_functional__,
  Map___vue_styles__,
  Map___vue_scopeId__,
  Map___vue_module_identifier__
)

/* harmony default export */ var components_Travels_Map = (Map_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Travels/Controls.vue
 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Controls = ({
  name: 'controls',
  props: {
    events: Array,
    travelSteps: Array,
    travelIndex: Number
  },
  data: function data() {
    return {
      playing: false,
      disablePlay: false,
      disableNextStep: false,
      disablePreviousStep: true,
      interval: {},
      nextTravelStepTick: 2000,
      currentEventName: '',
      currentEventDate: ''
    };
  },
  computed: {
    progress: function progress() {
      if (this.travelSteps.length === 0) {
        return 0;
      }
      var progress = parseInt(100 * this.travelIndex / this.travelSteps.length);
      return progress > 100 ? 100 : progress;
    }
  },
  watch: {
    travelIndex: function travelIndex(_travelIndex) {
      this.followTravelIndex(_travelIndex);
    },
    playing: function playing(_playing) {
      var _this = this;

      if (_playing) {
        this.interval = setInterval(function () {
          _this.$emit('update:travelIndex', _this.travelIndex + 1);
        }, this.nextTravelStepTick);
      } else {
        clearInterval(this.interval);
      }
    }
  },
  methods: {
    followTravelIndex: function followTravelIndex(travelIndex) {
      // Handle empty travel
      if (this.travelSteps.length === 0) {
        console.log('No hay eventos para mostrar');
        this.playing = false;
        return false;
      }
      // Handle previous step
      if (travelIndex <= 1) {
        this.disablePreviousStep = true;
      } else {
        this.disablePreviousStep = false;
      }
      // Handle play and next step
      if (travelIndex === this.travelSteps.length) {
        this.disablePlay = true;
        this.disableNextStep = true;
        this.playing = false;
      } else {
        this.disablePlay = false;
        this.disableNextStep = false;
      }
      var step = this.travelSteps[travelIndex - 1];
      var event = find_default()(this.events, { _id: step.eventId });
      var eventDate = new Date(event.data.gps.date).toLocaleString();
      this.currentEventName = event.name;
      this.currentEventDate = eventDate;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23355772","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Travels/Controls.vue
var Controls_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"tile":""}},[_c('v-progress-linear',{staticClass:"my-0",attrs:{"height":"4","value":_vm.progress}}),_vm._v(" "),_c('v-list',[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.currentEventName))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.currentEventDate))])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('open-config-dialog')}}},[_c('v-icon',[_vm._v("settings")])],1)],1),_vm._v(" "),_c('v-list-tile-action',{class:{
          'mx-5': _vm.$vuetify.breakpoint.mdAndUp
        }},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.$emit('update:travelIndex', 1)}}},[_c('v-icon',[_vm._v("replay")])],1)],1),_vm._v(" "),_c('v-list-tile-action',{class:{
          'mr-5': _vm.$vuetify.breakpoint.mdAndUp
        }},[_c('v-btn',{attrs:{"icon":"","disabled":_vm.disablePreviousStep},on:{"click":function($event){return _vm.$emit('update:travelIndex', _vm.travelIndex - 1)}}},[_c('v-icon',[_vm._v("fast_rewind")])],1)],1),_vm._v(" "),_c('v-list-tile-action',{class:{
          'mr-5': _vm.$vuetify.breakpoint.mdAndUp
        }},[_c('v-btn',{attrs:{"icon":"","disabled":_vm.disablePlay},on:{"click":function($event){_vm.playing = !_vm.playing}}},[(_vm.playing)?_c('v-icon',[_vm._v("pause")]):_c('v-icon',[_vm._v("play_arrow")])],1)],1),_vm._v(" "),_c('v-list-tile-action',{class:{
          'mr-5': _vm.$vuetify.breakpoint.mdAndUp
        }},[_c('v-btn',{attrs:{"icon":"","disabled":_vm.disableNextStep},on:{"click":function($event){return _vm.$emit('update:travelIndex', _vm.travelIndex + 1)}}},[_c('v-icon',[_vm._v("fast_forward")])],1)],1)],1)],1)],1)}
var Controls_staticRenderFns = []
var Controls_esExports = { render: Controls_render, staticRenderFns: Controls_staticRenderFns }
/* harmony default export */ var Travels_Controls = (Controls_esExports);
// CONCATENATED MODULE: ./src/components/Travels/Controls.vue
var Controls_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Controls___vue_template_functional__ = false
/* styles */
var Controls___vue_styles__ = null
/* scopeId */
var Controls___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Controls___vue_module_identifier__ = null
var Controls_Component = Controls_normalizeComponent(
  Controls,
  Travels_Controls,
  Controls___vue_template_functional__,
  Controls___vue_styles__,
  Controls___vue_scopeId__,
  Controls___vue_module_identifier__
)

/* harmony default export */ var components_Travels_Controls = (Controls_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Travels/ConfigDialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ConfigDialog = ({
  name: 'config-dialog',
  props: {
    vehicles: Array,
    selectedVehicle: Object,
    startDate: Number,
    finishDate: Number
  },
  data: function data() {
    return {
      dialog: false,
      dateDialog: false,
      startTimeDialog: false,
      finishTimeDialog: false,
      date: null,
      startTime: null,
      finishTime: null,
      vehicleSelect: null
    };
  },
  computed: {
    allowedDates: function allowedDates() {
      var min = moment_default()().subtract(6, 'months').toDate().toISOString().substr(0, 10);
      var max = moment_default()().toDate().toISOString().substr(0, 10);
      return { min: min, max: max };
    },
    startDateAndTime: function startDateAndTime() {
      if (!this.date || !this.startTime) {
        return null;
      }
      return moment_default()(this.date + ' ' + this.startTime, 'YYYY-MM-DD h:mmA');
    },
    finishDateAndTime: function finishDateAndTime() {
      if (!this.date || !this.finishTime) {
        return null;
      }
      return moment_default()(this.date + ' ' + this.finishTime, 'YYYY-MM-DD h:mmA');
    }
  },
  watch: {
    vehicleSelect: function vehicleSelect(_vehicleSelect) {
      this.$emit('update:selectedVehicle', _vehicleSelect);
    },
    date: function date() {
      this.getStartDateAndTime();
      this.getFinishDateAndTime();
    },
    startTime: function startTime() {
      this.getStartDateAndTime();
    },
    finishTime: function finishTime() {
      this.getFinishDateAndTime();
    }
  },
  methods: {
    getStartDateAndTime: function getStartDateAndTime() {
      var startDateAndTime = this.startDateAndTime;
      if (!startDateAndTime) {
        this.$emit('update:startDate', null);
      } else {
        this.$emit('update:startDate', startDateAndTime.valueOf());
      }
    },
    getFinishDateAndTime: function getFinishDateAndTime() {
      var finishDateAndTime = this.finishDateAndTime;
      if (!finishDateAndTime) {
        this.$emit('update:finishDate', null);
      } else {
        this.$emit('update:finishDate', finishDateAndTime.valueOf());
      }
    },
    open: function open() {
      this.dialog = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34d34977","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Travels/ConfigDialog.vue
var ConfigDialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":620},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Configuración")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.vehicles,"return-object":"","item-text":"plate","prepend-icon":"directions_car","label":"Vehículos","single-line":""},model:{value:(_vm.vehicleSelect),callback:function ($$v) {_vm.vehicleSelect=$$v},expression:"vehicleSelect"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-dialog',{attrs:{"lazy":"","full-width":"","width":"290px"},model:{value:(_vm.dateDialog),callback:function ($$v) {_vm.dateDialog=$$v},expression:"dateDialog"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Día","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"es-co","allowed-dates":_vm.allowedDates,"scrollable":"","autosave":""},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-dialog',{attrs:{"lazy":"","full-width":"","width":"290px"},model:{value:(_vm.startTimeDialog),callback:function ($$v) {_vm.startTimeDialog=$$v},expression:"startTimeDialog"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Desde","prepend-icon":"access_time","readonly":""},slot:"activator",model:{value:(_vm.startTime),callback:function ($$v) {_vm.startTime=$$v},expression:"startTime"}}),_vm._v(" "),_c('v-time-picker',{attrs:{"autosave":""},model:{value:(_vm.startTime),callback:function ($$v) {_vm.startTime=$$v},expression:"startTime"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-dialog',{attrs:{"lazy":"","full-width":"","width":"290px"},model:{value:(_vm.finishTimeDialog),callback:function ($$v) {_vm.finishTimeDialog=$$v},expression:"finishTimeDialog"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Hasta","prepend-icon":"access_time","readonly":""},slot:"activator",model:{value:(_vm.finishTime),callback:function ($$v) {_vm.finishTime=$$v},expression:"finishTime"}}),_vm._v(" "),_c('v-time-picker',{attrs:{"autosave":""},model:{value:(_vm.finishTime),callback:function ($$v) {_vm.finishTime=$$v},expression:"finishTime"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Cerrar")])],1)],1)],1)}
var ConfigDialog_staticRenderFns = []
var ConfigDialog_esExports = { render: ConfigDialog_render, staticRenderFns: ConfigDialog_staticRenderFns }
/* harmony default export */ var Travels_ConfigDialog = (ConfigDialog_esExports);
// CONCATENATED MODULE: ./src/components/Travels/ConfigDialog.vue
var ConfigDialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ConfigDialog___vue_template_functional__ = false
/* styles */
var ConfigDialog___vue_styles__ = null
/* scopeId */
var ConfigDialog___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ConfigDialog___vue_module_identifier__ = null
var ConfigDialog_Component = ConfigDialog_normalizeComponent(
  ConfigDialog,
  Travels_ConfigDialog,
  ConfigDialog___vue_template_functional__,
  ConfigDialog___vue_styles__,
  ConfigDialog___vue_scopeId__,
  ConfigDialog___vue_module_identifier__
)

/* harmony default export */ var components_Travels_ConfigDialog = (ConfigDialog_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Travels.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var Travels = ({
  name: 'travels',
  data: function data() {
    return {
      selectedVehicle: null,
      startDate: null,
      finishDate: null,
      travelIndex: 0,
      eventsDialogData: null
    };
  },
  computed: {
    events: function events() {
      return this.$store.getters['Travels/fixedEvents'];
    },
    vehicles: function vehicles() {
      return this.$store.state.Travels.vehicles;
    },
    travelSteps: function travelSteps() {
      return this.events.map(function (event) {
        return {
          latLng: {
            lat: event.data.gps.latitude,
            lng: event.data.gps.longitude
          },
          eventId: event._id
        };
      });
    },
    travelStepsAtIndex: function travelStepsAtIndex() {
      return this.travelSteps.slice(0, this.travelIndex);
    }
  },
  watch: {
    selectedVehicle: function selectedVehicle() {
      this.fetchEvents();
    },
    startDate: function startDate() {
      this.fetchEvents();
    },
    finishDate: function finishDate() {
      this.fetchEvents();
    }
  },
  created: function created() {
    this.$store.dispatch('Travels/fetchVehicles');
  },
  components: {
    'travels-map': components_Travels_Map,
    'controls': components_Travels_Controls,
    'config-dialog': components_Travels_ConfigDialog,
    'event-dialog': src_components_EventDialog
  },
  methods: {
    fetchEvents: function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!this.selectedVehicle || !this.startDate || !this.finishDate)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return', false);

              case 2:
                _context.next = 4;
                return this.$store.dispatch('Travels/fetchEvents', {
                  vehicleId: this.selectedVehicle._id,
                  startDate: this.startDate,
                  finishDate: this.finishDate
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchEvents() {
        return _ref.apply(this, arguments);
      }

      return fetchEvents;
    }(),
    openEventDialog: function openEventDialog(_ref2) {
      var eventId = _ref2.eventId;

      this.$refs.eventDialog.open({ eventId: eventId });
    },
    openConfigDialog: function openConfigDialog() {
      var configDialog = this.$refs.configDialog;
      configDialog.open();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-707b9298","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Travels.vue
var Travels_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"travels"},[_c('div',{staticClass:"map-wrapper"},[_c('div',{staticClass:"over-map-content"}),_vm._v(" "),_c('travels-map',{attrs:{"events":_vm.events,"travel-steps":_vm.travelStepsAtIndex},on:{"open-event-dialog":_vm.openEventDialog}})],1),_vm._v(" "),_c('controls',{attrs:{"events":_vm.events,"travel-index":_vm.travelIndex,"travel-steps":_vm.travelSteps},on:{"update:travelIndex":function($event){_vm.travelIndex=$event},"update:travel-index":function($event){_vm.travelIndex=$event},"open-config-dialog":_vm.openConfigDialog}}),_vm._v(" "),_c('config-dialog',{ref:"configDialog",attrs:{"vehicles":_vm.vehicles,"start-date":_vm.startDate,"finish-date":_vm.finishDate,"selected-vehicle":_vm.selectedVehicle},on:{"update:startDate":function($event){_vm.startDate=$event},"update:start-date":function($event){_vm.startDate=$event},"update:finishDate":function($event){_vm.finishDate=$event},"update:finish-date":function($event){_vm.finishDate=$event},"update:selectedVehicle":function($event){_vm.selectedVehicle=$event},"update:selected-vehicle":function($event){_vm.selectedVehicle=$event}}}),_vm._v(" "),_c('event-dialog',{ref:"eventDialog"})],1)}
var Travels_staticRenderFns = []
var Travels_esExports = { render: Travels_render, staticRenderFns: Travels_staticRenderFns }
/* harmony default export */ var views_Travels = (Travels_esExports);
// CONCATENATED MODULE: ./src/views/Travels.vue
function Travels_injectStyle (ssrContext) {
  __webpack_require__("Fl5w")
}
var Travels_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Travels___vue_template_functional__ = false
/* styles */
var Travels___vue_styles__ = Travels_injectStyle
/* scopeId */
var Travels___vue_scopeId__ = "data-v-707b9298"
/* moduleIdentifier (server only) */
var Travels___vue_module_identifier__ = null
var Travels_Component = Travels_normalizeComponent(
  Travels,
  views_Travels,
  Travels___vue_template_functional__,
  Travels___vue_styles__,
  Travels___vue_scopeId__,
  Travels___vue_module_identifier__
)

/* harmony default export */ var src_views_Travels = (Travels_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Profile/Password.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Password = ({
  name: 'password',
  props: {
    loading: Boolean
  },
  data: function data() {
    var _this = this;

    return {
      alert: false,
      alertMessage: '',
      valid: false,
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      passwordRules: [function (value) {
        return !!value || 'Campo requerido';
      }, function (value) {
        return value && value.length <= 24 || 'La contraseña debe contener menos de 24 caracteres';
      }, function (value) {
        return (/^[a-zA-Z0-9_.-]+$/.test(value) || 'Contraseña inválida'
        );
      }],
      confirmPasswordRules: [function (value) {
        return value === _this.newPassword || 'Las contraseñas no coinciden';
      }]
    };
  },
  methods: {
    submit: function submit() {
      var form = this.$refs.form;
      if (form.validate()) {
        this.$emit('update-password', {
          oldPassword: this.oldPassword,
          newPassword: this.newPassword
        });
        this.alert = false;
        form.reset();
      }
    },
    clear: function clear() {
      var form = this.$refs.form;
      this.alert = false;
      form.reset();
    },
    openAlert: function openAlert(message) {
      this.alertMessage = message;
      this.alert = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95779df6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile/Password.vue
var Password_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":"","sm10":"","md8":"","lg7":""}},[_c('v-card',{staticClass:"mt-5"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Contraseña")])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","justify-space-around":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":""}},[_c('v-alert',{attrs:{"error":""},model:{value:(_vm.alert),callback:function ($$v) {_vm.alert=$$v},expression:"alert"}},[_vm._v(_vm._s(_vm.alertMessage))])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-space-around":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":""}},[_c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"label":"Contraseña anterior","counter":24,"rules":_vm.passwordRules,"type":"password","required":""},model:{value:(_vm.oldPassword),callback:function ($$v) {_vm.oldPassword=$$v},expression:"oldPassword"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Contraseña nueva","counter":24,"rules":_vm.passwordRules,"type":"password","required":""},model:{value:(_vm.newPassword),callback:function ($$v) {_vm.newPassword=$$v},expression:"newPassword"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Confirmar contraseña nueva","counter":24,"rules":_vm.confirmPasswordRules,"type":"password","required":""},model:{value:(_vm.confirmPassword),callback:function ($$v) {_vm.confirmPassword=$$v},expression:"confirmPassword"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.clear}},[_vm._v("Limpiar")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","success":"","loading":_vm.loading,"disabled":_vm.loading},on:{"click":_vm.submit}},[_vm._v("Guardar")])],1)],1)],1)}
var Password_staticRenderFns = []
var Password_esExports = { render: Password_render, staticRenderFns: Password_staticRenderFns }
/* harmony default export */ var Profile_Password = (Password_esExports);
// CONCATENATED MODULE: ./src/components/Profile/Password.vue
var Password_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Password___vue_template_functional__ = false
/* styles */
var Password___vue_styles__ = null
/* scopeId */
var Password___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Password___vue_module_identifier__ = null
var Password_Component = Password_normalizeComponent(
  Password,
  Profile_Password,
  Password___vue_template_functional__,
  Password___vue_styles__,
  Password___vue_scopeId__,
  Password___vue_module_identifier__
)

/* harmony default export */ var components_Profile_Password = (Password_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Profile/PersonalData.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var PersonalData = ({
  name: 'personal-data',
  props: {
    client: Object,
    loading: Boolean,
    creatingEmail: Boolean,
    removingEmail: Boolean
  },
  data: function data() {
    return {
      alert: false,
      alertMessage: '',
      valid: false,
      emailIsValid: false,
      fullName: '',
      fullNameRules: [function (value) {
        return !!value || 'Nombre completo requerido';
      }, function (value) {
        return value && value.length <= 44 || 'El nombre completo debe contener menos de 44 caracteres';
      }, function (value) {
        return (/^[a-zA-Zá-úÁ-ÚüÜ ]+$/.test(value) || 'Nombre completo inválido'
        );
      }],
      emailAddress: '',
      emailAddressRules: [function (value) {
        return !!value || 'Correo electrónico requerido';
      }, function (value) {
        return (/^([a-z0-9_.-]+)@([a-z0-9.-]+)\.([a-z.]{2,6})$/.test(value) || 'Correo electrónico inválido'
        );
      }]
    };
  },
  computed: {
    uppercasedFullName: {
      get: function get() {
        return this.fullName.toUpperCase();
      },
      set: function set(fullName) {
        this.fullName = fullName;
      }
    }
  },
  watch: {
    client: function client(_client) {
      this.fullName = _client.name;
    }
  },
  methods: {
    submit: function submit() {
      var form = this.$refs.form;
      if (form.validate()) {
        this.$emit('update-personal-data', { name: this.uppercasedFullName });
        this.alert = false;
      }
    },
    submitEmail: function submitEmail() {
      var emailForm = this.$refs.emailForm;
      if (emailForm.validate()) {
        this.$emit('create-email', { email: this.emailAddress });
        this.alert = false;
        this.$refs.emailForm.reset();
      }
    },
    clear: function clear() {
      this.alert = false;
      this.$refs.form.reset();
      this.$refs.emailForm.reset();
    },
    openAlert: function openAlert(message) {
      this.alertMessage = message;
      this.alert = true;
    },
    fix: function fix() {}
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-724e78d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile/PersonalData.vue
var PersonalData_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":"","sm10":"","md8":"","lg7":""}},[_c('v-card',{staticClass:"mt-5 mb-5"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Información Personal")])]),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"form-alerts mb-3"},[_c('v-layout',{attrs:{"row":"","justify-space-around":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":""}},[_c('v-alert',{attrs:{"color":"error","icon":"warning"},model:{value:(_vm.alert),callback:function ($$v) {_vm.alert=$$v},expression:"alert"}},[_vm._v(_vm._s(_vm.alertMessage))])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-space-around":"","wrap":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"label":"Nombre Completo","counter":44,"rules":_vm.fullNameRules,"required":""},model:{value:(_vm.uppercasedFullName),callback:function ($$v) {_vm.uppercasedFullName=$$v},expression:"uppercasedFullName"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-space-around":"","wrap":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-list',[_c('v-subheader',[_vm._v("Correos Electrónicos")]),_vm._v(" "),(!_vm.client || _vm.client.emails.length === 0)?_c('v-list-tile',[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("No hay correos electrónicos para mostrar")])],1)],1)],1):_vm._l((_vm.client.emails),function(email,index){return _c('v-list-tile',{key:index,on:{"click":_vm.fix}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(email.address))])],1),_vm._v(" "),(!email.active)?_c('v-list-tile-action',[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',{attrs:{"color":"amber"}},[_vm._v("warning")])],1),_vm._v(" "),_c('span',[_vm._v("Activa tu correo electrónico")])],1)],1):_vm._e(),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"icon":"","loading":_vm.removingEmail},on:{"click":function($event){return _vm.$emit('remove-email', { email: email.address })}}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("delete")])],1)],1)],1)})],2)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-space-around":"","wrap":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-form',{ref:"emailForm",model:{value:(_vm.emailIsValid),callback:function ($$v) {_vm.emailIsValid=$$v},expression:"emailIsValid"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-text-field',{attrs:{"label":"Nuevo Correo Electrónico","rules":_vm.emailAddressRules,"loading":_vm.creatingEmail,"required":""},model:{value:(_vm.emailAddress),callback:function ($$v) {_vm.emailAddress=$$v},expression:"emailAddress"}}),_vm._v(" "),_c('v-btn',{staticClass:"ml-3 mt-3",attrs:{"loading":_vm.creatingEmail,"fab":"","small":"","dark":"","color":"green"},on:{"click":_vm.submitEmail}},[_c('v-icon',{attrs:{"dark":"","medium":""}},[_vm._v("add")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.clear}},[_vm._v("Limpiar")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","success":"","loading":_vm.loading,"disabled":_vm.loading},on:{"click":_vm.submit}},[_vm._v("Guardar")])],1)],1)],1)}
var PersonalData_staticRenderFns = []
var PersonalData_esExports = { render: PersonalData_render, staticRenderFns: PersonalData_staticRenderFns }
/* harmony default export */ var Profile_PersonalData = (PersonalData_esExports);
// CONCATENATED MODULE: ./src/components/Profile/PersonalData.vue
var PersonalData_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PersonalData___vue_template_functional__ = false
/* styles */
var PersonalData___vue_styles__ = null
/* scopeId */
var PersonalData___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PersonalData___vue_module_identifier__ = null
var PersonalData_Component = PersonalData_normalizeComponent(
  PersonalData,
  Profile_PersonalData,
  PersonalData___vue_template_functional__,
  PersonalData___vue_styles__,
  PersonalData___vue_scopeId__,
  PersonalData___vue_module_identifier__
)

/* harmony default export */ var components_Profile_PersonalData = (PersonalData_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Profile.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Profile = ({
  name: 'profile',
  data: function data() {
    return {
      passwordFormLoading: false,
      personalDataFormLoading: false,
      creatingEmail: false,
      removingEmail: false
    };
  },
  computed: {
    client: function client() {
      return this.$store.state.Account.client;
    }
  },
  created: function created() {
    this.$store.dispatch('Account/fetchClient');
  },
  components: {
    'password': components_Profile_Password,
    'personal-data': components_Profile_PersonalData,
    'snackbar': src_components_Snackbar
  },
  methods: {
    updatePassword: function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref2) {
        var oldPassword = _ref2.oldPassword,
            newPassword = _ref2.newPassword;
        var passwordForm, message;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.passwordFormLoading = true;
                _context.prev = 1;
                _context.next = 4;
                return this.$store.dispatch('Account/updateClientPassword', {
                  client: {
                    oldPassword: oldPassword,
                    newPassword: newPassword
                  }
                });

              case 4:
                _context.next = 13;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](1);

                this.passwordFormLoading = false;
                passwordForm = this.$refs.passwordForm;
                message = _context.t0.graphQLErrors[0] ? _context.t0.graphQLErrors[0].message : 'Ooops, ha ocurrido un error';

                passwordForm.openAlert(message);
                return _context.abrupt('return', console.error(_context.t0));

              case 13:
                this.passwordFormLoading = false;
                this.$refs.snackbar.open('success', 'Contraseña actualizada');

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 6]]);
      }));

      function updatePassword(_x) {
        return _ref.apply(this, arguments);
      }

      return updatePassword;
    }(),
    updatePersonalData: function () {
      var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(_ref4) {
        var name = _ref4.name;
        var personalDataForm, message;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.personalDataFormLoading = true;
                _context2.prev = 1;
                _context2.next = 4;
                return this.$store.dispatch('Account/updateClient', {
                  client: { name: name }
                });

              case 4:
                _context2.next = 13;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2['catch'](1);

                this.personalDataFormLoading = false;
                personalDataForm = this.$refs.personalDataForm;
                message = _context2.t0.graphQLErrors[0] ? _context2.t0.graphQLErrors[0].message : 'Ooops, ha ocurrido un error';

                personalDataForm.openAlert(message);
                return _context2.abrupt('return', console.error(_context2.t0));

              case 13:
                this.personalDataFormLoading = false;
                this.$refs.snackbar.open('success', 'Información personal actualizada');

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 6]]);
      }));

      function updatePersonalData(_x2) {
        return _ref3.apply(this, arguments);
      }

      return updatePersonalData;
    }(),
    createEmail: function () {
      var _ref5 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(_ref6) {
        var email = _ref6.email;
        var personalDataForm, message;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.creatingEmail = true;
                _context3.prev = 1;
                _context3.next = 4;
                return this.$store.dispatch('Account/createEmail', {
                  email: email
                });

              case 4:
                _context3.next = 13;
                break;

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3['catch'](1);

                this.creatingEmail = false;
                personalDataForm = this.$refs.personalDataForm;
                message = _context3.t0.graphQLErrors[0] ? _context3.t0.graphQLErrors[0].message : 'Ooops, ha ocurrido un error';

                personalDataForm.openAlert(message);
                return _context3.abrupt('return', console.error(_context3.t0));

              case 13:
                this.creatingEmail = false;
                this.$refs.snackbar.open('success', 'Activa tu correo electrónico');

              case 15:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 6]]);
      }));

      function createEmail(_x3) {
        return _ref5.apply(this, arguments);
      }

      return createEmail;
    }(),
    removeEmail: function () {
      var _ref7 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(_ref8) {
        var email = _ref8.email;
        var personalDataForm, message;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.removingEmail = true;
                _context4.prev = 1;
                _context4.next = 4;
                return this.$store.dispatch('Account/removeEmail', {
                  email: email
                });

              case 4:
                _context4.next = 13;
                break;

              case 6:
                _context4.prev = 6;
                _context4.t0 = _context4['catch'](1);

                this.removingEmail = false;
                personalDataForm = this.$refs.personalDataForm;
                message = _context4.t0.graphQLErrors[0] ? _context4.t0.graphQLErrors[0].message : 'Ooops, ha ocurrido un error';

                personalDataForm.openAlert(message);
                return _context4.abrupt('return', console.error(_context4.t0));

              case 13:
                this.removingEmail = false;
                this.$refs.snackbar.open('success', 'Correo electrónico eliminado');

              case 15:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 6]]);
      }));

      function removeEmail(_x4) {
        return _ref7.apply(this, arguments);
      }

      return removeEmail;
    }()
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11ca9e68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Profile.vue
var Profile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"navigation-drawer-view"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('v-card',{staticClass:"mt-3",attrs:{"color":"blue darken-1 white--text"}},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('div',{staticClass:"display-1 my-3"},[_vm._v("Controla, protege y asegura tu cuenta, todo en un solo lugar")])]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('div',{staticClass:"body-1"},[_vm._v("\n                Mi Cuenta te da un rápido acceso a configuraciones y herramientas\n                que te permiten salvaguardar tu información, proteger tu privacidad y\n                decidir como tu información puede mejorar los servicios de Rastreo Siglo XXI para ti.\n              ")])])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-space-around":"","wrap":""}},[_c('password',{ref:"passwordForm",attrs:{"loading":_vm.passwordFormLoading},on:{"update-password":_vm.updatePassword}}),_vm._v(" "),_c('personal-data',{ref:"personalDataForm",attrs:{"client":_vm.client,"loading":_vm.personalDataFormLoading,"creating-email":_vm.creatingEmail,"removing-email":_vm.removingEmail},on:{"update-personal-data":_vm.updatePersonalData,"create-email":_vm.createEmail,"remove-email":_vm.removeEmail}})],1)],1),_vm._v(" "),_c('snackbar',{ref:"snackbar"})],1)}
var Profile_staticRenderFns = []
var Profile_esExports = { render: Profile_render, staticRenderFns: Profile_staticRenderFns }
/* harmony default export */ var views_Profile = (Profile_esExports);
// CONCATENATED MODULE: ./src/views/Profile.vue
var Profile_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Profile___vue_template_functional__ = false
/* styles */
var Profile___vue_styles__ = null
/* scopeId */
var Profile___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Profile___vue_module_identifier__ = null
var Profile_Component = Profile_normalizeComponent(
  Profile,
  views_Profile,
  Profile___vue_template_functional__,
  Profile___vue_styles__,
  Profile___vue_scopeId__,
  Profile___vue_module_identifier__
)

/* harmony default export */ var src_views_Profile = (Profile_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FAQ/EventTemplate.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var EventTemplate = ({
  name: 'geofences-faq',
  props: {
    selectedFeature: String
  },
  data: function data() {
    return {
      questions: [{
        title: '¿Qué es el Acimut?',
        answer: 'Es la orientación del vehículo'
      }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00b22954","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FAQ/EventTemplate.vue
var EventTemplate_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-3"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.selectedFeature))])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-expansion-panel',_vm._l((_vm.questions),function(question,index){return _c('v-expansion-panel-content',{key:index},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(question.title))]),_vm._v(" "),_c('v-card',[_c('v-card-text',{staticClass:"grey lighten-3"},[_vm._v(_vm._s(question.answer))])],1)],1)}),1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"primary":"","flat":""}},[_vm._v("comenzar tutorial")])],1)],1)}
var EventTemplate_staticRenderFns = []
var EventTemplate_esExports = { render: EventTemplate_render, staticRenderFns: EventTemplate_staticRenderFns }
/* harmony default export */ var FAQ_EventTemplate = (EventTemplate_esExports);
// CONCATENATED MODULE: ./src/components/FAQ/EventTemplate.vue
var EventTemplate_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var EventTemplate___vue_template_functional__ = false
/* styles */
var EventTemplate___vue_styles__ = null
/* scopeId */
var EventTemplate___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EventTemplate___vue_module_identifier__ = null
var EventTemplate_Component = EventTemplate_normalizeComponent(
  EventTemplate,
  FAQ_EventTemplate,
  EventTemplate___vue_template_functional__,
  EventTemplate___vue_styles__,
  EventTemplate___vue_scopeId__,
  EventTemplate___vue_module_identifier__
)

/* harmony default export */ var components_FAQ_EventTemplate = (EventTemplate_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FAQ/Geofences.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var FAQ_Geofences = ({
  name: 'geofences-faq',
  props: {
    selectedFeature: String
  },
  data: function data() {
    return {
      questions: [{
        title: '¿Qué es una Geocerca?',
        answer: 'Una Geocerca es un polígono en el mapa que te permite recibir nofiticaciones cuando uno de los vehículos asociados entra o sale del perímetro'
      }, {
        title: '¿Cuántas Geocercas puedo crear?',
        answer: 'Actualmente no existe un límite'
      }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-866f265a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FAQ/Geofences.vue
var FAQ_Geofences_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-3"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.selectedFeature))])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-expansion-panel',_vm._l((_vm.questions),function(question,index){return _c('v-expansion-panel-content',{key:index},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(question.title))]),_vm._v(" "),_c('v-card',[_c('v-card-text',{staticClass:"grey lighten-3"},[_vm._v(_vm._s(question.answer))])],1)],1)}),1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"primary":"","flat":""}},[_vm._v("comenzar tutorial")])],1)],1)}
var FAQ_Geofences_staticRenderFns = []
var FAQ_Geofences_esExports = { render: FAQ_Geofences_render, staticRenderFns: FAQ_Geofences_staticRenderFns }
/* harmony default export */ var components_FAQ_Geofences = (FAQ_Geofences_esExports);
// CONCATENATED MODULE: ./src/components/FAQ/Geofences.vue
var FAQ_Geofences_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var FAQ_Geofences___vue_template_functional__ = false
/* styles */
var FAQ_Geofences___vue_styles__ = null
/* scopeId */
var FAQ_Geofences___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var FAQ_Geofences___vue_module_identifier__ = null
var FAQ_Geofences_Component = FAQ_Geofences_normalizeComponent(
  FAQ_Geofences,
  components_FAQ_Geofences,
  FAQ_Geofences___vue_template_functional__,
  FAQ_Geofences___vue_styles__,
  FAQ_Geofences___vue_scopeId__,
  FAQ_Geofences___vue_module_identifier__
)

/* harmony default export */ var src_components_FAQ_Geofences = (FAQ_Geofences_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FAQ/Guests.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Guests = ({
  name: 'geofences-faq',
  props: {
    selectedFeature: String
  },
  data: function data() {
    return {
      questions: [{
        title: '¿Cuántos Invitados puedo crear?',
        answer: 'Actualmente no existe un límite'
      }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72858c51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FAQ/Guests.vue
var Guests_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-3"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.selectedFeature))])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-expansion-panel',_vm._l((_vm.questions),function(question,index){return _c('v-expansion-panel-content',{key:index},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(question.title))]),_vm._v(" "),_c('v-card',[_c('v-card-text',{staticClass:"grey lighten-3"},[_vm._v(_vm._s(question.answer))])],1)],1)}),1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"primary":"","flat":""}},[_vm._v("comenzar tutorial")])],1)],1)}
var Guests_staticRenderFns = []
var Guests_esExports = { render: Guests_render, staticRenderFns: Guests_staticRenderFns }
/* harmony default export */ var FAQ_Guests = (Guests_esExports);
// CONCATENATED MODULE: ./src/components/FAQ/Guests.vue
var Guests_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Guests___vue_template_functional__ = false
/* styles */
var Guests___vue_styles__ = null
/* scopeId */
var Guests___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Guests___vue_module_identifier__ = null
var Guests_Component = Guests_normalizeComponent(
  Guests,
  FAQ_Guests,
  Guests___vue_template_functional__,
  Guests___vue_styles__,
  Guests___vue_scopeId__,
  Guests___vue_module_identifier__
)

/* harmony default export */ var components_FAQ_Guests = (Guests_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FAQ/Places.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var FAQ_Places = ({
  name: 'geofences-faq',
  props: {
    selectedFeature: String
  },
  data: function data() {
    return {
      questions: [{
        title: '¿Qué es un Lugar?',
        answer: 'Es un punto de interés para el cliente que aparecerá en el evento cuando el vehículo esté cerca'
      }, {
        title: '¿Cuántos Lugares puedo crear?',
        answer: 'Actualmente no existe un límite'
      }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fd2e0c3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FAQ/Places.vue
var FAQ_Places_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-3"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.selectedFeature))])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-expansion-panel',_vm._l((_vm.questions),function(question,index){return _c('v-expansion-panel-content',{key:index},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(question.title))]),_vm._v(" "),_c('v-card',[_c('v-card-text',{staticClass:"grey lighten-3"},[_vm._v(_vm._s(question.answer))])],1)],1)}),1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"primary":"","flat":""}},[_vm._v("comenzar tutorial")])],1)],1)}
var FAQ_Places_staticRenderFns = []
var FAQ_Places_esExports = { render: FAQ_Places_render, staticRenderFns: FAQ_Places_staticRenderFns }
/* harmony default export */ var components_FAQ_Places = (FAQ_Places_esExports);
// CONCATENATED MODULE: ./src/components/FAQ/Places.vue
var FAQ_Places_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var FAQ_Places___vue_template_functional__ = false
/* styles */
var FAQ_Places___vue_styles__ = null
/* scopeId */
var FAQ_Places___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var FAQ_Places___vue_module_identifier__ = null
var FAQ_Places_Component = FAQ_Places_normalizeComponent(
  FAQ_Places,
  components_FAQ_Places,
  FAQ_Places___vue_template_functional__,
  FAQ_Places___vue_styles__,
  FAQ_Places___vue_scopeId__,
  FAQ_Places___vue_module_identifier__
)

/* harmony default export */ var src_components_FAQ_Places = (FAQ_Places_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FAQ/Reports.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var FAQ_Reports = ({
  name: 'geofences-faq',
  props: {
    selectedFeature: String
  },
  data: function data() {
    return {
      questions: [{
        title: '¿Cuál es la disponibilidad de los reportes?',
        answer: 'Puedes generar reportes de máximo 6 meses atrás, mes a mes'
      }, {
        title: '¿En qué formato puedo descargar un reporte?',
        answer: 'Actualmente los reportes solo se pueden descargar en formato XLS (Excel)'
      }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3992efd1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FAQ/Reports.vue
var FAQ_Reports_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-3"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.selectedFeature))])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-expansion-panel',_vm._l((_vm.questions),function(question,index){return _c('v-expansion-panel-content',{key:index},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(question.title))]),_vm._v(" "),_c('v-card',[_c('v-card-text',{staticClass:"grey lighten-3"},[_vm._v(_vm._s(question.answer))])],1)],1)}),1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"primary":"","flat":""}},[_vm._v("comenzar tutorial")])],1)],1)}
var FAQ_Reports_staticRenderFns = []
var FAQ_Reports_esExports = { render: FAQ_Reports_render, staticRenderFns: FAQ_Reports_staticRenderFns }
/* harmony default export */ var components_FAQ_Reports = (FAQ_Reports_esExports);
// CONCATENATED MODULE: ./src/components/FAQ/Reports.vue
var FAQ_Reports_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var FAQ_Reports___vue_template_functional__ = false
/* styles */
var FAQ_Reports___vue_styles__ = null
/* scopeId */
var FAQ_Reports___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var FAQ_Reports___vue_module_identifier__ = null
var FAQ_Reports_Component = FAQ_Reports_normalizeComponent(
  FAQ_Reports,
  components_FAQ_Reports,
  FAQ_Reports___vue_template_functional__,
  FAQ_Reports___vue_styles__,
  FAQ_Reports___vue_scopeId__,
  FAQ_Reports___vue_module_identifier__
)

/* harmony default export */ var src_components_FAQ_Reports = (FAQ_Reports_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FAQ/Routes.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var FAQ_Routes = ({
  name: 'geofences-faq',
  props: {
    selectedFeature: String
  },
  data: function data() {
    return {
      questions: [{
        title: '¿Qué es una Ruta?',
        answer: 'Una ruta es una línea sobre el mapa que representa posibles recorridos de los vehículos. Las rutas generan notificaciones cuando un vehículo asociado se acerca o se aleja de la misma.'
      }, {
        title: '¿Cuántas Rutas puedo crear?',
        answer: 'Actualmente no existe un límite'
      }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-683cff92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FAQ/Routes.vue
var FAQ_Routes_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-3"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.selectedFeature))])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-expansion-panel',_vm._l((_vm.questions),function(question,index){return _c('v-expansion-panel-content',{key:index},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(question.title))]),_vm._v(" "),_c('v-card',[_c('v-card-text',{staticClass:"grey lighten-3"},[_vm._v(_vm._s(question.answer))])],1)],1)}),1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"primary":"","flat":""}},[_vm._v("comenzar tutorial")])],1)],1)}
var FAQ_Routes_staticRenderFns = []
var FAQ_Routes_esExports = { render: FAQ_Routes_render, staticRenderFns: FAQ_Routes_staticRenderFns }
/* harmony default export */ var components_FAQ_Routes = (FAQ_Routes_esExports);
// CONCATENATED MODULE: ./src/components/FAQ/Routes.vue
var FAQ_Routes_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var FAQ_Routes___vue_template_functional__ = false
/* styles */
var FAQ_Routes___vue_styles__ = null
/* scopeId */
var FAQ_Routes___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var FAQ_Routes___vue_module_identifier__ = null
var FAQ_Routes_Component = FAQ_Routes_normalizeComponent(
  FAQ_Routes,
  components_FAQ_Routes,
  FAQ_Routes___vue_template_functional__,
  FAQ_Routes___vue_styles__,
  FAQ_Routes___vue_scopeId__,
  FAQ_Routes___vue_module_identifier__
)

/* harmony default export */ var src_components_FAQ_Routes = (FAQ_Routes_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FAQ/Tracking.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var FAQ_Tracking = ({
  name: 'geofences-faq',
  props: {
    selectedFeature: String
  },
  data: function data() {
    return {
      questions: []
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4081b984","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FAQ/Tracking.vue
var FAQ_Tracking_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-3"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.selectedFeature))])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-expansion-panel',_vm._l((_vm.questions),function(question,index){return _c('v-expansion-panel-content',{key:index},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(question.title))]),_vm._v(" "),_c('v-card',[_c('v-card-text',{staticClass:"grey lighten-3"},[_vm._v(_vm._s(question.answer))])],1)],1)}),1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"primary":"","flat":""}},[_vm._v("comenzar tutorial")])],1)],1)}
var FAQ_Tracking_staticRenderFns = []
var FAQ_Tracking_esExports = { render: FAQ_Tracking_render, staticRenderFns: FAQ_Tracking_staticRenderFns }
/* harmony default export */ var components_FAQ_Tracking = (FAQ_Tracking_esExports);
// CONCATENATED MODULE: ./src/components/FAQ/Tracking.vue
var FAQ_Tracking_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var FAQ_Tracking___vue_template_functional__ = false
/* styles */
var FAQ_Tracking___vue_styles__ = null
/* scopeId */
var FAQ_Tracking___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var FAQ_Tracking___vue_module_identifier__ = null
var FAQ_Tracking_Component = FAQ_Tracking_normalizeComponent(
  FAQ_Tracking,
  components_FAQ_Tracking,
  FAQ_Tracking___vue_template_functional__,
  FAQ_Tracking___vue_styles__,
  FAQ_Tracking___vue_scopeId__,
  FAQ_Tracking___vue_module_identifier__
)

/* harmony default export */ var src_components_FAQ_Tracking = (FAQ_Tracking_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FAQ/Travels.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var FAQ_Travels = ({
  name: 'geofences-faq',
  props: {
    selectedFeature: String
  },
  data: function data() {
    return {
      questions: []
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fa9a824","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FAQ/Travels.vue
var FAQ_Travels_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-3"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.selectedFeature))])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-expansion-panel',_vm._l((_vm.questions),function(question,index){return _c('v-expansion-panel-content',{key:index},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(question.title))]),_vm._v(" "),_c('v-card',[_c('v-card-text',{staticClass:"grey lighten-3"},[_vm._v(_vm._s(question.answer))])],1)],1)}),1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"primary":"","flat":""}},[_vm._v("comenzar tutorial")])],1)],1)}
var FAQ_Travels_staticRenderFns = []
var FAQ_Travels_esExports = { render: FAQ_Travels_render, staticRenderFns: FAQ_Travels_staticRenderFns }
/* harmony default export */ var components_FAQ_Travels = (FAQ_Travels_esExports);
// CONCATENATED MODULE: ./src/components/FAQ/Travels.vue
var FAQ_Travels_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var FAQ_Travels___vue_template_functional__ = false
/* styles */
var FAQ_Travels___vue_styles__ = null
/* scopeId */
var FAQ_Travels___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var FAQ_Travels___vue_module_identifier__ = null
var FAQ_Travels_Component = FAQ_Travels_normalizeComponent(
  FAQ_Travels,
  components_FAQ_Travels,
  FAQ_Travels___vue_template_functional__,
  FAQ_Travels___vue_styles__,
  FAQ_Travels___vue_scopeId__,
  FAQ_Travels___vue_module_identifier__
)

/* harmony default export */ var src_components_FAQ_Travels = (FAQ_Travels_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FAQ/VehicleTemplate.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var VehicleTemplate = ({
  name: 'geofences-faq',
  props: {
    selectedFeature: String
  },
  data: function data() {
    return {
      questions: [{
        title: '¿Qué es el Acimut?',
        answer: 'Es la orientación del vehículo'
      }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15182578","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FAQ/VehicleTemplate.vue
var VehicleTemplate_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-3"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.selectedFeature))])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-expansion-panel',_vm._l((_vm.questions),function(question,index){return _c('v-expansion-panel-content',{key:index},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(question.title))]),_vm._v(" "),_c('v-card',[_c('v-card-text',{staticClass:"grey lighten-3"},[_vm._v(_vm._s(question.answer))])],1)],1)}),1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"primary":"","flat":""}},[_vm._v("comenzar tutorial")])],1)],1)}
var VehicleTemplate_staticRenderFns = []
var VehicleTemplate_esExports = { render: VehicleTemplate_render, staticRenderFns: VehicleTemplate_staticRenderFns }
/* harmony default export */ var FAQ_VehicleTemplate = (VehicleTemplate_esExports);
// CONCATENATED MODULE: ./src/components/FAQ/VehicleTemplate.vue
var VehicleTemplate_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var VehicleTemplate___vue_template_functional__ = false
/* styles */
var VehicleTemplate___vue_styles__ = null
/* scopeId */
var VehicleTemplate___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VehicleTemplate___vue_module_identifier__ = null
var VehicleTemplate_Component = VehicleTemplate_normalizeComponent(
  VehicleTemplate,
  FAQ_VehicleTemplate,
  VehicleTemplate___vue_template_functional__,
  VehicleTemplate___vue_styles__,
  VehicleTemplate___vue_scopeId__,
  VehicleTemplate___vue_module_identifier__
)

/* harmony default export */ var components_FAQ_VehicleTemplate = (VehicleTemplate_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Help.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ var Help = ({
  name: 'help',
  data: function data() {
    return {
      selectedFeature: '',
      features: ['Detalles del Evento', 'Geocercas', 'Invitados', 'Lugares', 'Reportes', 'Rutas', 'Seguimiento', 'Recorridos', 'Detalles del Vehículo']
    };
  },
  components: {
    'event-template-faq': components_FAQ_EventTemplate,
    'geofences-faq': src_components_FAQ_Geofences,
    'guests-faq': components_FAQ_Guests,
    'places-faq': src_components_FAQ_Places,
    'reports-faq': src_components_FAQ_Reports,
    'routes-faq': src_components_FAQ_Routes,
    'tracking-faq': src_components_FAQ_Tracking,
    'travels-faq': src_components_FAQ_Travels,
    'vehicle-template-faq': components_FAQ_VehicleTemplate
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5356a7d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Help.vue
var Help_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"navigation-drawer-view"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-card',{staticClass:"ma-3"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Ayuda")])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-autocomplete',{attrs:{"label":"Características","prepend-icon":"help","items":_vm.features},model:{value:(_vm.selectedFeature),callback:function ($$v) {_vm.selectedFeature=$$v},expression:"selectedFeature"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[(_vm.selectedFeature === 'Detalles del Evento')?_c('event-template-faq',{attrs:{"selectedFeature":_vm.selectedFeature}}):_vm._e(),_vm._v(" "),(_vm.selectedFeature === 'Geocercas')?_c('geofences-faq',{attrs:{"selectedFeature":_vm.selectedFeature}}):_vm._e(),_vm._v(" "),(_vm.selectedFeature === 'Invitados')?_c('guests-faq',{attrs:{"selectedFeature":_vm.selectedFeature}}):_vm._e(),_vm._v(" "),(_vm.selectedFeature === 'Lugares')?_c('places-faq',{attrs:{"selectedFeature":_vm.selectedFeature}}):_vm._e(),_vm._v(" "),(_vm.selectedFeature === 'Reportes')?_c('reports-faq',{attrs:{"selectedFeature":_vm.selectedFeature}}):_vm._e(),_vm._v(" "),(_vm.selectedFeature === 'Rutas')?_c('routes-faq',{attrs:{"selectedFeature":_vm.selectedFeature}}):_vm._e(),_vm._v(" "),(_vm.selectedFeature === 'Seguimiento')?_c('tracking-faq',{attrs:{"selectedFeature":_vm.selectedFeature}}):_vm._e(),_vm._v(" "),(_vm.selectedFeature === 'Recorridos')?_c('travels-faq',{attrs:{"selectedFeature":_vm.selectedFeature}}):_vm._e(),_vm._v(" "),(_vm.selectedFeature === 'Detalles del Vehículo')?_c('vehicle-template-faq',{attrs:{"selectedFeature":_vm.selectedFeature}}):_vm._e()],1)],1)],1)],1)}
var Help_staticRenderFns = []
var Help_esExports = { render: Help_render, staticRenderFns: Help_staticRenderFns }
/* harmony default export */ var views_Help = (Help_esExports);
// CONCATENATED MODULE: ./src/views/Help.vue
var Help_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Help___vue_template_functional__ = false
/* styles */
var Help___vue_styles__ = null
/* scopeId */
var Help___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Help___vue_module_identifier__ = null
var Help_Component = Help_normalizeComponent(
  Help,
  views_Help,
  Help___vue_template_functional__,
  Help___vue_styles__,
  Help___vue_scopeId__,
  Help___vue_module_identifier__
)

/* harmony default export */ var src_views_Help = (Help_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CreateGuestDialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var CreateGuestDialog = ({
  name: 'create-guest-dialog',
  props: {
    vehicles: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    permissions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var _this = this;

    return {
      selectedPermissions: [],
      dialog: false,
      valid: false,
      selectedVehicles: [],
      name: '',
      nameRules: [function (value) {
        return !!value || 'Nombre requerido';
      }, function (value) {
        return value && value.length >= 4 || 'El nombre debe contener más de 4 caracteres';
      }, function (value) {
        return value && value.length <= 44 || 'El nombre debe contener menos de 44 caracteres';
      }, function (value) {
        return (/^[a-zA-Z ]+$/.test(value) || 'Nombre inválido'
        );
      }],
      username: '',
      usernameRules: [function (value) {
        return !!value || 'Usuario requerido';
      }, function (value) {
        return value && value.length >= 4 || 'El usuario debe contener más de 4 caracteres';
      }, function (value) {
        return value && value.length <= 16 || 'El usuario debe contener menos de 16 caracteres';
      }, function (value) {
        return (/^[a-zA-Z0-9]+$/.test(value) || 'Usuario inválido'
        );
      }],
      password: '',
      passwordRules: [function (value) {
        return !!value || 'Contraseña requerida';
      }, function (value) {
        return value && value.length >= 4 || 'La contraseña debe contener más de 4 caracteres';
      }, function (value) {
        return value && value.length <= 24 || 'La contraseña debe contener menos de 24 caracteres';
      }, function (value) {
        return (/^[a-zA-Z0-9_.-]+$/.test(value) || 'Contraseña inválida'
        );
      }],
      confirmPassword: '',
      confirmPasswordRules: [function (value) {
        return value === _this.password || 'Las contraseñas no coinciden';
      }],
      creatingGuest: false,
      errorAlert: false,
      errorAlertText: ''
    };
  },
  methods: {
    createGuest: function createGuest() {
      if (!this.$refs.form.validate()) {
        return false;
      }
      this.creatingGuest = true;
      this.$emit('create-guest', {
        guest: {
          vehicles: this.selectedVehicles || [],
          name: this.name.toUpperCase(),
          username: this.username.toLowerCase(),
          password: this.password,
          permissions: this.selectedPermissions || []
        }
      });
    },
    open: function open() {
      this.dialog = true;
    },
    close: function close() {
      this.creatingGuest = false;
      this.selectedVehicles = [];
      this.selectedPermissions = [];
      this.$refs.form.reset();
      this.errorAlert = false;
      this.errorAlertText = '';
      this.dialog = false;
    },
    displayError: function displayError(err) {
      this.creatingGuest = false;
      this.errorAlertText = err;
      this.errorAlert = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1942ce16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateGuestDialog.vue
var CreateGuestDialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":590},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Crear Invitado")])]),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-subheader',[_vm._v("Información General")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('v-autocomplete',{attrs:{"label":"Vehículos","items":_vm.vehicles,"item-text":"plate","item-value":"_id","multiple":"","chips":"","hint":"El invitado tendrá acceso a estos vehículos","persistent-hint":""},model:{value:(_vm.selectedVehicles),callback:function ($$v) {_vm.selectedVehicles=$$v},expression:"selectedVehicles"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Nombre","count":44,"rules":_vm.nameRules,"required":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Usuario","count":16,"rules":_vm.usernameRules,"required":""},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Contraseña","type":"password","count":24,"rules":_vm.passwordRules,"required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Confirmar contraseña","type":"password","count":24,"rules":_vm.confirmPasswordRules,"required":""},model:{value:(_vm.confirmPassword),callback:function ($$v) {_vm.confirmPassword=$$v},expression:"confirmPassword"}})],1)],1),_vm._v(" "),_c('v-subheader',{staticClass:"mb-3"},[_vm._v("Permisos")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs10":""}},_vm._l((_vm.permissions),function(permission){return _c('v-switch',{key:permission.name,attrs:{"color":"primary","label":permission.displayName,"value":permission.name},model:{value:(_vm.selectedPermissions),callback:function ($$v) {_vm.selectedPermissions=$$v},expression:"selectedPermissions"}})}),1)],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"color":"error","icon":"warning"},model:{value:(_vm.errorAlert),callback:function ($$v) {_vm.errorAlert=$$v},expression:"errorAlert"}},[_vm._v(_vm._s(_vm.errorAlertText))])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("cerrar")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"green","loading":_vm.creatingGuest},on:{"click":_vm.createGuest}},[_vm._v("guardar")])],1)],1)],1)}
var CreateGuestDialog_staticRenderFns = []
var CreateGuestDialog_esExports = { render: CreateGuestDialog_render, staticRenderFns: CreateGuestDialog_staticRenderFns }
/* harmony default export */ var components_CreateGuestDialog = (CreateGuestDialog_esExports);
// CONCATENATED MODULE: ./src/components/CreateGuestDialog.vue
var CreateGuestDialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var CreateGuestDialog___vue_template_functional__ = false
/* styles */
var CreateGuestDialog___vue_styles__ = null
/* scopeId */
var CreateGuestDialog___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CreateGuestDialog___vue_module_identifier__ = null
var CreateGuestDialog_Component = CreateGuestDialog_normalizeComponent(
  CreateGuestDialog,
  components_CreateGuestDialog,
  CreateGuestDialog___vue_template_functional__,
  CreateGuestDialog___vue_styles__,
  CreateGuestDialog___vue_scopeId__,
  CreateGuestDialog___vue_module_identifier__
)

/* harmony default export */ var src_components_CreateGuestDialog = (CreateGuestDialog_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UpdateGuestDialog.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var UpdateGuestDialog = ({
  name: 'update-guest-dialog',
  props: {
    vehicles: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    permissions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      _id: null,
      selectedPermissions: [],
      dialog: false,
      valid: false,
      selectedVehicles: [],
      name: '',
      nameRules: [function (value) {
        return !!value || 'Nombre requerido';
      }, function (value) {
        return value && value.length >= 4 || 'El nombre debe contener más de 4 caracteres';
      }, function (value) {
        return value && value.length <= 44 || 'El nombre debe contener menos de 44 caracteres';
      }, function (value) {
        return (/^[a-zA-Z ]+$/.test(value) || 'Nombre inválido'
        );
      }],
      username: '',
      usernameRules: [function (value) {
        return !!value || 'Usuario requerido';
      }, function (value) {
        return value && value.length >= 4 || 'El usuario debe contener más de 4 caracteres';
      }, function (value) {
        return value && value.length <= 16 || 'El usuario debe contener menos de 16 caracteres';
      }, function (value) {
        return (/^[a-zA-Z0-9]+$/.test(value) || 'Usuario inválido'
        );
      }],
      updatingGuest: false,
      errorAlert: false,
      errorAlertText: ''
    };
  },
  methods: {
    createGuest: function createGuest() {
      if (!this.$refs.form.validate()) {
        return false;
      }
      this.updatingGuest = true;
      this.$emit('update-guest', {
        _id: this._id,
        guest: {
          vehicles: this.selectedVehicles || [],
          name: this.name.toUpperCase(),
          username: this.username.toLowerCase(),
          permissions: this.selectedPermissions || []
        }
      });
    },
    open: function open(_ref) {
      var guest = _ref.guest;

      this._id = guest._id;
      this.selectedVehicles = guest.vehicles;
      this.name = guest.name;
      this.username = guest.username;
      this.selectedPermissions = guest.permissions;
      this.dialog = true;
    },
    close: function close() {
      this._id = null;
      this.updatingGuest = false;
      this.selectedVehicles = [];
      this.selectedPermissions = [];
      this.$refs.form.reset();
      this.errorAlert = false;
      this.errorAlertText = '';
      this.dialog = false;
    },
    displayError: function displayError(err) {
      this.updatingGuest = false;
      this.errorAlertText = err;
      this.errorAlert = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fd6e684","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UpdateGuestDialog.vue
var UpdateGuestDialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":590},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Actualizar Invitado")])]),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-subheader',[_vm._v("Información General")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('v-autocomplete',{attrs:{"label":"Vehículos","items":_vm.vehicles,"item-text":"plate","item-value":"_id","multiple":"","chips":"","hint":"El invitado tendrá acceso a estos vehículos","persistent-hint":""},model:{value:(_vm.selectedVehicles),callback:function ($$v) {_vm.selectedVehicles=$$v},expression:"selectedVehicles"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Nombre","count":44,"rules":_vm.nameRules,"required":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Usuario","count":16,"rules":_vm.usernameRules,"required":""},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}})],1)],1),_vm._v(" "),_c('v-subheader',{staticClass:"mb-3"},[_vm._v("Permisos")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs10":""}},_vm._l((_vm.permissions),function(permission){return _c('v-switch',{key:permission.name,attrs:{"color":"primary","label":permission.displayName,"value":permission.name},model:{value:(_vm.selectedPermissions),callback:function ($$v) {_vm.selectedPermissions=$$v},expression:"selectedPermissions"}})}),1)],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"color":"error","icon":"warning"},model:{value:(_vm.errorAlert),callback:function ($$v) {_vm.errorAlert=$$v},expression:"errorAlert"}},[_vm._v(_vm._s(_vm.errorAlertText))])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("cerrar")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"green","loading":_vm.updatingGuest},on:{"click":_vm.createGuest}},[_vm._v("actualizar")])],1)],1)],1)}
var UpdateGuestDialog_staticRenderFns = []
var UpdateGuestDialog_esExports = { render: UpdateGuestDialog_render, staticRenderFns: UpdateGuestDialog_staticRenderFns }
/* harmony default export */ var components_UpdateGuestDialog = (UpdateGuestDialog_esExports);
// CONCATENATED MODULE: ./src/components/UpdateGuestDialog.vue
var UpdateGuestDialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UpdateGuestDialog___vue_template_functional__ = false
/* styles */
var UpdateGuestDialog___vue_styles__ = null
/* scopeId */
var UpdateGuestDialog___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UpdateGuestDialog___vue_module_identifier__ = null
var UpdateGuestDialog_Component = UpdateGuestDialog_normalizeComponent(
  UpdateGuestDialog,
  components_UpdateGuestDialog,
  UpdateGuestDialog___vue_template_functional__,
  UpdateGuestDialog___vue_styles__,
  UpdateGuestDialog___vue_scopeId__,
  UpdateGuestDialog___vue_module_identifier__
)

/* harmony default export */ var src_components_UpdateGuestDialog = (UpdateGuestDialog_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Guests.vue


 //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_Guests = ({
  name: 'guests',
  data: function data() {
    return {
      guestToRemove: null,
      confirmRemoveGuestDialog: false,
      removingGuest: false
    };
  },
  computed: {
    guests: function guests() {
      return this.$store.getters['Guests/guests'];
    },
    vehicles: function vehicles() {
      return this.$store.state.Guests.vehicles;
    },
    permissions: function permissions() {
      return this.$store.state.Guests.permissions;
    }
  },
  created: function created() {
    this.$store.dispatch('Guests/fetchVehicles');
    this.$store.dispatch('Guests/fetchGuests');
    this.$store.dispatch('Guests/fetchPermissions');
  },
  components: {
    'create-guest-dialog': src_components_CreateGuestDialog,
    'update-guest-dialog': src_components_UpdateGuestDialog
  },
  methods: {
    openUpdateGuestDialog: function openUpdateGuestDialog(_ref) {
      var guest = _ref.guest;

      this.$refs.updateGuestDialog.open({ guest: guest });
    },
    openCreateGuestDialog: function openCreateGuestDialog() {
      this.$refs.createGuestDialog.open();
    },
    createGuest: function () {
      var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref3) {
        var guest = _ref3.guest;
        var message;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.$store.dispatch('Guests/createGuest', { guest: guest });

              case 3:
                _context.next = 10;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context['catch'](0);
                message = _context.t0.graphQLErrors[0] ? _context.t0.graphQLErrors[0].message : 'Ooops, ha ocurrido un error';

                this.$refs.createGuestDialog.displayError(message);
                return _context.abrupt('return', console.error(_context.t0));

              case 10:
                this.$refs.createGuestDialog.close();

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 5]]);
      }));

      function createGuest(_x) {
        return _ref2.apply(this, arguments);
      }

      return createGuest;
    }(),
    updateGuest: function () {
      var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(_ref5) {
        var _id = _ref5._id,
            guest = _ref5.guest;
        var message;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.$store.dispatch('Guests/updateGuest', { _id: _id, guest: guest });

              case 3:
                _context2.next = 10;
                break;

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2['catch'](0);
                message = _context2.t0.graphQLErrors[0] ? _context2.t0.graphQLErrors[0].message : 'Ooops, ha ocurrido un error';

                this.$refs.updateGuestDialog.displayError(message);
                return _context2.abrupt('return', console.error(_context2.t0));

              case 10:
                this.$refs.updateGuestDialog.close();

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 5]]);
      }));

      function updateGuest(_x2) {
        return _ref4.apply(this, arguments);
      }

      return updateGuest;
    }(),
    openConfirmRemoveGuestDialog: function openConfirmRemoveGuestDialog(_ref6) {
      var _id = _ref6._id;

      var guest = find_default()(this.guests, { _id: _id });
      if (!guest) return false;
      this.guestToRemove = guest;
      this.confirmRemoveGuestDialog = true;
    },
    removeGuest: function () {
      var _ref7 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!this.guestToRemove || !this.guestToRemove._id)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return', false);

              case 2:
                this.removingGuest = true;
                _context3.next = 5;
                return this.$store.dispatch('Guests/removeGuest', { _id: this.guestToRemove._id });

              case 5:
                this.removingGuest = false;
                this.confirmRemoveGuestDialog = false;

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function removeGuest() {
        return _ref7.apply(this, arguments);
      }

      return removeGuest;
    }()
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19da4d6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Guests.vue
var components_Guests_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"white",attrs:{"id":"navigation-drawer-view"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('v-card',{staticClass:"mt-3",attrs:{"color":"blue darken-1 white--text"}},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('div',{staticClass:"display-1 my-3"},[_vm._v("Otorga acceso a tus vehículos")])]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('div',{staticClass:"body-1"},[_vm._v("\n                Invitados te permite compartir tus vehículos a través de una nueva cuenta\n                que podrás crear a continuación.\n              ")])])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"guests mt-3"},[_c('v-list',{attrs:{"two-line":"","subheader":""}},[_c('v-subheader',[_vm._v("Invitados")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._l((_vm.guests),function(guest,index){return _c('v-flex',{key:index,attrs:{"xs12":"","sm6":"","md4":"","xl3":""}},[_c('v-list-tile',{staticClass:"guest-tile",attrs:{"avatar":""},on:{"click":function($event){return _vm.openUpdateGuestDialog({ guest: guest })}}},[_c('v-list-tile-avatar',[_c('v-icon',{staticClass:"primary white--text"},[_vm._v("person")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(guest.name))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(guest.username))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.openConfirmRemoveGuestDialog({ _id: guest._id })}}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("delete")])],1)],1)],1)],1)}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":"","xl3":""}},[_c('v-list-tile',{staticClass:"create-guest-tile",attrs:{"avatar":""},on:{"click":_vm.openCreateGuestDialog}},[_c('v-list-tile-avatar',[_c('v-icon',{staticClass:"green lighten-1 white--text"},[_vm._v("add")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Agregar Invitado")])],1)],1)],1)],2)],1)],1)])],1)],1),_vm._v(" "),_c('create-guest-dialog',{ref:"createGuestDialog",attrs:{"vehicles":_vm.vehicles,"permissions":_vm.permissions},on:{"create-guest":_vm.createGuest}}),_vm._v(" "),_c('update-guest-dialog',{ref:"updateGuestDialog",attrs:{"vehicles":_vm.vehicles,"permissions":_vm.permissions},on:{"update-guest":_vm.updateGuest}}),_vm._v(" "),(_vm.guestToRemove)?_c('v-dialog',{staticClass:"confirm-remove-guest-dialog",attrs:{"max-width":290},model:{value:(_vm.confirmRemoveGuestDialog),callback:function ($$v) {_vm.confirmRemoveGuestDialog=$$v},expression:"confirmRemoveGuestDialog"}},[_c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("¿Realmente desea eliminar el invitado "+_vm._s(_vm.guestToRemove.username)+"?")])]),_vm._v(" "),_c('v-card-text',[_vm._v("\n        Si elimina la cuenta, el invitado no tendrá acceso a sus vehículos.\n      ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.confirmRemoveGuestDialog = false}}},[_vm._v("cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary","loading":_vm.removingGuest},on:{"click":_vm.removeGuest}},[_vm._v("eliminar")])],1)],1)],1):_vm._e()],1)}
var components_Guests_staticRenderFns = []
var components_Guests_esExports = { render: components_Guests_render, staticRenderFns: components_Guests_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Guests = (components_Guests_esExports);
// CONCATENATED MODULE: ./src/components/Guests.vue
var components_Guests_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var components_Guests___vue_template_functional__ = false
/* styles */
var components_Guests___vue_styles__ = null
/* scopeId */
var components_Guests___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var components_Guests___vue_module_identifier__ = null
var components_Guests_Component = components_Guests_normalizeComponent(
  components_Guests,
  selectortype_template_index_0_src_components_Guests,
  components_Guests___vue_template_functional__,
  components_Guests___vue_styles__,
  components_Guests___vue_scopeId__,
  components_Guests___vue_module_identifier__
)

/* harmony default export */ var src_components_Guests = (components_Guests_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ConfirmEmail.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ConfirmEmail = ({
  name: 'confirm-email',
  data: function data() {
    return {
      loading: true
    };
  },
  computed: {
    clientName: function clientName() {
      return this.$store.state.ConfirmEmail.clientName;
    }
  },
  mounted: function () {
    var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$store.dispatch('ConfirmEmail/activateEmail', { token: this.$route.params.token });

            case 2:
              this.loading = false;

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }()
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-612baa7b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfirmEmail.vue
var ConfirmEmail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-card',{staticClass:"mt-3 pa-3",attrs:{"color":"green lighten-5"}},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[(_vm.loading)?_c('div',{staticClass:"display-1 my-3"},[_vm._v("Estamos activando tu correo electrónico...")]):_c('div',{staticClass:"display-1 my-3"},[_vm._v(_vm._s(_vm.clientName)+", tu correo electrónico ha sido activado.")])])],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","size":100,"color":"primary"}}):_c('v-icon',{attrs:{"large":"","color":"green"}},[_vm._v("check")])],1)],1)],1)],1)],1)],1)}
var ConfirmEmail_staticRenderFns = []
var ConfirmEmail_esExports = { render: ConfirmEmail_render, staticRenderFns: ConfirmEmail_staticRenderFns }
/* harmony default export */ var components_ConfirmEmail = (ConfirmEmail_esExports);
// CONCATENATED MODULE: ./src/components/ConfirmEmail.vue
var ConfirmEmail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ConfirmEmail___vue_template_functional__ = false
/* styles */
var ConfirmEmail___vue_styles__ = null
/* scopeId */
var ConfirmEmail___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ConfirmEmail___vue_module_identifier__ = null
var ConfirmEmail_Component = ConfirmEmail_normalizeComponent(
  ConfirmEmail,
  components_ConfirmEmail,
  ConfirmEmail___vue_template_functional__,
  ConfirmEmail___vue_styles__,
  ConfirmEmail___vue_scopeId__,
  ConfirmEmail___vue_module_identifier__
)

/* harmony default export */ var src_components_ConfirmEmail = (ConfirmEmail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ForgotPassword.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ForgotPassword = ({
  name: 'forgot-password',
  data: function data() {
    return {
      errorAlert: false,
      errorAlertMessage: '',
      successAlert: false,
      successAlertMessage: '',
      valid: false,
      loading: false,
      emailAddress: '',
      emailAddressRules: [function (value) {
        return !!value || 'Correo electrónico requerido';
      }, function (value) {
        return (/^([a-z0-9_.-]+)@([a-z0-9.-]+)\.([a-z.]{2,6})$/.test(value) || 'Correo electrónico inválido'
        );
      }]
    };
  },
  methods: {
    submit: function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var message;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.$refs.form.validate()) {
                  _context.next = 20;
                  break;
                }

                this.loading = true;
                _context.prev = 2;
                _context.next = 5;
                return forgotPassword({ email: this.emailAddress });

              case 5:
                _context.next = 15;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](2);

                this.$refs.form.reset();
                this.loading = false;
                message = _context.t0.message || 'Ooops, ha ocurrido un error';

                this.errorAlertMessage = message;
                this.errorAlert = true;
                return _context.abrupt('return', false);

              case 15:
                this.$refs.form.reset();
                this.loading = false;
                this.errorAlert = false;
                this.successAlertMessage = 'Revisa tu correo electrónico para continuar con el proceso de recuperación de tu cuenta';
                this.successAlert = true;

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 7]]);
      }));

      function submit() {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de41378c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ForgotPassword.vue
var ForgotPassword_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","lg6":""}},[_c('v-card',{staticClass:"mt-3 pa-3",attrs:{"color":"grey lighten-3"}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Recupera tu cuenta")])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-subheader',[_vm._v("Introduce el correo electrónico para buscar tu cuenta.")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs11":""}},[_c('v-text-field',{attrs:{"label":"Correo electrónico","rules":_vm.emailAddressRules,"required":""},model:{value:(_vm.emailAddress),callback:function ($$v) {_vm.emailAddress=$$v},expression:"emailAddress"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"color":"error","icon":"error"},model:{value:(_vm.errorAlert),callback:function ($$v) {_vm.errorAlert=$$v},expression:"errorAlert"}},[_vm._v(_vm._s(_vm.errorAlertMessage))]),_vm._v(" "),_c('v-alert',{attrs:{"color":"success","icon":"check"},model:{value:(_vm.successAlert),callback:function ($$v) {_vm.successAlert=$$v},expression:"successAlert"}},[_vm._v(_vm._s(_vm.successAlertMessage))])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){return _vm.$refs.form.reset()}}},[_vm._v("limpiar")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"success","loading":_vm.loading},on:{"click":_vm.submit}},[_vm._v("buscar")])],1)],1)],1)],1)],1)],1)}
var ForgotPassword_staticRenderFns = []
var ForgotPassword_esExports = { render: ForgotPassword_render, staticRenderFns: ForgotPassword_staticRenderFns }
/* harmony default export */ var components_ForgotPassword = (ForgotPassword_esExports);
// CONCATENATED MODULE: ./src/components/ForgotPassword.vue
var ForgotPassword_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ForgotPassword___vue_template_functional__ = false
/* styles */
var ForgotPassword___vue_styles__ = null
/* scopeId */
var ForgotPassword___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ForgotPassword___vue_module_identifier__ = null
var ForgotPassword_Component = ForgotPassword_normalizeComponent(
  ForgotPassword,
  components_ForgotPassword,
  ForgotPassword___vue_template_functional__,
  ForgotPassword___vue_styles__,
  ForgotPassword___vue_scopeId__,
  ForgotPassword___vue_module_identifier__
)

/* harmony default export */ var src_components_ForgotPassword = (ForgotPassword_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ResetPassword.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ResetPassword = ({
  name: 'reset-password',
  data: function data() {
    var _this = this;

    return {
      errorAlert: false,
      errorAlertMessage: '',
      successAlert: false,
      successAlertMessage: '',
      valid: false,
      loading: false,
      password: '',
      confirmPassword: '',
      passwordRules: [function (value) {
        return !!value || 'Campo requerido';
      }, function (value) {
        return value && value.length <= 24 || 'La contraseña debe contener menos de 24 caracteres';
      }, function (value) {
        return (/^[a-zA-Z0-9_.-]+$/.test(value) || 'Contraseña inválida'
        );
      }],
      confirmPasswordRules: [function (value) {
        return value === _this.password || 'Las contraseñas no coinciden';
      }]
    };
  },
  methods: {
    submit: function () {
      var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var message;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.$refs.form.validate()) {
                  _context.next = 20;
                  break;
                }

                this.loading = true;
                _context.prev = 2;
                _context.next = 5;
                return resetPassword({
                  password: this.password,
                  token: this.$route.params.token
                });

              case 5:
                _context.next = 15;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](2);

                this.$refs.form.reset();
                this.loading = false;
                message = _context.t0.message || 'Ooops, ha ocurrido un error';

                this.errorAlertMessage = message;
                this.errorAlert = true;
                return _context.abrupt('return', false);

              case 15:
                this.$refs.form.reset();
                this.loading = false;
                this.errorAlert = false;
                this.successAlertMessage = 'Enhorabuena, tu contraseña ha sido reestablecida con éxito';
                this.successAlert = true;

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 7]]);
      }));

      function submit() {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fceb02da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResetPassword.vue
var ResetPassword_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","lg6":""}},[_c('v-card',{staticClass:"mt-3 pa-3",attrs:{"color":"grey lighten-3"}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Reestablece tu contraseña")])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-subheader',[_vm._v("Introduce tu nueva contraseña.")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-flex',{attrs:{"xs11":""}},[_c('v-text-field',{attrs:{"label":"Contraseña nueva","counter":24,"rules":_vm.passwordRules,"type":"password","required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Confirmar contraseña nueva","counter":24,"rules":_vm.confirmPasswordRules,"type":"password","required":""},model:{value:(_vm.confirmPassword),callback:function ($$v) {_vm.confirmPassword=$$v},expression:"confirmPassword"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-alert',{attrs:{"color":"error","icon":"error"},model:{value:(_vm.errorAlert),callback:function ($$v) {_vm.errorAlert=$$v},expression:"errorAlert"}},[_vm._v(_vm._s(_vm.errorAlertMessage))]),_vm._v(" "),_c('v-alert',{attrs:{"color":"success","icon":"check"},model:{value:(_vm.successAlert),callback:function ($$v) {_vm.successAlert=$$v},expression:"successAlert"}},[_vm._v(_vm._s(_vm.successAlertMessage))])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){return _vm.$refs.form.reset()}}},[_vm._v("limpiar")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"success","loading":_vm.loading},on:{"click":_vm.submit}},[_vm._v("reestablecer")])],1)],1)],1)],1)],1)],1)}
var ResetPassword_staticRenderFns = []
var ResetPassword_esExports = { render: ResetPassword_render, staticRenderFns: ResetPassword_staticRenderFns }
/* harmony default export */ var components_ResetPassword = (ResetPassword_esExports);
// CONCATENATED MODULE: ./src/components/ResetPassword.vue
var ResetPassword_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ResetPassword___vue_template_functional__ = false
/* styles */
var ResetPassword___vue_styles__ = null
/* scopeId */
var ResetPassword___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ResetPassword___vue_module_identifier__ = null
var ResetPassword_Component = ResetPassword_normalizeComponent(
  ResetPassword,
  components_ResetPassword,
  ResetPassword___vue_template_functional__,
  ResetPassword___vue_styles__,
  ResetPassword___vue_scopeId__,
  ResetPassword___vue_module_identifier__
)

/* harmony default export */ var src_components_ResetPassword = (ResetPassword_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js



var router__this = this;




















vue_esm["default"].use(vue_router_esm["a" /* default */]);

var router = new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/',
    redirect: '/app/tracking'
  }, {
    name: 'login',
    path: '/login',
    component: src_views_Login
  }, {
    name: 'confirm-email',
    path: '/confirm-email/:token',
    component: src_components_ConfirmEmail
  }, {
    name: 'forgot-password',
    path: '/forgot-password',
    component: src_components_ForgotPassword
  }, {
    name: 'reset-password',
    path: '/reset-password/:token',
    component: src_components_ResetPassword
  }, {
    path: '/app',
    component: src_components_Layout,
    children: [{
      name: 'tracking',
      path: 'tracking',
      component: src_views_Tracking
    }, {
      name: 'geofences',
      path: 'geofences',
      component: src_components_Geofences
    }, {
      name: 'routes',
      path: 'routes',
      component: src_components_Routes
    }, {
      name: 'places',
      path: 'places',
      component: src_components_Places
    }, {
      name: 'reports',
      path: 'reports',
      component: src_views_Reports
    }, {
      name: 'travels',
      path: 'travels',
      component: src_views_Travels
    }, {
      name: 'profile',
      path: 'profile',
      component: src_views_Profile
    }, {
      name: 'help',
      path: 'help',
      component: src_views_Help
    }, {
      name: 'guests',
      path: 'guests',
      component: src_components_Guests
    }]
  }]
});

router.beforeEach(function () {
  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(to, from, next) {
    var whitelist, guestsBlacklist, isWithinWhitelist, token, tokenIsValid, sessionIsGuest, isWithinBlacklist, lastPath;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            whitelist = ['login', 'forgot-password', 'reset-password'];
            guestsBlacklist = ['guests'];
            isWithinWhitelist = whitelist.indexOf(to.name) !== -1;

            if (!isWithinWhitelist) {
              _context.next = 5;
              break;
            }

            return _context.abrupt('return', next());

          case 5:
            token = localStorage.getItem('heimdall-session-token');

            if (token) {
              _context.next = 9;
              break;
            }

            localStorage.setItem('heimdall-session-last-path', to.path);
            return _context.abrupt('return', next('/login'));

          case 9:
            _context.next = 11;
            return validateToken(token);

          case 11:
            tokenIsValid = _context.sent;

            if (tokenIsValid) {
              _context.next = 15;
              break;
            }

            localStorage.setItem('heimdall-session-last-path', to.path);
            return _context.abrupt('return', next('/login'));

          case 15:
            sessionIsGuest = JSON.parse(localStorage.getItem('heimdall-session-is-guest'));

            if (!sessionIsGuest) {
              _context.next = 20;
              break;
            }

            isWithinBlacklist = guestsBlacklist.indexOf(to.name) !== -1;

            if (!isWithinBlacklist) {
              _context.next = 20;
              break;
            }

            return _context.abrupt('return', next(false));

          case 20:
            lastPath = localStorage.getItem('heimdall-session-last-path');

            if (!lastPath) {
              _context.next = 24;
              break;
            }

            localStorage.removeItem('heimdall-session-last-path');
            return _context.abrupt('return', next(lastPath));

          case 24:
            return _context.abrupt('return', next());

          case 25:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, router__this);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());

/* harmony default export */ var src_router = (router);
// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/lodash/findIndex.js
var findIndex = __webpack_require__("KgVm");
var findIndex_default = /*#__PURE__*/__webpack_require__.n(findIndex);

// CONCATENATED MODULE: ./src/store/mutation-types.js
var SET_INDICATORS = 'SET_INDICATORS';
var SET_VEHICLE = 'SET_VEHICLE';
var SET_VEHICLES = 'SET_VEHICLES';
var SET_GUESTS = 'SET_GUESTS';
var CREATE_GUEST = 'CREATE_GUEST';
var SET_EVENT = 'SET_EVENT';
var SET_EVENTS = 'SET_EVENTS';
var SET_PERMISSIONS = 'SET_PERMISSIONS';
var SET_COMMAND_TRANSFER_STATUS = 'SET_COMMAND_TRANSFER_STATUS';
var SET_CLIENT = 'SET_CLIENT';
var SET_CLIENT_NAME = 'SET_CLIENT_NAME';
var UNSHIFT_EVENT = 'UNSHIFT_EVENT';
var UPDATE_POSITION = 'UPDATE_POSITION';
var SET_SHAPES = 'SET_SHAPES';
// EXTERNAL MODULE: ./node_modules/apollo-link-http/lib/bundle.esm.js + 1 modules
var bundle_esm = __webpack_require__("gyJL");

// EXTERNAL MODULE: ./node_modules/apollo-client/bundle.esm.js + 1 modules
var apollo_client_bundle_esm = __webpack_require__("ZEWO");

// EXTERNAL MODULE: ./node_modules/apollo-link/lib/bundle.esm.js + 1 modules
var lib_bundle_esm = __webpack_require__("4bvt");

// EXTERNAL MODULE: ./node_modules/apollo-cache-inmemory/lib/bundle.esm.js + 1 modules
var apollo_cache_inmemory_lib_bundle_esm = __webpack_require__("1bcK");

// CONCATENATED MODULE: ./src/api/apollo.js




var GRAPHQL_URL = "http://api.web.rastreosigloxxi.io:3000/graphql";

var httpLink = new bundle_esm["a" /* HttpLink */]({ uri: GRAPHQL_URL || 'http://localhost:3000/graphql' });
var authMiddleware = new lib_bundle_esm["a" /* ApolloLink */](function (operation, forward) {
  var token = localStorage.getItem('heimdall-session-token');
  operation.setContext({
    headers: {
      authorization: token ? 'Bearer ' + token : null
    }
  });
  return forward(operation);
});

var apollo_client = new apollo_client_bundle_esm["a" /* default */]({
  link: Object(lib_bundle_esm["c" /* concat */])(authMiddleware, httpLink),
  cache: new apollo_cache_inmemory_lib_bundle_esm["a" /* InMemoryCache */]()
});

/* harmony default export */ var apollo = (apollo_client);
// CONCATENATED MODULE: ./src/api/events.js







var EVENTS_URL = "ws://api.web.rastreosigloxxi.io:3002/events-subscribers";

var events_EventsSubscribersClient = function (_EventEmitter) {
  inherits_default()(EventsSubscribersClient, _EventEmitter);

  function EventsSubscribersClient() {
    classCallCheck_default()(this, EventsSubscribersClient);

    var _this = possibleConstructorReturn_default()(this, (EventsSubscribersClient.__proto__ || get_prototype_of_default()(EventsSubscribersClient)).call(this));

    _this._isConnected = false;
    _this._url = EVENTS_URL;
    _this._socket = {};
    return _this;
  }

  createClass_default()(EventsSubscribersClient, [{
    key: 'connect',
    value: function connect() {
      var _this2 = this;

      var token = localStorage.getItem('heimdall-session-token');
      this._socket = new WebSocket(this._url + '?token=' + token);
      this._socket.onerror = function (err) {
        console.error(err);
      };
      this._socket.onopen = function (event) {
        _this2._isConnected = true;
        _this2.emit('connection', event);
      };
      this._socket.onmessage = function (message) {
        var data = JSON.parse(message.data);
        var notification = data.notification;
        _this2.emit(notification, data[notification]);
      };
    }
  }, {
    key: 'subscribe',
    value: function subscribe() {
      this._socket.send(stringify_default()({
        event: 'subscribe-to-events-room'
      }));
    }
  }, {
    key: 'subscribeToPositions',
    value: function subscribeToPositions() {
      this._socket.send(stringify_default()({
        event: 'subscribe-to-positions-room'
      }));
    }
  }, {
    key: 'unsubscribe',
    value: function unsubscribe() {
      if (this._socket.readyState !== 1) {
        return false;
      }
      this._socket.send(stringify_default()({
        event: 'unsubscribe-from-events-room'
      }));
    }
  }, {
    key: 'watchVehicle',
    value: function watchVehicle(vehicleId) {
      this._socket.send(stringify_default()({
        event: 'update-watched-vehicle',
        vehicleId: vehicleId
      }));
    }
  }, {
    key: 'watchVehiclesPositions',
    value: function watchVehiclesPositions(vehicles) {
      this._socket.send(stringify_default()({
        event: 'watch-vehicles-positions',
        vehicles: vehicles
      }));
    }
  }, {
    key: 'isConnected',
    get: function get() {
      return this._isConnected;
    }
  }]);

  return EventsSubscribersClient;
}(events_default.a);

/* harmony default export */ var api_events = (events_EventsSubscribersClient);
// EXTERNAL MODULE: ./src/graphql/queries/Tracking/FetchVehicles.graphql
var FetchVehicles_graphql = __webpack_require__("6a2R");
var FetchVehicles_graphql_default = /*#__PURE__*/__webpack_require__.n(FetchVehicles_graphql);

// EXTERNAL MODULE: ./src/graphql/queries/Tracking/FetchVehicleLastEvent.graphql
var FetchVehicleLastEvent_graphql = __webpack_require__("FHHX");
var FetchVehicleLastEvent_graphql_default = /*#__PURE__*/__webpack_require__.n(FetchVehicleLastEvent_graphql);

// CONCATENATED MODULE: ./src/store/modules/tracking/index.js








var _mutations;










var eventsClient = new api_events();
var tracking_module = {
  namespaced: true,
  state: {
    events: [],
    vehicles: []
  },
  getters: {
    events: function events(state) {
      return state.events.map(function (event) {
        return {
          _id: event._id,
          name: event.name,
          date: moment_default()(event.gpsDate).fromNow(),
          highPriority: event.highPriority
        };
      });
    }
  },
  mutations: (_mutations = {}, defineProperty_default()(_mutations, UNSHIFT_EVENT, function (state, _ref) {
    var event = _ref.event;

    state.events = [event].concat(toConsumableArray_default()(state.events));
  }), defineProperty_default()(_mutations, SET_EVENTS, function (state, _ref2) {
    var events = _ref2.events;

    state.events = events;
  }), defineProperty_default()(_mutations, UPDATE_POSITION, function (state, _ref3) {
    var position = _ref3.position;

    var vehicle = find_default()(state.vehicles, { _id: position.vehicleId });
    var vehicleIndex = findIndex_default()(state.vehicles, { _id: position.vehicleId });
    if (!vehicle || vehicleIndex === -1) throw new Error('Vehicle not found in store');
    vehicle.position = { lat: position.lat, lng: position.lng };
    state.vehicles.splice(vehicleIndex, 1, vehicle);
  }), defineProperty_default()(_mutations, SET_VEHICLES, function (state, _ref4) {
    var vehicles = _ref4.vehicles;

    state.vehicles = vehicles.map(function (vehicle) {
      var position = void 0;
      if (vehicle.lastEvent && vehicle.lastEvent.data && vehicle.lastEvent.data.gps) {
        position = {
          lat: vehicle.lastEvent.data.gps.latitude || 0,
          lng: vehicle.lastEvent.data.gps.longitude || 0
        };
      }
      return {
        _id: vehicle._id,
        plate: vehicle.plate,
        position: position
      };
    });
  }), _mutations),
  actions: {
    connectToEventsServer: function connectToEventsServer(_ref5) {
      var commit = _ref5.commit;

      return new promise_default.a(function (resolve, reject) {
        eventsClient.connect();
        eventsClient.once('connection', function (event) {
          if (false) {
            console.log('Connected to events subscribers server');
          }
          return resolve(event);
        });
      });
    },
    subscribeToEvents: function subscribeToEvents(_ref6) {
      var commit = _ref6.commit;

      eventsClient.subscribe();
      eventsClient.on('event', function (event) {
        commit(UNSHIFT_EVENT, { event: event });
      });
      eventsClient.on('position', function (position) {
        commit(UPDATE_POSITION, { position: position });
      });
    },
    unsubscribeFromEvents: function unsubscribeFromEvents(_ref7) {
      var commit = _ref7.commit;

      eventsClient.unsubscribe();
      eventsClient.removeAllListeners();
    },
    watchVehicle: function watchVehicle(context, _ref8) {
      var vehicleId = _ref8.vehicleId;

      eventsClient.watchVehicle(vehicleId);
    },
    fetchVehicles: function fetchVehicles(_ref9) {
      var _this = this;

      var commit = _ref9.commit;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var result, vehicles;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return apollo.query({
                  query: FetchVehicles_graphql_default.a
                });

              case 2:
                result = _context.sent;
                vehicles = result.data.fetchVehicles;

                commit(SET_VEHICLES, { vehicles: vehicles });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetchVehicleLastEvent: function fetchVehicleLastEvent(_ref10, _ref11) {
      var _this2 = this;

      var commit = _ref10.commit;
      var vehicleId = _ref11.vehicleId;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var result, lastEvent;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return apollo.query({
                  query: FetchVehicleLastEvent_graphql_default.a,
                  variables: {
                    vehicleId: vehicleId
                  }
                });

              case 2:
                result = _context2.sent;
                lastEvent = result.data.fetchVehicleById.lastEvent;

                if (lastEvent) {
                  _context2.next = 7;
                  break;
                }

                commit(SET_EVENTS, { events: [] });
                throw new Error('No se encontró el último evento del vehículo');

              case 7:
                commit(SET_EVENTS, {
                  events: [{
                    _id: lastEvent._id,
                    gpsDate: lastEvent.data.gps.date,
                    name: lastEvent.name,
                    highPriority: lastEvent.highPriority
                  }]
                });

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
};

/* harmony default export */ var tracking = (tracking_module);
// EXTERNAL MODULE: ./src/graphql/queries/Geofences/Shapes.graphql
var Shapes_graphql = __webpack_require__("vq0I");
var Shapes_graphql_default = /*#__PURE__*/__webpack_require__.n(Shapes_graphql);

// EXTERNAL MODULE: ./src/graphql/queries/Geofences/FetchVehicles.graphql
var Geofences_FetchVehicles_graphql = __webpack_require__("DkdU");
var Geofences_FetchVehicles_graphql_default = /*#__PURE__*/__webpack_require__.n(Geofences_FetchVehicles_graphql);

// EXTERNAL MODULE: ./src/graphql/mutations/Geofences/CreateShape.graphql
var CreateShape_graphql = __webpack_require__("e7B0");
var CreateShape_graphql_default = /*#__PURE__*/__webpack_require__.n(CreateShape_graphql);

// EXTERNAL MODULE: ./src/graphql/mutations/Geofences/UpdateShape.graphql
var UpdateShape_graphql = __webpack_require__("/IWP");
var UpdateShape_graphql_default = /*#__PURE__*/__webpack_require__.n(UpdateShape_graphql);

// EXTERNAL MODULE: ./src/graphql/mutations/Geofences/RemoveShape.graphql
var RemoveShape_graphql = __webpack_require__("R9cU");
var RemoveShape_graphql_default = /*#__PURE__*/__webpack_require__.n(RemoveShape_graphql);

// CONCATENATED MODULE: ./src/store/modules/geofences/index.js







var geofences__mutations;












var geofences_eventsClient = new api_events();
var geofences_module = {
  namespaced: true,
  state: {
    shapes: [],
    vehicles: []
  },
  mutations: (geofences__mutations = {}, defineProperty_default()(geofences__mutations, SET_VEHICLES, function (state, _ref) {
    var vehicles = _ref.vehicles;

    state.vehicles = vehicles.map(function (vehicle) {
      var position = void 0;
      if (vehicle.lastEvent && vehicle.lastEvent.data && vehicle.lastEvent.data.gps) {
        position = {
          lat: vehicle.lastEvent.data.gps.latitude || 0,
          lng: vehicle.lastEvent.data.gps.longitude || 0
        };
      }
      return {
        _id: vehicle._id,
        plate: vehicle.plate,
        position: position
      };
    });
  }), defineProperty_default()(geofences__mutations, SET_SHAPES, function (state, _ref2) {
    var shapes = _ref2.shapes;

    state.shapes = shapes;
  }), defineProperty_default()(geofences__mutations, UPDATE_POSITION, function (state, _ref3) {
    var position = _ref3.position;

    var vehicle = find_default()(state.vehicles, { _id: position.vehicleId });
    var vehicleIndex = findIndex_default()(state.vehicles, { _id: position.vehicleId });
    if (!vehicle || vehicleIndex === -1) throw new Error('Vehicle not found in store');
    vehicle.position = { lat: position.lat, lng: position.lng };
    state.vehicles.splice(vehicleIndex, 1, vehicle);
  }), geofences__mutations),
  actions: {
    connectToEventsServer: function connectToEventsServer(_ref4) {
      var commit = _ref4.commit;

      return new promise_default.a(function (resolve, reject) {
        geofences_eventsClient.connect();
        geofences_eventsClient.once('connection', function (event) {
          if (false) {
            console.log('Connected to events subscribers server');
          }
          return resolve(event);
        });
      });
    },
    subscribeToPositions: function subscribeToPositions(_ref5) {
      var commit = _ref5.commit;

      geofences_eventsClient.subscribeToPositions();
      geofences_eventsClient.on('position', function (position) {
        commit(UPDATE_POSITION, { position: position });
      });
    },
    unsubscribeFromEvents: function unsubscribeFromEvents(_ref6) {
      var commit = _ref6.commit;

      geofences_eventsClient.unsubscribe();
      geofences_eventsClient.removeAllListeners();
    },
    createShape: function createShape(_ref7, _ref8) {
      var _this = this;

      var commit = _ref7.commit;
      var shape = _ref8.shape;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var result, shapes;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return apollo.mutate({
                  mutation: CreateShape_graphql_default.a,
                  variables: {
                    shape: shape
                  }
                });

              case 2:
                result = _context.sent;
                shapes = result.data.createGeofence;

                commit(SET_SHAPES, { shapes: shapes });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetchVehicles: function fetchVehicles(_ref9) {
      var _this2 = this;

      var commit = _ref9.commit;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var result, vehicles;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return apollo.query({
                  query: Geofences_FetchVehicles_graphql_default.a
                });

              case 2:
                result = _context2.sent;
                vehicles = result.data.fetchVehicles;

                commit(SET_VEHICLES, { vehicles: vehicles });

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    fetchShapes: function fetchShapes(_ref10) {
      var _this3 = this;

      var commit = _ref10.commit;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var result, shapes;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return apollo.query({
                  query: Shapes_graphql_default.a
                });

              case 2:
                result = _context3.sent;
                shapes = result.data.fetchGeofences;

                commit(SET_SHAPES, { shapes: shapes });

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    updateShape: function updateShape(_ref11, _ref12) {
      var _this4 = this;

      var commit = _ref11.commit;
      var shapeId = _ref12.shapeId,
          shape = _ref12.shape;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var result, shapes;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return apollo.mutate({
                  mutation: UpdateShape_graphql_default.a,
                  variables: {
                    shapeId: shapeId,
                    shape: shape
                  }
                });

              case 2:
                result = _context4.sent;
                shapes = result.data.updateGeofence;

                commit(SET_SHAPES, { shapes: shapes });

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    removeShape: function removeShape(_ref13, _ref14) {
      var _this5 = this;

      var commit = _ref13.commit;
      var shapeId = _ref14.shapeId;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var result, shapes;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return apollo.mutate({
                  mutation: RemoveShape_graphql_default.a,
                  variables: {
                    shapeId: shapeId
                  }
                });

              case 2:
                result = _context5.sent;
                shapes = result.data.removeGeofence;

                commit(SET_SHAPES, { shapes: shapes });

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    }
  }
};

/* harmony default export */ var modules_geofences = (geofences_module);
// EXTERNAL MODULE: ./src/graphql/queries/Routes/Shapes.graphql
var Routes_Shapes_graphql = __webpack_require__("0S1D");
var Routes_Shapes_graphql_default = /*#__PURE__*/__webpack_require__.n(Routes_Shapes_graphql);

// EXTERNAL MODULE: ./src/graphql/queries/Routes/Vehicles.graphql
var Vehicles_graphql = __webpack_require__("i4C6");
var Vehicles_graphql_default = /*#__PURE__*/__webpack_require__.n(Vehicles_graphql);

// EXTERNAL MODULE: ./src/graphql/mutations/Routes/CreateShape.graphql
var Routes_CreateShape_graphql = __webpack_require__("ESOj");
var Routes_CreateShape_graphql_default = /*#__PURE__*/__webpack_require__.n(Routes_CreateShape_graphql);

// EXTERNAL MODULE: ./src/graphql/mutations/Routes/UpdateShape.graphql
var Routes_UpdateShape_graphql = __webpack_require__("J3Zt");
var Routes_UpdateShape_graphql_default = /*#__PURE__*/__webpack_require__.n(Routes_UpdateShape_graphql);

// EXTERNAL MODULE: ./src/graphql/mutations/Routes/RemoveShape.graphql
var Routes_RemoveShape_graphql = __webpack_require__("XS4J");
var Routes_RemoveShape_graphql_default = /*#__PURE__*/__webpack_require__.n(Routes_RemoveShape_graphql);

// CONCATENATED MODULE: ./src/store/modules/routes/index.js




var routes__mutations;










var routes_module = {
  namespaced: true,
  state: {
    shapes: [],
    vehicles: []
  },
  mutations: (routes__mutations = {}, defineProperty_default()(routes__mutations, SET_VEHICLES, function (state, _ref) {
    var vehicles = _ref.vehicles;

    state.vehicles = vehicles;
  }), defineProperty_default()(routes__mutations, SET_SHAPES, function (state, _ref2) {
    var shapes = _ref2.shapes;

    state.shapes = shapes;
  }), routes__mutations),
  actions: {
    createShape: function createShape(_ref3, _ref4) {
      var _this = this;

      var commit = _ref3.commit;
      var shape = _ref4.shape;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var result, shapes;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return apollo.mutate({
                  mutation: Routes_CreateShape_graphql_default.a,
                  variables: {
                    shape: shape
                  }
                });

              case 2:
                result = _context.sent;
                shapes = result.data.createRoute;

                commit(SET_SHAPES, { shapes: shapes });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetchVehicles: function fetchVehicles(_ref5) {
      var _this2 = this;

      var commit = _ref5.commit;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var result, vehicles;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return apollo.query({
                  query: Vehicles_graphql_default.a
                });

              case 2:
                result = _context2.sent;
                vehicles = result.data.fetchVehicles;

                commit(SET_VEHICLES, { vehicles: vehicles });

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    fetchShapes: function fetchShapes(_ref6) {
      var _this3 = this;

      var commit = _ref6.commit;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var result, shapes;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return apollo.query({
                  query: Routes_Shapes_graphql_default.a
                });

              case 2:
                result = _context3.sent;
                shapes = result.data.fetchRoutes;

                commit(SET_SHAPES, { shapes: shapes });

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    updateShape: function updateShape(_ref7, _ref8) {
      var _this4 = this;

      var commit = _ref7.commit;
      var shapeId = _ref8.shapeId,
          shape = _ref8.shape;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var result, shapes;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return apollo.mutate({
                  mutation: Routes_UpdateShape_graphql_default.a,
                  variables: {
                    shapeId: shapeId,
                    shape: shape
                  }
                });

              case 2:
                result = _context4.sent;
                shapes = result.data.updateRoute;

                commit(SET_SHAPES, { shapes: shapes });

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    removeShape: function removeShape(_ref9, _ref10) {
      var _this5 = this;

      var commit = _ref9.commit;
      var shapeId = _ref10.shapeId;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var result, shapes;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return apollo.mutate({
                  mutation: Routes_RemoveShape_graphql_default.a,
                  variables: {
                    shapeId: shapeId
                  }
                });

              case 2:
                result = _context5.sent;
                shapes = result.data.removeRoute;

                commit(SET_SHAPES, { shapes: shapes });

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    }
  }
};

/* harmony default export */ var modules_routes = (routes_module);
// EXTERNAL MODULE: ./src/graphql/queries/Places/Shapes.graphql
var Places_Shapes_graphql = __webpack_require__("jNbB");
var Places_Shapes_graphql_default = /*#__PURE__*/__webpack_require__.n(Places_Shapes_graphql);

// EXTERNAL MODULE: ./src/graphql/mutations/Places/CreateShape.graphql
var Places_CreateShape_graphql = __webpack_require__("aJq1");
var Places_CreateShape_graphql_default = /*#__PURE__*/__webpack_require__.n(Places_CreateShape_graphql);

// EXTERNAL MODULE: ./src/graphql/mutations/Places/UpdateShape.graphql
var Places_UpdateShape_graphql = __webpack_require__("dZW8");
var Places_UpdateShape_graphql_default = /*#__PURE__*/__webpack_require__.n(Places_UpdateShape_graphql);

// EXTERNAL MODULE: ./src/graphql/mutations/Places/RemoveShape.graphql
var Places_RemoveShape_graphql = __webpack_require__("r+Ov");
var Places_RemoveShape_graphql_default = /*#__PURE__*/__webpack_require__.n(Places_RemoveShape_graphql);

// CONCATENATED MODULE: ./src/store/modules/places/index.js











var places_module = {
  namespaced: true,
  state: {
    shapes: []
  },
  mutations: defineProperty_default()({}, SET_SHAPES, function (state, _ref) {
    var shapes = _ref.shapes;

    state.shapes = shapes;
  }),
  actions: {
    createShape: function createShape(_ref2, _ref3) {
      var _this = this;

      var commit = _ref2.commit;
      var shape = _ref3.shape;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var result, shapes;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return apollo.mutate({
                  mutation: Places_CreateShape_graphql_default.a,
                  variables: {
                    shape: shape
                  }
                });

              case 2:
                result = _context.sent;
                shapes = result.data.createPlace;

                commit(SET_SHAPES, { shapes: shapes });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetchShapes: function fetchShapes(_ref4) {
      var _this2 = this;

      var commit = _ref4.commit;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var result, shapes;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return apollo.query({
                  query: Places_Shapes_graphql_default.a
                });

              case 2:
                result = _context2.sent;
                shapes = result.data.fetchPlaces;

                commit(SET_SHAPES, { shapes: shapes });

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    updateShape: function updateShape(_ref5, _ref6) {
      var _this3 = this;

      var commit = _ref5.commit;
      var shapeId = _ref6.shapeId,
          shape = _ref6.shape;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var result, shapes;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return apollo.mutate({
                  mutation: Places_UpdateShape_graphql_default.a,
                  variables: {
                    shapeId: shapeId,
                    shape: shape
                  }
                });

              case 2:
                result = _context3.sent;
                shapes = result.data.updatePlace;

                commit(SET_SHAPES, { shapes: shapes });

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    removeShape: function removeShape(_ref7, _ref8) {
      var _this4 = this;

      var commit = _ref7.commit;
      var shapeId = _ref8.shapeId;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var result, shapes;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return apollo.mutate({
                  mutation: Places_RemoveShape_graphql_default.a,
                  variables: {
                    shapeId: shapeId
                  }
                });

              case 2:
                result = _context4.sent;
                shapes = result.data.removePlace;

                commit(SET_SHAPES, { shapes: shapes });

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    }
  }
};

/* harmony default export */ var modules_places = (places_module);
// CONCATENATED MODULE: ./src/api/indicators.js



var indicators_fetchIndicators = function () {
  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref2) {
    var vehicleId = _ref2.vehicleId,
        mark = _ref2.mark,
        reference = _ref2.reference,
        startDate = _ref2.startDate,
        finishDate = _ref2.finishDate;
    var path, response;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            path = '/indicators/' + mark + '/' + reference + '/' + vehicleId + '/' + startDate + '/' + finishDate;
            response = void 0;
            _context.prev = 2;
            _context.next = 5;
            return indicators_client.get(path);

          case 5:
            response = _context.sent;
            _context.next = 12;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context['catch'](2);

            console.error(_context.t0);
            return _context.abrupt('return', []);

          case 12:
            return _context.abrupt('return', response.data);

          case 13:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[2, 8]]);
  }));

  return function fetchIndicators(_x) {
    return _ref.apply(this, arguments);
  };
}();

var indicators_downloadSpreadsheet = function () {
  var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(_ref4) {
    var vehicleId = _ref4.vehicleId,
        startDate = _ref4.startDate,
        finishDate = _ref4.finishDate;
    var path, response, mime, filename;
    return regenerator_default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            path = '/files/spreadsheet/download/' + vehicleId + '/' + startDate + '/' + finishDate;
            response = void 0;
            _context2.prev = 2;
            _context2.next = 5;
            return indicators_client.get(path);

          case 5:
            response = _context2.sent;
            _context2.next = 12;
            break;

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2['catch'](2);

            console.error(_context2.t0);
            return _context2.abrupt('return', null);

          case 12:
            mime = response.headers['content-type'].split(';')[0] || 'application/octet-stream';
            filename = response.headers['content-disposition'].split('=')[1] || 'reporte.xlsx';
            return _context2.abrupt('return', {
              data: response.data,
              mime: mime,
              filename: filename
            });

          case 15:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this, [[2, 8]]);
  }));

  return function downloadSpreadsheet(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

var indicators_downloadCsv = function () {
  var _ref5 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(_ref6) {
    var vehicleId = _ref6.vehicleId,
        startDate = _ref6.startDate,
        finishDate = _ref6.finishDate;
    var path, response, mime, filename;
    return regenerator_default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            path = '/files/csv/download/' + vehicleId + '/' + startDate + '/' + finishDate;
            response = void 0;
            _context3.prev = 2;
            _context3.next = 5;
            return indicators_client.get(path);

          case 5:
            response = _context3.sent;
            _context3.next = 12;
            break;

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3['catch'](2);

            console.error(_context3.t0);
            return _context3.abrupt('return', null);

          case 12:
            mime = response.headers['content-type'].split(';')[0] || 'application/octet-stream';
            filename = response.headers['content-disposition'].split('=')[1] || 'reporte.csv';
            return _context3.abrupt('return', {
              data: response.data,
              mime: mime,
              filename: filename
            });

          case 15:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this, [[2, 8]]);
  }));

  return function downloadCsv(_x3) {
    return _ref5.apply(this, arguments);
  };
}();


var INDICATORS_URL = "https://reports.rastreosigloxxi.io";
var indicators_token = localStorage.getItem('heimdall-session-token');
var indicators_client = axios_default.a.create({
  baseURL: INDICATORS_URL,
  headers: { 'Authorization': indicators_token ? 'Bearer ' + indicators_token : null }
});

/* harmony default export */ var api_indicators = ({
  fetchIndicators: indicators_fetchIndicators,
  downloadSpreadsheet: indicators_downloadSpreadsheet,
  downloadCsv: indicators_downloadCsv
});
// EXTERNAL MODULE: ./src/graphql/queries/Reports/Vehicles.graphql
var Reports_Vehicles_graphql = __webpack_require__("mZ88");
var Reports_Vehicles_graphql_default = /*#__PURE__*/__webpack_require__.n(Reports_Vehicles_graphql);

// EXTERNAL MODULE: ./src/graphql/queries/Reports/Events.graphql
var Events_graphql = __webpack_require__("knoI");
var Events_graphql_default = /*#__PURE__*/__webpack_require__.n(Events_graphql);

// EXTERNAL MODULE: ./src/graphql/queries/Reports/PaginatedEvents.graphql
var PaginatedEvents_graphql = __webpack_require__("00uD");
var PaginatedEvents_graphql_default = /*#__PURE__*/__webpack_require__.n(PaginatedEvents_graphql);

// EXTERNAL MODULE: ./src/graphql/queries/Reports/EventsCount.graphql
var EventsCount_graphql = __webpack_require__("eBEL");
var EventsCount_graphql_default = /*#__PURE__*/__webpack_require__.n(EventsCount_graphql);

// CONCATENATED MODULE: ./src/store/modules/reports/index.js




var reports__mutations;










var reports_module = {
  namespaced: true,
  state: {
    indicators: [],
    vehicles: [],
    events: [],
    totalEvents: 0
  },
  getters: {
    vehicles: function vehicles(state) {
      return state.vehicles;
    },
    events: function events(state) {
      return state.events;
    },
    totalEvents: function totalEvents(state) {
      return state.totalEvents;
    },
    kilometersTraveled: function kilometersTraveled(state) {
      return state.kilometersTraveled;
    },
    timeOn: function timeOn(state) {
      return state.timeOn;
    },
    timeOff: function timeOff(state) {
      return state.timeOff;
    },
    speedings: function speedings(state) {
      return state.speedings;
    },
    averageSpeed: function averageSpeed(state) {
      return state.averageSpeed;
    }
  },
  mutations: (reports__mutations = {}, defineProperty_default()(reports__mutations, SET_INDICATORS, function (state, _ref) {
    var indicators = _ref.indicators;

    state.indicators = indicators;
  }), defineProperty_default()(reports__mutations, 'setVehicles', function setVehicles(state, vehicles) {
    state.vehicles = vehicles;
  }), defineProperty_default()(reports__mutations, 'setEvents', function setEvents(state, events) {
    state.events = events;
  }), defineProperty_default()(reports__mutations, 'setTotalEvents', function setTotalEvents(state, totalEvents) {
    state.totalEvents = totalEvents;
  }), reports__mutations),
  actions: {
    fetchVehicles: function fetchVehicles(_ref2) {
      var _this = this;

      var commit = _ref2.commit;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var result, vehicles;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return apollo.query({
                  query: Reports_Vehicles_graphql_default.a
                });

              case 2:
                result = _context.sent;
                vehicles = result.data.fetchVehicles;

                commit('setVehicles', vehicles);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetchEvents: function fetchEvents(_ref3, _ref4) {
      var _this2 = this;

      var commit = _ref3.commit;
      var vehicleId = _ref4.vehicleId,
          startDate = _ref4.startDate,
          finishDate = _ref4.finishDate;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var result, events;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return apollo.query({
                  query: Events_graphql_default.a,
                  variables: {
                    vehicleId: vehicleId,
                    startDate: startDate,
                    finishDate: finishDate
                  }
                });

              case 2:
                result = _context2.sent;
                events = result.data.fetchEventsByVehicleAndDate;

                commit('setEvents', events);

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    fetchPaginatedEvents: function fetchPaginatedEvents(_ref5, _ref6) {
      var _this3 = this;

      var commit = _ref5.commit;
      var vehicleId = _ref6.vehicleId,
          startDate = _ref6.startDate,
          finishDate = _ref6.finishDate,
          page = _ref6.page,
          rowsPerPage = _ref6.rowsPerPage;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var result, events;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return apollo.query({
                  query: PaginatedEvents_graphql_default.a,
                  variables: {
                    vehicleId: vehicleId,
                    startDate: startDate,
                    finishDate: finishDate,
                    page: page,
                    rowsPerPage: rowsPerPage
                  }
                });

              case 2:
                result = _context3.sent;
                events = result.data.fetchPaginatedEventsByVehicleAndDate;

                commit('setEvents', events);

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    countEvents: function countEvents(_ref7, _ref8) {
      var _this4 = this;

      var commit = _ref7.commit;
      var vehicleId = _ref8.vehicleId,
          startDate = _ref8.startDate,
          finishDate = _ref8.finishDate;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var result, totalEvents;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return apollo.query({
                  query: EventsCount_graphql_default.a,
                  variables: {
                    vehicleId: vehicleId,
                    startDate: startDate,
                    finishDate: finishDate
                  }
                });

              case 2:
                result = _context4.sent;
                totalEvents = result.data.countEventsByVehicleAndDate.count;

                commit('setTotalEvents', totalEvents);

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    fetchIndicators: function fetchIndicators(_ref9, _ref10) {
      var _this5 = this;

      var commit = _ref9.commit;
      var vehicleId = _ref10.vehicleId,
          mark = _ref10.mark,
          reference = _ref10.reference,
          startDate = _ref10.startDate,
          finishDate = _ref10.finishDate;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var indicators;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return api_indicators.fetchIndicators({
                  vehicleId: vehicleId,
                  mark: mark,
                  reference: reference,
                  startDate: startDate,
                  finishDate: finishDate
                });

              case 2:
                indicators = _context5.sent;

                commit(SET_INDICATORS, { indicators: indicators });

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    downloadSpreadsheet: function downloadSpreadsheet(_ref11, _ref12) {
      var commit = _ref11.commit;
      var vehicleId = _ref12.vehicleId,
          startDate = _ref12.startDate,
          finishDate = _ref12.finishDate;

      return api_indicators.downloadSpreadsheet({
        vehicleId: vehicleId,
        startDate: startDate,
        finishDate: finishDate
      });
    },
    downloadCsv: function downloadCsv(_ref13, _ref14) {
      var commit = _ref13.commit;
      var vehicleId = _ref14.vehicleId,
          startDate = _ref14.startDate,
          finishDate = _ref14.finishDate;

      return api_indicators.downloadCsv({
        vehicleId: vehicleId,
        startDate: startDate,
        finishDate: finishDate
      });
    }
  }
};

/* harmony default export */ var reports = (reports_module);
// EXTERNAL MODULE: ./src/graphql/queries/Travels/Vehicles.graphql
var Travels_Vehicles_graphql = __webpack_require__("pO1b");
var Travels_Vehicles_graphql_default = /*#__PURE__*/__webpack_require__.n(Travels_Vehicles_graphql);

// EXTERNAL MODULE: ./src/graphql/queries/Travels/Events.graphql
var Travels_Events_graphql = __webpack_require__("iB8B");
var Travels_Events_graphql_default = /*#__PURE__*/__webpack_require__.n(Travels_Events_graphql);

// CONCATENATED MODULE: ./src/store/modules/travels/index.js








var travels_module = {
  namespaced: true,
  state: {
    vehicles: [],
    events: []
  },
  getters: {
    fixedEvents: function fixedEvents(state) {
      var fixedEvents = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(state.events), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var event = _step.value;

          var latitude = event.data.gps.latitude;
          var longitude = event.data.gps.longitude;
          // Skip unfixed position
          if (!latitude || !longitude) {
            continue;
          }
          fixedEvents.push(event);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return fixedEvents;
      // Fake events
      // return [
      //   { _id: 'sdifgistdfiv', name: 'Reporte por tiempo', data: { gps: { latitude: 6.230818, longitude: -75.602143, date: new Date() } } },
      //   { _id: 'sdifgi44stdfiv', name: 'Desconexión de batería', data: { gps: { latitude: 6.231255, longitude: -75.597659, date: new Date() } } },
      //   { _id: 'sdifgis88tdfiv', name: 'Botón de pánico', data: { gps: { latitude: 6.231499, longitude: -75.588301, date: new Date() } } }
      // ]
    }
  },
  mutations: {
    setVehicles: function setVehicles(state, vehicles) {
      state.vehicles = vehicles;
    },
    setEvents: function setEvents(state, events) {
      state.events = events;
    }
  },
  actions: {
    fetchVehicles: function fetchVehicles(_ref) {
      var _this = this;

      var commit = _ref.commit;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var result, vehicles;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return apollo.query({
                  query: Travels_Vehicles_graphql_default.a
                });

              case 2:
                result = _context.sent;
                vehicles = result.data.fetchVehicles;

                commit('setVehicles', vehicles);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetchEvents: function fetchEvents(_ref2, _ref3) {
      var _this2 = this;

      var commit = _ref2.commit;
      var vehicleId = _ref3.vehicleId,
          startDate = _ref3.startDate,
          finishDate = _ref3.finishDate;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var result, events;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return apollo.query({
                  query: Travels_Events_graphql_default.a,
                  variables: {
                    vehicleId: vehicleId,
                    startDate: startDate,
                    finishDate: finishDate
                  }
                });

              case 2:
                result = _context2.sent;
                events = result.data.fetchEventsByVehicleAndDate;

                commit('setEvents', events);

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
};

/* harmony default export */ var travels = (travels_module);
// EXTERNAL MODULE: ./src/graphql/queries/Account/Client.graphql
var Client_graphql = __webpack_require__("5t8j");
var Client_graphql_default = /*#__PURE__*/__webpack_require__.n(Client_graphql);

// EXTERNAL MODULE: ./src/graphql/mutations/Account/UpdateClient.graphql
var UpdateClient_graphql = __webpack_require__("T6S+");
var UpdateClient_graphql_default = /*#__PURE__*/__webpack_require__.n(UpdateClient_graphql);

// EXTERNAL MODULE: ./src/graphql/mutations/Account/UpdateClientPassword.graphql
var UpdateClientPassword_graphql = __webpack_require__("Cq6c");
var UpdateClientPassword_graphql_default = /*#__PURE__*/__webpack_require__.n(UpdateClientPassword_graphql);

// EXTERNAL MODULE: ./src/graphql/mutations/Account/CreateClientEmail.graphql
var CreateClientEmail_graphql = __webpack_require__("HB6Q");
var CreateClientEmail_graphql_default = /*#__PURE__*/__webpack_require__.n(CreateClientEmail_graphql);

// EXTERNAL MODULE: ./src/graphql/mutations/Account/RemoveClientEmail.graphql
var RemoveClientEmail_graphql = __webpack_require__("JN0E");
var RemoveClientEmail_graphql_default = /*#__PURE__*/__webpack_require__.n(RemoveClientEmail_graphql);

// CONCATENATED MODULE: ./src/store/modules/account/index.js




var account__mutations;










var account_module = {
  namespaced: true,
  state: {
    client: null,
    lastPasswordUpdate: null
  },
  mutations: (account__mutations = {}, defineProperty_default()(account__mutations, SET_CLIENT, function (state, _ref) {
    var client = _ref.client;

    state.client = client;
  }), defineProperty_default()(account__mutations, 'setClient', function setClient(state, client) {
    state.client = client;
  }), defineProperty_default()(account__mutations, 'setLastPasswordUpdate', function setLastPasswordUpdate(state, lastPasswordUpdate) {
    state.lastPasswordUpdate = lastPasswordUpdate;
  }), account__mutations),
  actions: {
    fetchClient: function fetchClient(_ref2) {
      var _this = this;

      var commit = _ref2.commit;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var result, client;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return apollo.query({
                  query: Client_graphql_default.a
                });

              case 2:
                result = _context.sent;
                client = result.data.fetchClient;

                commit('setClient', client);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    updateClient: function updateClient(_ref3, _ref4) {
      var _this2 = this;

      var commit = _ref3.commit;
      var client = _ref4.client;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var result, updatedClient;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return apollo.mutate({
                  mutation: UpdateClient_graphql_default.a,
                  variables: {
                    client: client
                  }
                });

              case 2:
                result = _context2.sent;
                updatedClient = result.data.updateClient;

                commit('setClient', updatedClient);

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    updateClientPassword: function updateClientPassword(_ref5, _ref6) {
      var _this3 = this;

      var commit = _ref5.commit;
      var client = _ref6.client;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return apollo.mutate({
                  mutation: UpdateClientPassword_graphql_default.a,
                  variables: {
                    client: client
                  }
                });

              case 2:
                commit('setLastPasswordUpdate', new Date());

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    createEmail: function createEmail(_ref7, _ref8) {
      var _this4 = this;

      var commit = _ref7.commit;
      var email = _ref8.email;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var result, client;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return apollo.mutate({
                  mutation: CreateClientEmail_graphql_default.a,
                  variables: {
                    email: email
                  }
                });

              case 2:
                result = _context4.sent;
                client = result.data.createClientEmail;

                commit(SET_CLIENT, { client: client });

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    removeEmail: function removeEmail(_ref9, _ref10) {
      var _this5 = this;

      var commit = _ref9.commit;
      var email = _ref10.email;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var result, client;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return apollo.mutate({
                  mutation: RemoveClientEmail_graphql_default.a,
                  variables: {
                    email: email
                  }
                });

              case 2:
                result = _context5.sent;
                client = result.data.removeClientEmail;

                commit(SET_CLIENT, { client: client });

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    }
  }
};

/* harmony default export */ var account = (account_module);
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./src/graphql/queries/Guests/FetchVehicles.graphql
var Guests_FetchVehicles_graphql = __webpack_require__("4IYN");
var Guests_FetchVehicles_graphql_default = /*#__PURE__*/__webpack_require__.n(Guests_FetchVehicles_graphql);

// EXTERNAL MODULE: ./src/graphql/queries/Guests/FetchGuests.graphql
var FetchGuests_graphql = __webpack_require__("vqlZ");
var FetchGuests_graphql_default = /*#__PURE__*/__webpack_require__.n(FetchGuests_graphql);

// EXTERNAL MODULE: ./src/graphql/mutations/Guests/CreateGuest.graphql
var CreateGuest_graphql = __webpack_require__("BZUx");
var CreateGuest_graphql_default = /*#__PURE__*/__webpack_require__.n(CreateGuest_graphql);

// EXTERNAL MODULE: ./src/graphql/mutations/Guests/RemoveGuest.graphql
var RemoveGuest_graphql = __webpack_require__("6SVg");
var RemoveGuest_graphql_default = /*#__PURE__*/__webpack_require__.n(RemoveGuest_graphql);

// EXTERNAL MODULE: ./src/graphql/mutations/Guests/UpdateGuest.graphql
var UpdateGuest_graphql = __webpack_require__("5PLJ");
var UpdateGuest_graphql_default = /*#__PURE__*/__webpack_require__.n(UpdateGuest_graphql);

// EXTERNAL MODULE: ./src/graphql/queries/Guests/FetchPermissions.graphql
var FetchPermissions_graphql = __webpack_require__("Dilr");
var FetchPermissions_graphql_default = /*#__PURE__*/__webpack_require__.n(FetchPermissions_graphql);

// CONCATENATED MODULE: ./src/store/modules/guests/index.js






var guests__mutations;











var namespaced = true;

var guests_state = {
  vehicles: [],
  guests: [],
  permissions: []
};

var guests_getters = {
  guests: function guests(state) {
    return state.guests.map(function (guest) {
      var vehicles = guest.vehicles.map(function (vehicle) {
        return vehicle._id;
      });
      return extends_default()({}, guest, {
        vehicles: vehicles
      });
    });
  }
};

var mutations = (guests__mutations = {}, defineProperty_default()(guests__mutations, SET_VEHICLES, function (state, _ref) {
  var vehicles = _ref.vehicles;

  state.vehicles = vehicles;
}), defineProperty_default()(guests__mutations, SET_GUESTS, function (state, _ref2) {
  var guests = _ref2.guests;

  state.guests = guests;
}), defineProperty_default()(guests__mutations, CREATE_GUEST, function (state, _ref3) {
  var guest = _ref3.guest;

  state.guests = [].concat(toConsumableArray_default()(state.guests), [guest]);
}), defineProperty_default()(guests__mutations, SET_PERMISSIONS, function (state, _ref4) {
  var permissions = _ref4.permissions;

  state.permissions = permissions;
}), guests__mutations);

var actions = {
  fetchGuests: function fetchGuests(_ref5) {
    var _this = this;

    var commit = _ref5.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var result, guests;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return apollo.query({
                query: FetchGuests_graphql_default.a
              });

            case 2:
              result = _context.sent;
              guests = result.data.fetchGuests;

              commit(SET_GUESTS, { guests: guests });

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  fetchVehicles: function fetchVehicles(_ref6) {
    var _this2 = this;

    var commit = _ref6.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      var result, vehicles;
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return apollo.query({
                query: Guests_FetchVehicles_graphql_default.a
              });

            case 2:
              result = _context2.sent;
              vehicles = result.data.fetchVehicles;

              commit(SET_VEHICLES, { vehicles: vehicles });

            case 5:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  fetchPermissions: function fetchPermissions(_ref7) {
    var _this3 = this;

    var commit = _ref7.commit;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
      var result, permissions;
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return apollo.query({
                query: FetchPermissions_graphql_default.a
              });

            case 2:
              result = _context3.sent;
              permissions = result.data.fetchPermissions;

              commit(SET_PERMISSIONS, { permissions: permissions });

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  createGuest: function createGuest(_ref8, _ref9) {
    var _this4 = this;

    var commit = _ref8.commit;
    var guest = _ref9.guest;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
      var result, createdGuest;
      return regenerator_default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return apollo.mutate({
                mutation: CreateGuest_graphql_default.a,
                variables: {
                  guest: guest
                }
              });

            case 2:
              result = _context4.sent;
              createdGuest = result.data.createGuest;

              commit(CREATE_GUEST, { guest: createdGuest });

            case 5:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  removeGuest: function removeGuest(_ref10, _ref11) {
    var _this5 = this;

    var commit = _ref10.commit;
    var _id = _ref11._id;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
      var result, guests;
      return regenerator_default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return apollo.mutate({
                mutation: RemoveGuest_graphql_default.a,
                variables: {
                  _id: _id
                }
              });

            case 2:
              result = _context5.sent;
              guests = result.data.removeGuest;

              commit(SET_GUESTS, { guests: guests });

            case 5:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  updateGuest: function updateGuest(_ref12, _ref13) {
    var _this6 = this;

    var commit = _ref12.commit;
    var _id = _ref13._id,
        guest = _ref13.guest;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
      var result, guests;
      return regenerator_default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return apollo.mutate({
                mutation: UpdateGuest_graphql_default.a,
                variables: {
                  _id: _id,
                  guest: guest
                }
              });

            case 2:
              result = _context6.sent;
              guests = result.data.updateGuest;

              commit(SET_GUESTS, { guests: guests });

            case 5:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  }
};

/* harmony default export */ var modules_guests = ({
  namespaced: namespaced,
  state: guests_state,
  getters: guests_getters,
  actions: actions,
  mutations: mutations
});
// EXTERNAL MODULE: ./src/graphql/queries/EventDialog/FetchEvent.graphql
var FetchEvent_graphql = __webpack_require__("Gply");
var FetchEvent_graphql_default = /*#__PURE__*/__webpack_require__.n(FetchEvent_graphql);

// CONCATENATED MODULE: ./src/store/modules/event-dialog/index.js









moment_default.a.locale('es-do');

var event_dialog_namespaced = true;

var event_dialog_state = {
  event: null
};

var event_dialog_getters = {
  event: function event(state, getters) {
    return function (now) {
      if (!state.event) {
        return null;
      }
      var gsm = state.event.data.gsm ? {
        signal: state.event.data.gsm.signal,
        registration: state.event.data.gsm.registration,
        codeCountry: state.event.data.gsm.codeCountry,
        codeNetwork: state.event.data.gsm.codeNetwork,
        baseStationCode: state.event.data.gsm.baseStationCode,
        baseStationIdentifier: state.event.data.gsm.baseStationIdentifier,
        strengthSignal: state.event.data.gsm.strengthSignal
      } : null;
      return {
        vehiclePlate: state.event.vehicle.plate,
        name: state.event.name,
        date: getters.humanDate(state.event.data.gps.date, now),
        engineState: state.event.engineState,
        gps: {
          speed: state.event.data.gps.speed,
          azimuth: state.event.data.gps.azimuth.grades,
          satellites: state.event.data.gps.satellites,
          hdop: state.event.data.gps.hdop,
          vdop: state.event.data.gps.vdop,
          latitude: state.event.data.gps.latitude,
          longitude: state.event.data.gps.longitude,
          altitude: state.event.data.gps.altitude
        },
        gsm: gsm,
        reverseGeocoding: state.event.reverseGeocoding,
        batteryLevel: state.event.data.adc.voltagePowerExternal,
        backupBatteryLevel: state.event.data.adc.voltageBateryBackup
      };
    };
  },
  notes: function notes(state, getters) {
    return function (now) {
      if (!state.vehicle) {
        return [];
      }
      return state.vehicle.notes.map(function (_ref) {
        var _id = _ref._id,
            author = _ref.author,
            title = _ref.title,
            body = _ref.body,
            date = _ref.date;

        return { _id: _id, author: author.name, title: title, body: body, date: getters.humanDate(date, now) };
      });
    };
  },
  humanDate: function humanDate(state, getters) {
    return function (date, now) {
      if (!date) {
        return 'nunca';
      }
      var isSameDay = moment_default()(date).isSame(now, 'day');
      if (isSameDay) {
        return moment_default()(date).from(now);
      }
      return moment_default()(date).format('DD [de] MMMM [de] YYYY [a las] hh:mm:ss A').toLowerCase();
    };
  }
};

var event_dialog_mutations = defineProperty_default()({}, SET_EVENT, function (state, _ref2) {
  var event = _ref2.event;

  state.event = event;
});

var event_dialog_actions = {
  fetchEvent: function fetchEvent(_ref3, _ref4) {
    var _this = this;

    var commit = _ref3.commit;
    var eventId = _ref4.eventId;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var result, event;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return apollo.query({
                query: FetchEvent_graphql_default.a,
                variables: {
                  eventId: eventId
                }
              });

            case 2:
              result = _context.sent;
              event = result.data.fetchEventById;

              if (event) {
                _context.next = 6;
                break;
              }

              throw new Error('Event not found');

            case 6:
              commit(SET_EVENT, { event: event });

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
};

/* harmony default export */ var event_dialog = ({
  namespaced: event_dialog_namespaced,
  state: event_dialog_state,
  getters: event_dialog_getters,
  actions: event_dialog_actions,
  mutations: event_dialog_mutations
});
// CONCATENATED MODULE: ./src/api/commands.js







var COMMANDS_URL = "ws://api.web.rastreosigloxxi.io:3004/commands";

var commands_CommandsClient = function (_EventEmitter) {
  inherits_default()(CommandsClient, _EventEmitter);

  function CommandsClient(token, view) {
    classCallCheck_default()(this, CommandsClient);

    var _this = possibleConstructorReturn_default()(this, (CommandsClient.__proto__ || get_prototype_of_default()(CommandsClient)).call(this));

    _this._isConnected = false;
    _this._url = COMMANDS_URL;
    _this._socket = {};
    return _this;
  }

  createClass_default()(CommandsClient, [{
    key: 'connect',
    value: function connect() {
      var _this2 = this;

      var token = localStorage.getItem('heimdall-session-token');
      this._socket = new WebSocket(this._url + '?token=' + token);
      this._socket.onerror = function (err) {
        console.error(err);
      };
      this._socket.onclose = function (closeEvent) {
        _this2.emit('close', closeEvent);
      };
      this._socket.onopen = function (event) {
        _this2._isConnected = true;
        _this2.emit('connection', event);
      };
      this._socket.onmessage = function (message) {
        var data = JSON.parse(message.data);
        _this2.emit('transfer-update', data);
      };
    }
  }, {
    key: 'sendCommand',
    value: function sendCommand(_ref) {
      var commandId = _ref.commandId,
          vehicleId = _ref.vehicleId;

      this._socket.send(stringify_default()({ commandId: commandId, vehicleId: vehicleId }));
    }
  }, {
    key: 'isConnected',
    get: function get() {
      return this._isConnected;
    }
  }]);

  return CommandsClient;
}(events_default.a);

/* harmony default export */ var commands = (commands_CommandsClient);
// EXTERNAL MODULE: ./src/graphql/queries/CommandsDialog/FetchVehicle.graphql
var FetchVehicle_graphql = __webpack_require__("OM/V");
var FetchVehicle_graphql_default = /*#__PURE__*/__webpack_require__.n(FetchVehicle_graphql);

// CONCATENATED MODULE: ./src/store/modules/commands-dialog/index.js





var commands_dialog__mutations;








moment_default.a.locale('es-do');

var commandsClient = new commands();

var commands_dialog_namespaced = true;

var commands_dialog_state = {
  vehicle: null,
  commandTransferStatus: 'SUCCESS'
};

var commands_dialog_getters = {
  commands: function commands(state) {
    if (!state.vehicle) return [];
    return state.vehicle.commands;
  }
};

var commands_dialog_mutations = (commands_dialog__mutations = {}, defineProperty_default()(commands_dialog__mutations, SET_VEHICLE, function (state, _ref) {
  var vehicle = _ref.vehicle;

  state.vehicle = vehicle;
}), defineProperty_default()(commands_dialog__mutations, SET_COMMAND_TRANSFER_STATUS, function (state, _ref2) {
  var commandTransferStatus = _ref2.commandTransferStatus;

  state.commandTransferStatus = commandTransferStatus;
}), commands_dialog__mutations);

var commands_dialog_actions = {
  fetchVehicle: function fetchVehicle(_ref3, _ref4) {
    var _this = this;

    var commit = _ref3.commit;
    var vehicleId = _ref4.vehicleId;
    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var result, vehicle;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return apollo.query({
                query: FetchVehicle_graphql_default.a,
                variables: {
                  vehicleId: vehicleId
                }
              });

            case 2:
              result = _context.sent;
              vehicle = result.data.fetchVehicleById;

              if (vehicle) {
                _context.next = 6;
                break;
              }

              throw new Error('Vehicle not found');

            case 6:
              commit(SET_VEHICLE, { vehicle: vehicle });

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  connectToCommandsServer: function connectToCommandsServer(_ref5) {
    var commit = _ref5.commit;

    return new promise_default.a(function (resolve, reject) {
      commandsClient.connect();
      commandsClient.once('connection', function (event) {
        console.log('Connected to commands server');
        return resolve(event);
      });
    });
  },
  sendCommand: function sendCommand(_ref6, _ref7) {
    var commit = _ref6.commit;
    var commandId = _ref7.commandId,
        vehicleId = _ref7.vehicleId;

    commit(SET_COMMAND_TRANSFER_STATUS, { commandTransferStatus: 'SENDING' });
    commandsClient.sendCommand({
      commandId: commandId,
      vehicleId: vehicleId
    });
    commandsClient.once('close', function (eventClose) {
      commandsClient.removeAllListeners();
      console.log('Disconnected from commands server');
    });
    commandsClient.on('transfer-update', function (transferUpdate) {
      console.log(transferUpdate.message);
      commit(SET_COMMAND_TRANSFER_STATUS, { commandTransferStatus: transferUpdate.status });
    });
  }
};

/* harmony default export */ var commands_dialog = ({
  namespaced: commands_dialog_namespaced,
  state: commands_dialog_state,
  getters: commands_dialog_getters,
  actions: commands_dialog_actions,
  mutations: commands_dialog_mutations
});
// EXTERNAL MODULE: ./src/graphql/mutations/ConfirmEmail/ActivateEmail.graphql
var ActivateEmail_graphql = __webpack_require__("IkIV");
var ActivateEmail_graphql_default = /*#__PURE__*/__webpack_require__.n(ActivateEmail_graphql);

// CONCATENATED MODULE: ./src/store/modules/confirm-email/index.js








var confirm_email_module = {
  namespaced: true,
  state: {
    clientName: null
  },
  mutations: defineProperty_default()({}, SET_CLIENT_NAME, function (state, _ref) {
    var clientName = _ref.clientName;

    state.clientName = clientName;
  }),
  actions: {
    activateEmail: function activateEmail(_ref2, _ref3) {
      var _this = this;

      var commit = _ref2.commit;
      var token = _ref3.token;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var result, clientName;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return apollo.mutate({
                  mutation: ActivateEmail_graphql_default.a,
                  variables: {
                    token: token
                  }
                });

              case 2:
                result = _context.sent;
                clientName = result.data.activateEmail.name;

                commit(SET_CLIENT_NAME, { clientName: clientName });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
};

/* harmony default export */ var confirm_email = (confirm_email_module);
// CONCATENATED MODULE: ./src/store/index.js















vue_esm["default"].use(vuex_esm["a" /* default */]);

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  modules: {
    Tracking: tracking,
    Geofences: modules_geofences,
    Routes: modules_routes,
    Places: modules_places,
    Reports: reports,
    Travels: travels,
    Account: account,
    Guests: modules_guests,
    EventDialog: event_dialog,
    CommandsDialog: commands_dialog,
    ConfirmEmail: confirm_email
  }
}));
// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










































vue_esm["default"].use(Vuetify_default.a, {
  components: {
    VApp: VApp_default.a,
    VResponsive: VResponsive_default.a,
    VNavigationDrawer: VNavigationDrawer_default.a,
    VGrid: VGrid_default.a,
    VToolbar: VToolbar_default.a,
    VCard: VCard_default.a,
    VMenu: VMenu_default.a,
    VFooter: VFooter_default.a,
    VList: VList_default.a,
    VBtn: VBtn_default.a,
    VIcon: VIcon_default.a,
    VDivider: VDivider_default.a,
    VAutocomplete: VAutocomplete_default.a,
    VDialog: VDialog_default.a,
    VSnackbar: VSnackbar_default.a,
    VSubheader: VSubheader_default.a,
    VAvatar: VAvatar_default.a,
    VProgressCircular: VProgressCircular_default.a,
    VProgressLinear: VProgressLinear_default.a,
    VForm: VForm_default.a,
    VTextField: VTextField_default.a,
    VChip: VChip_default.a,
    VPagination: VPagination_default.a,
    VSwitch: VSwitch_default.a,
    VAlert: VAlert_default.a,
    VBadge: VBadge_default.a,
    VDataTable: VDataTable_default.a,
    VDatePicker: VDatePicker_default.a,
    VTimePicker: VTimePicker_default.a,
    VTooltip: VTooltip_default.a,
    VExpansionPanel: VExpansionPanel_default.a,
    transitions: transitions_default.a
  },
  theme: {
    primary: '#e53935',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
});

vue_esm["default"].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["default"]({
  el: '#app',
  router: src_router,
  store: store,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "NOHZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OM/V":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchVehicle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vehicleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchVehicleById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vehicleId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"commands"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"alias"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":147}};
    doc.loc.source = {"body":"query FetchVehicle ($vehicleId: ID!) {\n  fetchVehicleById (_id: $vehicleId) {\n    _id,\n    plate,\n    commands {\n      id,\n      alias\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["FetchVehicle"] = oneQuery(doc, "FetchVehicle");
        


/***/ }),

/***/ "P0ba":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PJ2A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pjg2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R681":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R9cU":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveGeofence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shapeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeGeofence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shapeId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":91}};
    doc.loc.source = {"body":"mutation RemoveGeofence ($shapeId: ID!) {\n  removeGeofence (_id: $shapeId) {\n    _id\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["RemoveGeofence"] = oneQuery(doc, "RemoveGeofence");
        


/***/ }),

/***/ "RGFK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SWxp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Stsr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T6S+":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateClient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"client"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateClientInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateClient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"client"},"value":{"kind":"Variable","name":{"kind":"Name","value":"client"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"active"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":149}};
    doc.loc.source = {"body":"mutation UpdateClient ($client: UpdateClientInput!) {\n  updateClient (client: $client) {\n    name\n    email {\n      address\n      active\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["UpdateClient"] = oneQuery(doc, "UpdateClient");
        


/***/ }),

/***/ "V5lI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VSNX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WZn9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X05+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XC5Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XS4J":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveRoute"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shapeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeRoute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shapeId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":85}};
    doc.loc.source = {"body":"mutation RemoveRoute ($shapeId: ID!) {\n  removeRoute (_id: $shapeId) {\n    _id\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["RemoveRoute"] = oneQuery(doc, "RemoveRoute");
        


/***/ }),

/***/ "YLcb":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YLcb";

/***/ }),

/***/ "ZU8t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aJq1":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePlace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shape"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePlaceInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPlace"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"place"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shape"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"geometry"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":119}};
    doc.loc.source = {"body":"mutation CreatePlace ($shape: CreatePlaceInput!) {\n  createPlace (place: $shape) {\n    _id\n    geometry\n    name\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["CreatePlace"] = oneQuery(doc, "CreatePlace");
        


/***/ }),

/***/ "acBN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bVJk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bbkW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c3KV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "crfu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d/lB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dM5o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dZW8":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePlace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shapeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shape"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePlaceInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePlace"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shapeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"place"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shape"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"geometry"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":149}};
    doc.loc.source = {"body":"mutation UpdatePlace ($shapeId: ID!, $shape: UpdatePlaceInput!) {\n  updatePlace (_id: $shapeId, place: $shape) {\n    _id\n    geometry\n    name\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["UpdatePlace"] = oneQuery(doc, "UpdatePlace");
        


/***/ }),

/***/ "e7B0":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateGeofence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shape"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateGeofenceInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createGeofence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"geofence"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shape"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"geometry"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vehicles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plate"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":174}};
    doc.loc.source = {"body":"mutation CreateGeofence ($shape: CreateGeofenceInput!) {\n  createGeofence (geofence: $shape) {\n    _id\n    geometry\n    name\n    vehicles {\n      _id\n      plate\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["CreateGeofence"] = oneQuery(doc, "CreateGeofence");
        


/***/ }),

/***/ "eBEL":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vehicleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"finishDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countEventsByVehicleAndDate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"vehicleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vehicleId"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"finishDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"finishDate"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":197}};
    doc.loc.source = {"body":"query EventsCount ($vehicleId: ID!, $startDate: Date!, $finishDate: Date!) {\n  countEventsByVehicleAndDate (vehicleId: $vehicleId, startDate: $startDate, finishDate: $finishDate) {\n    count\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["EventsCount"] = oneQuery(doc, "EventsCount");
        


/***/ }),

/***/ "f2Ia":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hVUK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i4C6":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Vehicles"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchVehicles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plate"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":59}};
    doc.loc.source = {"body":"query Vehicles {\n  fetchVehicles {\n    _id\n    plate\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["Vehicles"] = oneQuery(doc, "Vehicles");
        


/***/ }),

/***/ "iB8B":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Events"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vehicleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"finishDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchEventsByVehicleAndDate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"vehicleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vehicleId"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"finishDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"finishDate"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gps"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"longitude"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"speed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"azimuth"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardinalDirection"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"altitude"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reverseGeocoding"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"engineState"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":408}};
    doc.loc.source = {"body":"query Events ($vehicleId: ID!, $startDate: Date!, $finishDate: Date!) {\n  fetchEventsByVehicleAndDate (vehicleId: $vehicleId, startDate: $startDate, finishDate: $finishDate) {\n    _id\n    name\n    data {\n      gps {\n        latitude\n        longitude\n        speed\n        azimuth {\n          cardinalDirection\n        }\n        altitude\n        date\n      }\n    }\n    reverseGeocoding\n    engineState\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["Events"] = oneQuery(doc, "Events");
        


/***/ }),

/***/ "jNbB":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Places"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchPlaces"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"geometry"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":67}};
    doc.loc.source = {"body":"query Places {\n  fetchPlaces {\n    _id\n    geometry\n    name\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["Places"] = oneQuery(doc, "Places");
        


/***/ }),

/***/ "jQdp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kP4z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kVeV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "knoI":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Events"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vehicleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"finishDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchEventsByVehicleAndDate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"vehicleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vehicleId"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"finishDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"finishDate"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gps"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latitude"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"latitude"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"speed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"azimuth"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardinalDirection"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"altitude"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reverseGeocoding"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"engineState"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":407}};
    doc.loc.source = {"body":"query Events ($vehicleId: ID!, $startDate: Date!, $finishDate: Date!) {\n  fetchEventsByVehicleAndDate (vehicleId: $vehicleId, startDate: $startDate, finishDate: $finishDate) {\n    _id\n    name\n    data {\n      gps {\n        latitude\n        latitude\n        speed\n        azimuth {\n          cardinalDirection\n        }\n        altitude\n        date\n      }\n    }\n    reverseGeocoding\n    engineState\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["Events"] = oneQuery(doc, "Events");
        


/***/ }),

/***/ "lThp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mZ88":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Vehicles"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchVehicles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"device"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mark"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reference"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":130}};
    doc.loc.source = {"body":"query Vehicles {\n  fetchVehicles {\n    _id\n    plate\n    device {\n      type {\n        mark\n        reference\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["Vehicles"] = oneQuery(doc, "Vehicles");
        


/***/ }),

/***/ "pO1b":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Vehicles"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchVehicles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plate"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":59}};
    doc.loc.source = {"body":"query Vehicles {\n  fetchVehicles {\n    _id\n    plate\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["Vehicles"] = oneQuery(doc, "Vehicles");
        


/***/ }),

/***/ "pu2v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pxzo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q/9b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qlEt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r+Ov":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemovePlace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shapeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removePlace"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shapeId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":85}};
    doc.loc.source = {"body":"mutation RemovePlace ($shapeId: ID!) {\n  removePlace (_id: $shapeId) {\n    _id\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["RemovePlace"] = oneQuery(doc, "RemovePlace");
        


/***/ }),

/***/ "rzhv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s6ZO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sBiC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uKc5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vq0I":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Geofences"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchGeofences"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"geometry"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vehicles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plate"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":116}};
    doc.loc.source = {"body":"query Geofences {\n  fetchGeofences {\n    _id\n    geometry\n    name\n    vehicles {\n      _id\n      plate\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["Geofences"] = oneQuery(doc, "Geofences");
        


/***/ }),

/***/ "vqlZ":
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchGuests"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchGuests"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vehicles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plate"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"username"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":131}};
    doc.loc.source = {"body":"query FetchGuests {\n  fetchGuests {\n    _id\n    vehicles {\n      _id\n      plate\n    }\n    name\n    username\n    permissions\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["FetchGuests"] = oneQuery(doc, "FetchGuests");
        


/***/ }),

/***/ "zSdZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.a086264876b5aab72302.js